
  var EFFN_CONFIG = window.EFFN_THEME_CONFIG || {};
  function effnCfg(key, fallback) {
    var value = EFFN_CONFIG[key];
    return value === undefined || value === null || value === '' ? fallback : value;
  }
  function effnBrandShort() {
    return effnCfg('brandShortName', effnCfg('brandName', 'EFFN'));
  }
  function effnDriveName() {
    return effnCfg('brandDriveName', effnBrandShort());
  }
  function effnEscapeAttr(text) {
    return String(text || '').replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;' })[c];
    });
  }
  function renderProductVisual(product, className) {
    if (product && product.image) {
      return '<img class="' + (className || 'product-image') + '" src="' + effnEscapeAttr(product.image) + '" alt="' + effnEscapeAttr(product.name || '') + '">';
    }
    return effnEscapeAttr(product && product.emoji ? product.emoji : effnBrandShort());
  }

  // Define start-menu toggle FIRST so the inline onclick can always find it,
  // even if a later script error prevents the rest of the file from running.
  window.toggleStartMenu = function (e) {
    if (e) e.stopPropagation();
    var btn  = document.getElementById('start-btn');
    var menu = document.getElementById('start-menu');
    if (!btn || !menu) {  return; }
    var wasOpen = menu.classList.contains('open');
    if (wasOpen) {
      menu.classList.remove('open');
      btn.classList.remove('open');
    } else {
      menu.classList.add('open');
      btn.classList.add('open');
    }
  };

  // Start-menu route handlers — defined globally so inline onclick on each
  // <li> item works regardless of any IIFE issues. Each closes the menu first.
  function closeStartMenu() {
    var menu = document.getElementById('start-menu');
    var btn  = document.getElementById('start-btn');
    if (menu) menu.classList.remove('open');
    if (btn)  btn.classList.remove('open');
  }
  window.startMenuRoute = function (key, e) {
    if (e) e.stopPropagation();
    closeStartMenu();
    var diag = function (label, err) { return; };
    try {
      switch (key) {
        case 'shop-all':
          if (typeof openCollection !== 'function') return diag('openCollection is not defined');
          openCollection('all');
          break;
        case 'tops':
          if (typeof openCollection !== 'function') return diag('openCollection is not defined');
          openCollection('tees');
          break;
        case 'bottoms':
        case 'accessories':
          if (typeof popupShell !== 'function') return diag('popupShell is not defined');
          var stub = popupShell(key === 'bottoms' ? 'Bottoms' : 'Accessories', 320);
          stub.style.left = '50%'; stub.style.top = '40%';
          stub.style.transform = 'translate(-50%, -50%)';
          stub.innerHTML +=
            '<div class="window-body" style="padding:16px;font-size:12px;line-height:1.5;">' +
              'No drops in this category yet.<br>Check back soon.' +
            '</div>' +
            '<div style="text-align:right;padding:0 14px 14px;">' +
              '<button data-action="close" style="min-width:72px;padding:5px 14px;font-size:11px;">OK</button>' +
            '</div>';
          document.getElementById('scene-desktop').appendChild(stub);
          if (typeof makeDraggable === 'function') makeDraggable(stub);
          if (typeof bringToFront === 'function') bringToFront(stub);
          if (typeof wirePopupClose === 'function') wirePopupClose(stub);
          break;
        case 'help':
          if (typeof openSupportChat !== 'function') return diag('openSupportChat is not defined — script may have errored before defining it.');
          openSupportChat();
          break;
        case 'bg':
          if (typeof openDisplayProperties !== 'function') return diag('openDisplayProperties is not defined — script may have errored before defining it.');
          openDisplayProperties();
          break;
        default:
          diag('Unknown menu key: ' + key);
      }
    } catch (err) {
      diag('Route ' + key + ' threw an error', err);
    }
  };

  // Restore any persisted desktop background early so it applies on first paint
  (function () {
    try {
      var saved = localStorage.getItem('effn_bg');
      var savedImage = localStorage.getItem('effn_bg_image');
      if (saved) document.documentElement.style.setProperty('--effn-bg', saved);
      if (savedImage) document.documentElement.style.setProperty('--effn-bg-image', savedImage);
    } catch (e) {}
  })();

  // ============ SCENE ROUTER ============
  function goTo(name) {
    cancelLoginAnim(); // any pending login timers stop when leaving
    document.querySelectorAll('.scene').forEach(s => s.classList.remove('active'));
    document.getElementById('scene-' + name).classList.add('active');
    /* Preview bar removed in Shopify port. */
    // hide taskbar in boot and login
    var tb = document.getElementById('taskbar');
    if (name === 'boot' || name === 'login') {
      tb.classList.add('hidden');
    } else {
      tb.classList.remove('hidden');
    }
    if (name === 'boot') runBoot();
    if (name === 'login') runLogin();
    if (name === 'desktop') { scheduleSubscribePopup(); scheduleDealPopup(); }
    window.scrollTo(0, 0);
  }
  window.goTo = goTo;
  window.EFFNEnterStore = function (e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    try {
      localStorage.setItem('effn_mode', 'win98');
      sessionStorage.setItem('effn_seen_login', '1');
    } catch (err) {}
    goTo('desktop');
    return false;
  };
  /* Preview bar controls removed in Shopify port. */

  // ============ BOOT ============
  function runBoot() {
    if (effnCfg('bootEnabled', true) === false) {
      goTo('login');
      return;
    }
    var driveLabel = String(effnDriveName()).toUpperCase().replace(/\s+/g, '_');
    var year = String(new Date().getFullYear());
    var copyright = effnCfg('bootCopyright', '2024 EFFN ON TOP');
    function tokenize(s) {
      return String(s || '')
        /* Both [token] and {token} forms supported for back-compat. */
        .replace(/\[brand\]|\{brand\}/g, effnBrandShort())
        .replace(/\[drive\]|\{drive\}/g, driveLabel)
        .replace(/\[copyright\]|\{copyright\}/g, copyright)
        .replace(/\[year\]|\{year\}/g, year);
    }
    var customLines = String(effnCfg('bootLines', '') || '').split(/\r?\n/).map(tokenize);
    var headerLine = tokenize(effnCfg('bootHeaderLine', '') || (effnBrandShort() + ' BIOS v1.04 - (c) ' + copyright));
    var lines = (headerLine ? [headerLine, ''] : [])
      .concat(customLines.length ? customLines : [
        'CPU: AUTHENTICATED ........... [OK]',
        'Memory Test: 65,536 KB ....... [OK]',
        'Detecting drives ............. [OK]',
        'HDD0: ' + driveLabel + '_ARCHIVE',
        'HDD1: CURRENT_DROP',
        'CDROM: not present',
        '',
        'Loading retail interface .....'
      ], ['']);
    var lineDelay = Math.max(40, Math.min(320, Number(effnCfg('bootLineDelay', 180)) || 180));
    var out = document.getElementById('boot-output');
    out.innerHTML = '';
    var i = 0;
    function next() {
      if (i >= lines.length) {
        var c = document.createElement('span');
        c.className = 'boot-cursor';
        out.appendChild(c);
        setTimeout(() => goTo('login'), 800);
        return;
      }
      var p = document.createElement('p');
      p.className = 'boot-line';
      p.textContent = lines[i] || '\u00A0';
      out.appendChild(p);
      i++;
      setTimeout(next, lineDelay + Math.random() * Math.min(120, lineDelay));
    }
    next();
  }

  // ============ LOGIN — typed credentials, reveal, bounce ============
  var loginTimers = [];
  function cancelLoginAnim() {
    loginTimers.forEach(t => clearTimeout(t));
    loginTimers = [];
    // reset state
    var u = document.getElementById('lu');
    var p = document.getElementById('lp');
    var btn = document.getElementById('enter-btn');
    if (u) { u.value = ''; u.classList.remove('typing'); }
    if (p) { p.value = ''; p.type = 'password'; p.classList.remove('typing', 'pass-revealed'); }
    if (btn) btn.classList.remove('bouncing');
  }
  function typeInto(el, text, perChar, onDone) {
    var i = 0;
    el.classList.add('typing');
    function step() {
      if (i >= text.length) {
        el.classList.remove('typing');
        if (onDone) onDone();
        return;
      }
      el.value += text.charAt(i);
      i++;
      // small jitter feels more human
      var delay = perChar + (Math.random() * 60 - 30);
      loginTimers.push(setTimeout(step, delay));
    }
    step();
  }
  function runLogin() {
    cancelLoginAnim(); // start fresh every visit
    var u = document.getElementById('lu');
    var p = document.getElementById('lp');
    var btn = document.getElementById('enter-btn');
    if (!u || !p || !btn) return;
    btn.type = 'button';
    btn.onclick = window.EFFNEnterStore;
    if (effnCfg('loginAnimationEnabled', true) === false) {
      u.value = effnCfg('loginUser', 'EffnFamily');
      p.value = effnCfg('loginPassword', 'EFFNONTOP2026');
      btn.classList.add('bouncing');
      return;
    }
    var typingSpeed = Math.max(40, Math.min(180, Number(effnCfg('loginTypingSpeed', 100)) || 100));

    // small pause before typing starts — lets the screen settle
    loginTimers.push(setTimeout(function () {
      typeInto(u, effnCfg('loginUser', 'EffnFamily'), typingSpeed + 10, function () {
        // pause between fields
        loginTimers.push(setTimeout(function () {
          typeInto(p, effnCfg('loginPassword', 'EFFNONTOP2026'), typingSpeed, function () {
            // hold dots, then reveal for 500ms, then re-mask
            loginTimers.push(setTimeout(function () {
              p.type = 'text';
              p.classList.add('pass-revealed');
              loginTimers.push(setTimeout(function () {
                p.type = 'password';
                p.classList.remove('pass-revealed');
                // start bouncing the Enter button
                btn.classList.add('bouncing');
              }, 600));
            }, 250));
          });
        }, 280));
      });
    }, 350));
  }

  // ============ DESKTOP — collection windows ============
  // Catalog of products per collection (placeholder data — wires to real Shopify products later)
  var COLLECTIONS = {
    tees: {
      title: 'Tees',
      items: [
        { name: 'Tour Tee — Black', price: '$80.00', emoji: '👕' },
        { name: 'Pocket Tee — Bone', price: '$70.00', emoji: '👕' },
        { name: 'SS24 Tee', price: '$70.00', emoji: '👕' },
        { name: 'Logo Tee — White', price: '$65.00', emoji: '👕' },
        { name: 'Box Tee — Olive', price: '$75.00', emoji: '👕' },
        { name: 'Long Sleeve — Black', price: '$90.00', emoji: '👕' }
      ]
    },
    hoodies: {
      title: 'Hoodies',
      items: [
        { name: 'Heavy Hoodie — Black', price: '$180.00', emoji: '🧥' },
        { name: 'Zip Hoodie — Bone', price: '$200.00', emoji: '🧥' },
        { name: 'Logo Hoodie — Grey', price: '$160.00', emoji: '🧥' },
        { name: 'Crew — Olive', price: '$140.00', emoji: '🧥' }
      ]
    },
    hats: {
      title: 'Hats',
      items: [
        { name: 'Logo Cap — Bone', price: '$50.00', emoji: '🧢' },
        { name: 'Trucker — Black', price: '$55.00', emoji: '🧢' },
        { name: '5-Panel — Olive', price: '$60.00', emoji: '🧢' },
        { name: 'Beanie — Black', price: '$45.00', emoji: '🧢' },
        { name: 'Bucket — Bone', price: '$65.00', emoji: '🧢' }
      ]
    },
    bottoms: {
      title: 'Bottoms',
      items: [
        { name: 'Big Boy Pants — Black', price: '$140.00', emoji: '👖' },
        { name: 'Cargo Pants — Olive', price: '$160.00', emoji: '👖' },
        { name: 'Sweatpants — Bone', price: '$120.00', emoji: '👖' },
        { name: 'Shorts — Black', price: '$90.00', emoji: '🩳' }
      ]
    },
    all: {
      title: 'Shop All',
      items: [
        { name: 'Tour Tee — Black', price: '$80.00', emoji: '👕' },
        { name: 'Heavy Hoodie — Black', price: '$180.00', emoji: '🧥' },
        { name: 'Logo Cap — Bone', price: '$50.00', emoji: '🧢' },
        { name: 'Pocket Tee — Bone', price: '$70.00', emoji: '👕' },
        { name: 'Trucker — Black', price: '$55.00', emoji: '🧢' },
        { name: 'Zip Hoodie — Bone', price: '$200.00', emoji: '🧥' },
        { name: 'Beanie — Black', price: '$45.00', emoji: '🧢' },
        { name: 'Box Tee — Olive', price: '$75.00', emoji: '👕' }
      ]
    }
  };

  // Open windows tracked by collection key — clicking the icon again brings existing window to front
  var openWindows = {};
  var topZ = 100;
  var cascadeOffset = 0;
  var cascadeDirection = 1; // +1 = down-right, -1 = up-left. Flips on viewport edge hit.

  /* Centralized window placement.
     - Cascades each new window by `step` so titles stay visible.
     - Reverses cascade direction when the next position would push
       the window off the viewport, so we walk back the other way.
     - Always clamps the final position so the window fits fully on
       screen with a small margin from edges and the taskbar.
     - On narrow viewports (≤640px), shrinks the window to the
       available area when it would otherwise overflow. */
  function effnPlaceWindow(win, opts) {
    opts = opts || {};
    var baseX = opts.baseX != null ? opts.baseX : 80;
    var baseY = opts.baseY != null ? opts.baseY : 60;
    var step  = opts.step  != null ? opts.step  : 28;
    var margin = 8;

    var taskbarH = 36;
    var vw = (window.innerWidth  || document.documentElement.clientWidth)  || 393;
    var vh = (window.innerHeight || document.documentElement.clientHeight) || 852;
    var availH = vh - taskbarH - margin;

    /* Pre-size: if a desired width/height was specified or the window
       is wider than the viewport, clamp it so it fits. Without this
       step, the cascade math doesn't know the final size. */
    var ww = win.offsetWidth || parseInt(win.style.width, 10) || 0;
    var wh = win.offsetHeight || 0;
    if (opts.width)  win.style.width  = Math.min(opts.width,  vw - margin * 2) + 'px';
    if (opts.height) win.style.height = Math.min(opts.height, availH) + 'px';

    /* Only force-fit width when the window is actually too wide for
       the viewport. Previously this also force-fit on narrow viewports
       (vw ≤ 640) which killed horizontal cascade room. */
    if (ww > vw - margin * 2) {
      win.style.width  = (vw - margin * 2) + 'px';
    }

    /* Recompute size after sizing decisions. */
    ww = win.offsetWidth  || parseInt(win.style.width, 10)  || 320;
    wh = win.offsetHeight || parseInt(win.style.height, 10) || 240;

    /* Cascade position. Direction flips when the next step would
       collide with a viewport edge. */
    var x = baseX + cascadeOffset * step * cascadeDirection;
    var y = baseY + cascadeOffset * step;

    /* Predict next position; if it overflows, flip direction now. */
    var nextX = x + step * cascadeDirection;
    if (nextX + ww > vw - margin || nextX < margin) {
      cascadeDirection *= -1;
    }
    cascadeOffset = (cascadeOffset + 1) % 8;

    /* Final clamp: ensure the window is fully visible. */
    x = Math.max(margin, Math.min(x, vw - ww - margin));
    y = Math.max(margin, Math.min(y, availH - wh));

    win.style.left = x + 'px';
    win.style.top  = y + 'px';

    /* Some callers run this helper BEFORE the window is appended to the
       DOM, so offsetHeight is 0 at this point. Re-clamp on the next
       frame once layout settles, to guarantee the window is fully
       on-screen regardless of when the caller wired things up. */
    requestAnimationFrame(function () {
      if (!win.isConnected) return;
      var rect = win.getBoundingClientRect();
      var vw2 = (window.innerWidth  || document.documentElement.clientWidth)  || 393;
      var vh2 = (window.innerHeight || document.documentElement.clientHeight) || 852;
      var availH2 = vh2 - taskbarH - margin;
      /* If too tall for the available area, force-fit the height. */
      if (rect.height > availH2) {
        win.style.height = availH2 + 'px';
        rect = win.getBoundingClientRect();
      }
      /* If too wide for the viewport, force-fit the width. */
      if (rect.width > vw2 - margin * 2) {
        win.style.width = (vw2 - margin * 2) + 'px';
        rect = win.getBoundingClientRect();
      }
      var nx = parseInt(win.style.left, 10) || 0;
      var ny = parseInt(win.style.top,  10) || 0;
      nx = Math.max(margin, Math.min(nx, vw2 - rect.width  - margin));
      ny = Math.max(margin, Math.min(ny, availH2 - rect.height));
      win.style.left = nx + 'px';
      win.style.top  = ny + 'px';
    });
  }

  // ============ TASKBAR TABS + MAXIMIZE (universal) ============
  var taskbarItemsEl = document.querySelector('.taskbar-items');
  var taskbarTabReg  = new Map(); // win -> tab element

  function addTaskbarTab(win, label) {
    if (!taskbarItemsEl || taskbarTabReg.has(win)) return;
    var tab = document.createElement('button');
    tab.type = 'button';
    tab.className = 'taskbar-tab';
    var lbl = document.createElement('span');
    lbl.className = 'taskbar-tab-label';
    lbl.textContent = label || 'Window';
    tab.appendChild(lbl);
    tab.addEventListener('click', function (e) {
      e.stopPropagation();
      win.classList.remove('minimized');
      if (win.classList.contains('draggable')) bringToFront(win);
      removeTaskbarTab(win);
    });
    taskbarItemsEl.appendChild(tab);
    taskbarTabReg.set(win, tab);
  }
  function removeTaskbarTab(win) {
    var t = taskbarTabReg.get(win);
    if (t) { t.remove(); taskbarTabReg.delete(win); }
  }
  function toggleMaximize(win) { win.classList.toggle('maximized'); }

  // Attach taskbar + maximize behavior to a window's chrome buttons.
  // Existing per-window min/close handlers still run; this layers on top.
  function wireWindowChrome(win, label) {
    var minBtn   = win.querySelector('[data-action="min"], [data-music="min"], [aria-label="Minimize"]');
    var maxBtn   = win.querySelector('[aria-label="Maximize"]');
    var closeBtn = win.querySelector('[data-action="close"], [data-music="close"], [aria-label="Close"]');
    if (minBtn) {
      minBtn.addEventListener('click', function () {
        // Existing handler toggles .minimized; check resulting state next tick
        setTimeout(function () {
          if (win.classList.contains('minimized')) addTaskbarTab(win, label);
          else removeTaskbarTab(win);
        }, 0);
      });
    }
    if (maxBtn) {
      maxBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleMaximize(win);
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        // Existing handler removes the window; we just clean up its tab
        setTimeout(function () { removeTaskbarTab(win); }, 0);
      });
    }
  }

  function bringToFront(win) {
    document.querySelectorAll('.draggable.active').forEach(w => w.classList.remove('active'));
    topZ += 1;
    win.style.zIndex = topZ;
    win.classList.add('active');
  }

  function makeDraggable(win) {
    var bar = win.querySelector('.title-bar');
    if (!bar) return;
    var dragging = false, ox = 0, oy = 0;

    bar.addEventListener('mousedown', e => {
      if (e.target.closest('.title-bar-controls')) return;
      bringToFront(win);
      dragging = true;
      var r = win.getBoundingClientRect();
      // Pointer offset within the window itself
      ox = e.clientX - r.left;
      oy = e.clientY - r.top;
      e.preventDefault();
    });
    document.addEventListener('mousemove', e => {
      if (!dragging) return;
      // Convert viewport coords -> coords relative to the window's containing block
      var parent = win.offsetParent || document.body;
      var parentRect = parent.getBoundingClientRect();
      var x = e.clientX - parentRect.left - ox;
      var y = e.clientY - parentRect.top - oy;
      // Clamp to keep the window mostly on-screen
      var maxX = parent.clientWidth - 100;
      var maxY = parent.clientHeight - 30;
      x = Math.max(0, Math.min(x, maxX));
      y = Math.max(0, Math.min(y, maxY));
      win.style.left = x + 'px';
      win.style.top = y + 'px';
    });
    document.addEventListener('mouseup', () => { dragging = false; });
    win.addEventListener('mousedown', () => bringToFront(win));
  }

  function openCollection(key) {
    // Already open? Bring to front
    if (openWindows[key]) {
      var existing = openWindows[key];
      existing.classList.remove('minimized');
      bringToFront(existing);
      return;
    }

    var coll = COLLECTIONS[key];
    if (!coll) return;

    var win = document.createElement('div');
    win.className = 'window draggable';
    win.dataset.collectionKey = key;

    // Cascade position so windows stack visibly
    var baseX = 80;
    var baseY = 60;
    var step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    // Build product grid HTML — each tile embeds product data for drag-to-cart
    var gridHtml = coll.items.map((p, idx) =>
      '<a class="product-tile" data-product-link ' +
         'data-product-index="' + idx + '" ' +
         'data-product-name="' + effnEscapeAttr(p.name || 'Product') + '" ' +
         'data-product-price="' + effnEscapeAttr(cleanMoney(p.price || '')) + '" ' +
         'data-product-emoji="' + effnEscapeAttr(p.emoji || effnBrandShort()) + '" ' +
         'draggable="false">' +
        '<div class="ph">' + renderProductVisual(p) + '</div>' +
        '<p class="product-tile-name">' + effnEscapeAttr(p.name || 'Product') + '</p>' +
        '<p class="product-tile-price">' + effnEscapeAttr(cleanMoney(p.price || '')) + '</p>' +
      '</a>'
    ).join('');

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">' + coll.title + (((window.innerWidth || document.documentElement.clientWidth) <= 640) ? '' : ' — Drag item to shopping bag') + '</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="collection-toolbar">' +
        '<button onclick="event.stopPropagation();">←</button>' +
        '<button onclick="event.stopPropagation();">→</button>' +
        '<span class="breadcrumb">C:\\' + String(effnDriveName()).toUpperCase().replace(/\s+/g, '_') + '\\' + coll.title.toUpperCase() + '</span>' +
      '</div>' +
      '<div class="window-body collection-window-body">' +
        '<div class="product-grid">' + gridHtml + '</div>' +
      '</div>' +
      '<div class="collection-statusbar">' +
        '<span>' + coll.items.length + ' object(s)</span>' +
        '<span>' + Math.floor(coll.items.length * 1.4) + ' KB</span>' +
      '</div>';

    document.getElementById('scene-desktop').appendChild(win);
    openWindows[key] = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, coll.title);
    // Mark the desktop icon as "open" so its visual flips (e.g. Shop All folder)
    var iconEl = document.querySelector('.icon[data-collection="' + key + '"]');
    if (iconEl) iconEl.classList.add('is-open');

    // Wire window controls
    win.querySelector('[data-action="close"]').addEventListener('click', e => {
      e.stopPropagation();
      win.remove();
      delete openWindows[key];
      var iconEl2 = document.querySelector('.icon[data-collection="' + key + '"]');
      if (iconEl2) iconEl2.classList.remove('is-open');
    });
    win.querySelector('[data-action="min"]').addEventListener('click', e => {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });

    // Wire each product tile: click previews, drag drops into the shopping bag.
    win.querySelectorAll('[data-product-link]').forEach(tile => {
      tile.__effnProduct = coll.items[Number(tile.dataset.productIndex)] || null;
      wireProductTile(tile);
    });
  }

  // Trash window — empty for now, just shows the chrome
  var trashWindow = null;
  function openTrash() {
    if (trashWindow) {
      trashWindow.classList.remove('minimized');
      bringToFront(trashWindow);
      return;
    }

    var win = document.createElement('div');
    win.className = 'window draggable';
    win.style.width = '420px';

    var baseX = 80;
    var baseY = 60;
    var step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">Recycle Bin</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="collection-toolbar">' +
        '<button>←</button>' +
        '<button>→</button>' +
        '<span class="breadcrumb">C:\\RECYCLED</span>' +
      '</div>' +
      '<div class="window-body collection-window-body" data-trash-body style="min-height: 160px;">' +
      '</div>' +
      '<div class="collection-statusbar">' +
        '<span data-trash-count>0 object(s)</span>' +
        '<span data-trash-bytes>0 bytes</span>' +
      '</div>';

    document.getElementById('scene-desktop').appendChild(win);
    trashWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, 'Recycle Bin');

    renderTrashContents();

    win.querySelector('[data-action="close"]').addEventListener('click', e => {
      e.stopPropagation();
      win.remove();
      trashWindow = null;
    });
    win.querySelector('[data-action="min"]').addEventListener('click', e => {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });
  }

  function renderTrashContents() {
    if (!trashWindow) return;
    var body  = trashWindow.querySelector('[data-trash-body]');
    var count = trashWindow.querySelector('[data-trash-count]');
    var bytes = trashWindow.querySelector('[data-trash-bytes]');
    var items = [];
    if (notepadDeleted) items.push('notepad');
    if (wmoDeleted) items.push('wmo');

    if (items.length === 0) {
      body.style.cssText = 'min-height:160px;display:flex;align-items:center;justify-content:center;color:var(--effn-window-darker);font-style:italic;';
      body.innerHTML = 'This folder is empty.';
      count.textContent = '0 object(s)';
      bytes.textContent = '0 bytes';
      return;
    }

    body.style.cssText = 'min-height:160px;';
    var html = '<div class="trash-file-list">';
    if (notepadDeleted) {
      html +=
        '<div class="trash-file" data-trash-file="notepad" tabindex="0">' +
          '<svg class="tf-icon" viewBox="0 0 48 48" aria-hidden="true">' +
            '<rect x="9" y="14" width="30" height="30" fill="rgba(0,0,0,0.25)"/>' +
            '<rect x="7" y="12" width="30" height="30" fill="#f5e88a" stroke="#000" stroke-width="1.5"/>' +
            '<rect x="8" y="13" width="28" height="2" fill="#fff7c2"/>' +
            '<line x1="13" y1="17" x2="13" y2="40" stroke="#c81c1c" stroke-width="0.7"/>' +
            '<g stroke="#6e7e94" stroke-width="0.7">' +
              '<line x1="9" y1="22" x2="35" y2="22"/>' +
              '<line x1="9" y1="27" x2="35" y2="27"/>' +
              '<line x1="9" y1="32" x2="35" y2="32"/>' +
              '<line x1="9" y1="37" x2="35" y2="37"/>' +
            '</g>' +
            '<rect x="5" y="7" width="34" height="6" fill="#4a5a72" stroke="#000" stroke-width="1"/>' +
            '<rect x="5" y="7" width="34" height="2" fill="#6a7a92"/>' +
            '<g fill="#1a2433">' +
              '<rect x="9"  y="9" width="3" height="2"/>' +
              '<rect x="14" y="9" width="3" height="2"/>' +
              '<rect x="19" y="9" width="3" height="2"/>' +
              '<rect x="24" y="9" width="3" height="2"/>' +
              '<rect x="29" y="9" width="3" height="2"/>' +
            '</g>' +
          '</svg>' +
          '<div class="tf-name">SUGGEST.TXT</div>' +
        '</div>';
    }
    if (wmoDeleted) {
      html +=
        '<div class="trash-file" data-trash-file="wmo" tabindex="0">' +
          '<svg class="tf-icon" viewBox="0 0 48 48" aria-hidden="true">' +
            '<rect x="6" y="10" width="36" height="28" fill="#000" stroke="#000" stroke-width="1.5"/>' +
            '<rect x="8" y="12" width="32" height="24" fill="#1a3550"/>' +
            '<text x="24" y="28" text-anchor="middle" font-family="Arial Black, Arial, sans-serif" font-weight="900" font-size="9" fill="#fff">WMO</text>' +
            '<rect x="14" y="40" width="20" height="3" fill="#202020" stroke="#000" stroke-width="0.6"/>' +
          '</svg>' +
          '<div class="tf-name">WMO.LNK</div>' +
        '</div>';
    }
    html += '</div>';
    body.innerHTML = html;
    count.textContent = items.length + ' object(s)';
    bytes.textContent = (items.length * 2) + ' KB';

    // Selection + double-click to restore
    body.querySelectorAll('.trash-file').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        body.querySelectorAll('.trash-file.selected').forEach(function (s) { s.classList.remove('selected'); });
        el.classList.add('selected');
      });
      el.addEventListener('dblclick', function (e) {
        e.stopPropagation();
        if (el.dataset.trashFile === 'notepad') restoreNotepad();
        if (el.dataset.trashFile === 'wmo')     restoreWMO();
      });
    });
  }

  // ============ CART SYSTEM ============
  // Cart state — items: [{name, price, emoji, size, qty}]
  var cart = [];
  var cartWindow = null;

  // Sizes per category — picked based on product type from name
  function sizesForProduct(name) {
    var n = name.toLowerCase();
    if (n.indexOf('hat') !== -1 || n.indexOf('cap') !== -1 || n.indexOf('beanie') !== -1 || n.indexOf('bucket') !== -1 || n.indexOf('trucker') !== -1 || n.indexOf('5-panel') !== -1) {
      return ['One size'];
    }
    return ['S', 'M', 'L', 'XL'];
  }

  function priceToNumber(priceStr) {
    return parseFloat(String(priceStr).replace(/[^0-9.]/g, '')) || 0;
  }

  function updateCartBadge() {
    var badge = document.querySelector('[data-cart-badge]');
    if (!badge) return;
    var totalQty = cart.reduce((s, it) => s + it.qty, 0);
    if (totalQty > 0) {
      badge.textContent = totalQty;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  }

  function bumpCart() {
    var iconEl = document.querySelector('.icon-cart');
    if (!iconEl) return;
    iconEl.classList.remove('bumping');
    void iconEl.offsetWidth; // restart animation
    iconEl.classList.add('bumping');
    setTimeout(() => iconEl.classList.remove('bumping'), 500);
  }

  // Pull cart from Shopify and project into local shape used by the renderer.
  function hydrateCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = (data.items || []).map(function (item) {
          return {
            key: item.key,
            variantId: item.variant_id,
            name: item.product_title || item.title,
            price: '$' + (Number(item.price || 0) / 100).toFixed(2).replace(/\.00$/, ''),
            emoji: '',
            image: item.image,
            size: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
            qty: item.quantity
          };
        });
        updateCartBadge();
        if (cartWindow) renderCartWindow();
      })
      .catch(function () {});
  }

  // Single source of truth for adding. `size` arg kept for back-compat with
  // existing call sites; ignored — Shopify returns variant_title on hydrate.
  function addToCart(product, size, qty) {
    qty = Math.max(1, parseInt(qty || 1, 10) || 1);
    if (!product || !product.variantId) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(product.variantId), quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return hydrateCart(); })
      .then(function () { bumpCart(); });
  }

  function removeFromCart(index) {
    var line = cart[index];
    if (!line) return;
    if (!line.key) {
      cart.splice(index, 1);
      updateCartBadge();
      if (cartWindow) renderCartWindow();
      return;
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    }).then(function () { return hydrateCart(); });
  }

  // Hydrate on load so badge + window reflect Shopify session from first paint.
  hydrateCart();
  // Expose for the product section's inline script.
  window.hydrateCart = hydrateCart;
  window.addToCart = addToCart;

  // ===== Custom drag ghost (replaces ugly browser default) =====
  var dragGhostEl = null;
  function startCustomDragGhost(e, product) {
    // Hide native ghost using a transparent 1×1 pixel image
    if (e && e.dataTransfer && e.dataTransfer.setDragImage) {
      var img = new Image();
      img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      e.dataTransfer.setDragImage(img, 0, 0);
    }
    endCustomDragGhost();
    dragGhostEl = document.createElement('div');
    dragGhostEl.className = 'drag-ghost';
    dragGhostEl.innerHTML = '<span class="drag-ghost-emoji">' + product.emoji + '</span><span>' + product.name + '</span>';
    document.body.appendChild(dragGhostEl);
    if (e) document.addEventListener('dragover', positionDragGhost);
  }
  function positionDragGhost(e) {
    if (!dragGhostEl) return;
    dragGhostEl.style.left = (e.clientX + 12) + 'px';
    dragGhostEl.style.top  = (e.clientY + 12) + 'px';
  }
  function endCustomDragGhost() {
    if (dragGhostEl) {
      dragGhostEl.remove();
      dragGhostEl = null;
    }
    document.removeEventListener('dragover', positionDragGhost);
  }

  function productFromTile(tile) {
    if (tile.__effnProduct) return Object.assign({}, tile.__effnProduct);
    return {
      name: tile.dataset.productName,
      price: tile.dataset.productPrice,
      emoji: tile.dataset.productEmoji || effnBrandShort()
    };
  }

  function cleanMoney(value) {
    var temp = document.createElement('div');
    temp.innerHTML = String(value || '');
    return (temp.textContent || temp.innerText || '').trim();
  }

  function productImages(product) {
    var images = Array.isArray(product.images) ? product.images.slice() : [];
    if (!images.length && product.image) {
      images.push({ src: product.image, thumb: product.image, alt: product.name || '' });
    }
    return images.filter(function (img) { return img && img.src; });
  }

  function imageHtml(src, alt, className) {
    return '<img class="' + (className || 'product-main-image') + '" src="' + effnEscapeAttr(src) + '" alt="' + effnEscapeAttr(alt || '') + '">';
  }

  function optionIsUseful(option) {
    if (!option || !Array.isArray(option.values)) return false;
    var values = option.values.filter(function (v) { return String(v || '').trim() !== ''; });
    if (!values.length) return false;
    if (values.length === 1 && String(values[0]).toLowerCase() === 'default title') return false;
    if (String(option.name || '').toLowerCase() === 'title' && values.length === 1) return false;
    return values.length > 1 || String(option.name || '').toLowerCase() !== 'title';
  }

  function isDefaultOnlyProduct(product) {
    var variants = product && product.variants || [];
    var options = product && product.options || [];
    if (!variants.length) return false;
    if (variants.length === 1 && String(variants[0].title || '').toLowerCase() === 'default title') return true;
    var usefulOptions = options.filter(optionIsUseful);
    return variants.length === 1 && usefulOptions.length === 0;
  }

  function findVariantForOptions(product, selectedOptions) {
    var variants = product.variants || [];
    if (!variants.length) return null;
    return variants.find(function (variant) {
      if (!Array.isArray(variant.options)) return false;
      return selectedOptions.every(function (value, index) {
        return !value || String(variant.options[index]) === String(value);
      });
    }) || variants.find(function (variant) { return variant.available; }) || variants[0] || null;
  }

  function getRelatedProducts(product) {
    var collectionKey = product.collectionKey;
    var items = collectionKey && COLLECTIONS[collectionKey] ? COLLECTIONS[collectionKey].items || [] : [];
    if (!items.length) {
      Object.keys(COLLECTIONS).some(function (key) {
        items = (COLLECTIONS[key] && COLLECTIONS[key].items || []).filter(function (item) {
          return item && item.name !== product.name;
        });
        return items.length > 0;
      });
    }
    return items.filter(function (item) {
      return item && item.name !== product.name;
    }).slice(0, 4);
  }

  function matchCatalogProduct(product) {
    var name = product && product.name;
    if (!name) return product;
    for (var key in COLLECTIONS) {
      var items = COLLECTIONS[key] && COLLECTIONS[key].items || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].name === name) return Object.assign({}, items[i], product);
      }
    }
    return product;
  }

  function renderProductDetails() {
    var detailWrap = document.querySelector('[data-product-details]');
    if (!detailWrap) return;
    var details = Array.isArray(window.EFFN_PRODUCT_DETAILS) ? window.EFFN_PRODUCT_DETAILS : [];
    details = details.filter(function (detail) {
      return detail && (detail.title || detail.body);
    });
    if (!details.length) {
      details = [
        { title: 'Materials', body: 'Add Product detail dropdown blocks in the theme editor.' },
        { title: 'Size chart', body: 'Use this dropdown for sizing, measurements, care, or shipping notes.' }
      ];
    }
    detailWrap.innerHTML = details.map(function (detail, index) {
      return '<details class="product-detail-item"' + (index === 0 ? ' open' : '') + '>' +
        '<summary>' + effnEscapeAttr(detail.title || 'Details') + '</summary>' +
        '<div class="product-detail-body">' + effnEscapeAttr(detail.body || '') + '</div>' +
      '</details>';
    }).join('');
  }

  function renderRelatedWindow(product) {
    var win = document.querySelector('[data-related-window]');
    var body = document.querySelector('[data-related-body]');
    if (!win || !body) return;
    var related = getRelatedProducts(product);
    if (!related.length) {
      win.style.display = 'none';
      body.innerHTML = '';
      return;
    }
    win.style.display = '';
    body.innerHTML =
      '<div class="related-grid">' +
        related.map(function (item, index) {
          return '<button type="button" class="related-card" data-related-index="' + index + '">' +
            '<div class="ph">' + renderProductVisual(item) + '</div>' +
            '<p class="related-name">' + effnEscapeAttr(item.name || 'Product') + '</p>' +
            '<p class="related-price">' + effnEscapeAttr(cleanMoney(item.price || '')) + '</p>' +
          '</button>';
        }).join('') +
      '</div>' +
      '<div class="bundle-panel">' +
        '<p class="bundle-title">Bundle & save</p>' +
        '<label class="bundle-option"><input type="checkbox" checked disabled> ' + effnEscapeAttr(product.name || 'Current product') + '</label>' +
        related.slice(0, 3).map(function (item, index) {
          return '<label class="bundle-option"><input type="checkbox" data-bundle-index="' + index + '"> ' +
            effnEscapeAttr(item.name || 'Product') + ' <span>(' + effnEscapeAttr(cleanMoney(item.price || '')) + ')</span></label>';
        }).join('') +
        '<button type="button" class="bundle-action" data-bundle-add>Add selected bundle</button>' +
      '</div>';

    body.querySelectorAll('[data-related-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openProduct(Object.assign({}, related[Number(btn.dataset.relatedIndex)]));
      });
    });
    var bundleBtn = body.querySelector('[data-bundle-add]');
    if (bundleBtn) {
      bundleBtn.addEventListener('click', function () {
        var products = [product].concat(Array.from(body.querySelectorAll('[data-bundle-index]:checked')).map(function (input) {
          return related[Number(input.dataset.bundleIndex)];
        }).filter(Boolean));
        var items = products.filter(function (item) { return item && item.variantId; }).map(function (item) {
          return { id: Number(item.variantId), quantity: 1 };
        });
        if (items.length) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () { return hydrateCart(); }).then(function () { bumpCart(); }).catch(function () {});
        }
      });
    }
  }

  function openProduct(product) {
    product = matchCatalogProduct(product || {});
    var title = document.querySelector('#scene-product .product-title');
    var price = document.querySelector('#scene-product .product-price');
    var media = document.getElementById('main-img');
    var thumbs = document.querySelector('[data-product-thumbs]');
    var desc = document.querySelector('#scene-product .product-desc');
    var optionsWrap = document.querySelector('[data-product-options]');
    var saleWrap = document.querySelector('[data-sale-badge]');
    var atc = document.querySelector('#scene-product .atc');
    var qty = document.getElementById('qty');
    var titleBar = document.querySelector('#scene-product .title-bar-text');
    var status = document.querySelector('#scene-product .product-statusbar');
    var images = productImages(product);
    var productVariants = product.variants || [];
    var selectedVariant = productVariants.find(function (variant) { return variant.available; }) || productVariants[0] || null;
    var selectedOptions = selectedVariant && Array.isArray(selectedVariant.options) ? selectedVariant.options.slice() : [];

    function updateProductPrice() {
      var displayPrice = selectedVariant && selectedVariant.price ? selectedVariant.price : product.price;
      var compareAt = selectedVariant && selectedVariant.compareAtPrice ? selectedVariant.compareAtPrice : product.compareAtPrice;
      var isSale = !!compareAt && cleanMoney(compareAt) !== cleanMoney(displayPrice);
      if (price) {
        price.innerHTML = isSale
          ? '<span class="was-price">' + effnEscapeAttr(cleanMoney(compareAt)) + '</span><span class="now-price">' + effnEscapeAttr(cleanMoney(displayPrice)) + '</span>'
          : '<span class="now-price">' + effnEscapeAttr(cleanMoney(displayPrice || '')) + '</span>';
      }
      if (saleWrap) {
        saleWrap.innerHTML = isSale ? '<div class="sale-warning">SALE WARNING</div>' : '';
      }
      if (selectedVariant && selectedVariant.id) product.variantId = selectedVariant.id;
      product.price = cleanMoney(displayPrice || product.price || '');
      if (status) {
        status.innerHTML =
          '<span>' + (product.variantId ? 'Variant: ' + effnEscapeAttr(product.variantId) : 'Product details') + '</span>' +
          '<span>' + (product.url ? '<a href="' + effnEscapeAttr(product.url) + '">Open Shopify product page</a>' : '') + '</span>';
      }
      if (atc) {
        atc.disabled = selectedVariant ? !selectedVariant.available : false;
        atc.textContent = selectedVariant && !selectedVariant.available ? 'Sold out' : 'Add to cart';
      }
    }

    function setMainImage(src, alt) {
      if (!media) return;
      if (src) media.innerHTML = imageHtml(src, alt || product.name, 'product-main-image');
      else media.innerHTML = renderProductVisual(product, 'product-main-image');
    }

    if (title) title.textContent = product.name || 'Product';
    if (titleBar) titleBar.textContent = (product.name || 'Product');
    setMainImage(images[0] && images[0].src, images[0] && images[0].alt);
    if (thumbs) {
      var extraImages = images.slice(1);
      thumbs.innerHTML = extraImages.map(function (image, index) {
        return '<button type="button" class="product-thumb" data-image-index="' + (index + 1) + '">' +
          imageHtml(image.thumb || image.src, image.alt || product.name, '') +
        '</button>';
      }).join('');
      thumbs.querySelectorAll('[data-image-index]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          thumbs.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
          btn.classList.add('active');
          var image = images[Number(btn.dataset.imageIndex)];
          setMainImage(image && image.src, image && image.alt);
        });
      });
    }
    if (optionsWrap) {
      var options = (product.options || []).map(function (option, index) {
        return { option: option, index: index };
      }).filter(function (entry) {
        return optionIsUseful(entry.option);
      });
      optionsWrap.innerHTML = options.map(function (entry) {
        var option = entry.option;
        var optionIndex = entry.index;
        var safeName = effnEscapeAttr(option.name || 'Option');
        if (!selectedOptions[optionIndex] && option.values && option.values.length) selectedOptions[optionIndex] = option.values[0];
        return '<div class="product-field" data-option-index="' + optionIndex + '">' +
          '<label>' + safeName + ': <span data-option-display="' + optionIndex + '">' + effnEscapeAttr(selectedOptions[optionIndex] || '') + '</span></label>' +
          '<div class="variants">' +
            option.values.map(function (value) {
              return '<button type="button" data-option-value="' + effnEscapeAttr(value) + '"' +
                (String(value) === String(selectedOptions[optionIndex]) ? ' class="selected"' : '') + '>' +
                effnEscapeAttr(value) +
              '</button>';
            }).join('') +
          '</div>' +
        '</div>';
      }).join('');
      optionsWrap.querySelectorAll('[data-option-index]').forEach(function (field) {
        var optionIndex = Number(field.dataset.optionIndex);
        field.querySelectorAll('[data-option-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            field.querySelectorAll('button').forEach(function (b) { b.classList.remove('selected'); });
            btn.classList.add('selected');
            selectedOptions[optionIndex] = btn.dataset.optionValue;
            var display = optionsWrap.querySelector('[data-option-display="' + optionIndex + '"]');
            if (display) display.textContent = btn.dataset.optionValue;
            selectedVariant = findVariantForOptions(product, selectedOptions);
            updateProductPrice();
          });
        });
      });
    }
    updateProductPrice();
    if (desc) {
      var body = product.description || 'Drag this item to the shopping bag, or choose a size here.';
      desc.innerHTML = '<p style="margin:0;">' + effnEscapeAttr(body) + '</p>';
    }
    renderProductDetails();
    renderRelatedWindow(product);
    if (qty) qty.value = 1;
    if (atc) {
      atc.onclick = function () {
        var amount = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
        var label = selectedVariant && selectedVariant.title && selectedVariant.title !== 'Default Title' ? selectedVariant.title : 'Default';
        addToCart(product, label, amount);
      };
    }
    goTo('product');
  }

  function setCartDropTarget(active) {
    var cartEl = document.querySelector('.icon-cart');
    if (cartEl) cartEl.classList.toggle('drop-target', !!active);
  }

  function isPointOverCart(x, y) {
    var cartEl = document.querySelector('.icon-cart');
    if (!cartEl) return false;
    var r = cartEl.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  function wireProductTile(tile) {
    var suppressClick = false;
    tile.setAttribute('draggable', 'false');

    tile.addEventListener('dragstart', function (e) {
      // Native HTML5 drag is unreliable in Shopify preview iframes.
      e.preventDefault();
    });

    tile.addEventListener('click', function (e) {
      e.stopPropagation();
      if (suppressClick) {
        e.preventDefault();
        suppressClick = false;
        return;
      }
      var product = productFromTile(tile);
      /* On mobile, jump directly to the Shopify product page so customers
         can ATC there. Desktop keeps the in-page Win98 preview window. */
      var isMobileViewport = (window.innerWidth || document.documentElement.clientWidth) <= 640;
      if (isMobileViewport && product && product.url) {
        window.location.href = product.url;
        return;
      }
      openProduct(product);
    });

    /* Mobile (≤640px): skip drag-to-cart entirely so vertical scroll
       inside the collection window works. Customers add to cart via the
       product page only. Desktop keeps the drag-and-drop interaction. */
    var isMobileViewport = (window.innerWidth || document.documentElement.clientWidth) <= 640;
    if (isMobileViewport) return;

    tile.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      var product = productFromTile(tile);
      var startX = e.clientX;
      var startY = e.clientY;
      var pointerId = e.pointerId;
      var dragging = false;

      function startDrag(moveEvent) {
        dragging = true;
        suppressClick = true;
        tile.classList.add('dragging');
        startCustomDragGhost(null, product);
        positionDragGhost(moveEvent);
        setCartDropTarget(isPointOverCart(moveEvent.clientX, moveEvent.clientY));
      }

      function move(moveEvent) {
        if (moveEvent.pointerId !== pointerId) return;
        var dx = moveEvent.clientX - startX;
        var dy = moveEvent.clientY - startY;
        if (!dragging && Math.sqrt(dx * dx + dy * dy) > 6) startDrag(moveEvent);
        if (!dragging) return;
        moveEvent.preventDefault();
        positionDragGhost(moveEvent);
        setCartDropTarget(isPointOverCart(moveEvent.clientX, moveEvent.clientY));
      }

      function finish(upEvent) {
        if (upEvent.pointerId !== pointerId) return;
        document.removeEventListener('pointermove', move);
        document.removeEventListener('pointerup', finish);
        document.removeEventListener('pointercancel', cancel);
        if (!dragging) return;
        upEvent.preventDefault();
        tile.classList.remove('dragging');
        endCustomDragGhost();
        var droppedOnCart = isPointOverCart(upEvent.clientX, upEvent.clientY);
        setCartDropTarget(false);
        if (droppedOnCart) openSizeDialog(product);
      }

      function cancel(cancelEvent) {
        if (cancelEvent.pointerId !== pointerId) return;
        document.removeEventListener('pointermove', move);
        document.removeEventListener('pointerup', finish);
        document.removeEventListener('pointercancel', cancel);
        tile.classList.remove('dragging');
        endCustomDragGhost();
        setCartDropTarget(false);
      }

      document.addEventListener('pointermove', move, { passive: false });
      document.addEventListener('pointerup', finish, { passive: false });
      document.addEventListener('pointercancel', cancel);
    });
  }

  // ===== Wire cart icon as drop target =====
  function wireCartDropTarget() {
    var cartEl = document.querySelector('.icon-cart');
    if (!cartEl) return;

    cartEl.addEventListener('dragover', e => {
      // Must preventDefault to allow drop
      if (e.dataTransfer.types.indexOf('application/effn-product') !== -1) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
        cartEl.classList.add('drop-target');
      }
    });
    cartEl.addEventListener('dragenter', e => {
      if (e.dataTransfer.types.indexOf('application/effn-product') !== -1) {
        e.preventDefault();
        cartEl.classList.add('drop-target');
      }
    });
    cartEl.addEventListener('dragleave', e => {
      // Only clear if we're actually leaving the cart, not a child
      if (!cartEl.contains(e.relatedTarget)) {
        cartEl.classList.remove('drop-target');
      }
    });
    cartEl.addEventListener('drop', e => {
      e.preventDefault();
      cartEl.classList.remove('drop-target');
      var raw = e.dataTransfer.getData('application/effn-product');
      if (!raw) return;
      try {
        var product = JSON.parse(raw);
        openSizeDialog(product);
      } catch (err) { /* malformed payload, ignore */ }
    });
  }

  // ===== Size picker dialog =====
  function openSizeDialog(product) {
    var sizes = sizesForProduct(product.name);
    var selectedSize = sizes.length === 1 ? sizes[0] : null;

    var overlay = document.createElement('div');
    overlay.className = 'size-dialog-overlay';
    overlay.innerHTML =
      '<div class="window size-dialog">' +
        '<div class="title-bar">' +
          '<div class="title-bar-text">Add to cart</div>' +
          '<div class="title-bar-controls">' +
            '<button aria-label="Close" data-cancel></button>' +
          '</div>' +
        '</div>' +
        '<div class="window-body">' +
          '<div class="size-dialog-product">' +
            '<div class="ph">' + renderProductVisual(product) + '</div>' +
            '<div class="size-dialog-product-info">' +
              '<p class="name">' + product.name + '</p>' +
              '<p class="price">' + product.price + '</p>' +
            '</div>' +
          '</div>' +
          '<p class="size-dialog-label">Select size</p>' +
          '<div class="size-dialog-options" data-sizes>' +
            sizes.map(s =>
              '<button data-size="' + s + '"' +
                (sizes.length === 1 ? ' class="selected"' : '') + '>' + s + '</button>'
            ).join('') +
          '</div>' +
          '<div class="size-dialog-actions">' +
            '<button data-cancel>Cancel</button>' +
            '<button data-confirm' + (selectedSize ? '' : ' disabled') + '>Add to cart</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    var confirmBtn = overlay.querySelector('[data-confirm]');

    overlay.querySelectorAll('[data-size]').forEach(btn => {
      btn.addEventListener('click', () => {
        overlay.querySelectorAll('[data-size]').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        selectedSize = btn.dataset.size;
        if (confirmBtn) confirmBtn.disabled = false;
      });
    });

    overlay.querySelectorAll('[data-cancel]').forEach(b => {
      b.addEventListener('click', () => overlay.remove());
    });

    confirmBtn.addEventListener('click', () => {
      if (!selectedSize) return;
      addToCart(product, selectedSize);
      overlay.remove();
    });

    // Click overlay background to cancel
    overlay.addEventListener('click', e => {
      if (e.target === overlay) overlay.remove();
    });

    // ESC to cancel
    var escHandler = function (e) {
      if (e.key === 'Escape') {
        overlay.remove();
        document.removeEventListener('keydown', escHandler);
      }
    };
    document.addEventListener('keydown', escHandler);
  }

  // ===== Cart window =====
  function openCart() {
    if (cartWindow) {
      cartWindow.classList.remove('minimized');
      bringToFront(cartWindow);
      return;
    }

    var win = document.createElement('div');
    win.className = 'window draggable cart-window';
    win.style.width = '440px';
    var baseX = 120, baseY = 80, step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">Bag</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="window-body" data-cart-body></div>';

    document.getElementById('scene-desktop').appendChild(win);
    cartWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, 'Shopping Bag');

    win.querySelector('[data-action="close"]').addEventListener('click', e => {
      e.stopPropagation();
      win.remove();
      cartWindow = null;
    });
    win.querySelector('[data-action="min"]').addEventListener('click', e => {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });

    renderCartWindow();
  }

  function renderCartWindow() {
    if (!cartWindow) return;
    var body = cartWindow.querySelector('[data-cart-body]');
    if (!body) return;
    if (cart.length === 0) {
      body.innerHTML = '<div class="cart-empty">Your cart is empty.<br>Drag items here from any folder.</div>';
      return;
    }
    var total = cart.reduce((s, it) => s + (priceToNumber(it.price) * it.qty), 0);
    var listHtml = cart.map((it, i) =>
      '<div class="cart-item">' +
        '<div class="ph">' + (it.image ? '<img src="' + effnEscapeAttr(it.image) + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : (it.emoji || (it.name ? it.name.charAt(0) : '·'))) + '</div>' +
        '<div class="cart-item-info">' +
          '<p class="cart-item-name">' + it.name + '</p>' +
          '<p class="cart-item-meta">Size: ' + it.size + ' · Qty: ' + it.qty + '</p>' +
        '</div>' +
        '<span class="cart-item-price">$' + (priceToNumber(it.price) * it.qty).toFixed(2) + '</span>' +
        '<button class="cart-item-remove" data-remove="' + i + '">×</button>' +
      '</div>'
    ).join('');

    var earnedCodes = [
      { code: 'MINESWEEPER',     game: 'Minesweeper' },
      { code: 'SOLITAIREWINNER', game: 'Spider Solitaire' }
    ].filter(function (entry) {
      return localStorage.getItem('effn_winpop_' + entry.code) === '1';
    });
    var rewardHtml = earnedCodes.length
      ? '<div class="cart-reward">' +
          earnedCodes.map(function (entry) {
            return '<div class="cart-reward-row">' +
              '<span>🏆 ' + entry.game + ' reward — 10% off</span>' +
              '<button class="cart-reward-copy" data-copy-code="' + effnEscapeAttr(entry.code) + '">' + effnEscapeAttr(entry.code) + '</button>' +
            '</div>';
          }).join('') +
          '<p class="cart-reward-note">Apply at checkout. One per customer.</p>' +
        '</div>'
      : '';

    body.innerHTML =
      '<div class="cart-list">' + listHtml + '</div>' +
      rewardHtml +
      '<div class="cart-summary">' +
        '<span class="cart-summary-label">Subtotal</span>' +
        '<span class="cart-summary-total">$' + total.toFixed(2) + ' AUD</span>' +
      '</div>' +
      '<button class="cart-checkout" onclick="window.location.href=\'/checkout\'">Checkout</button>';

    body.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        var idx = parseInt(btn.dataset.remove, 10);
        removeFromCart(idx);
      });
    });
    body.querySelectorAll('[data-copy-code]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var code = btn.dataset.copyCode;
        var done = function () {
          var prev = btn.textContent;
          btn.textContent = 'Copied';
          setTimeout(function () { btn.textContent = prev; }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (err) {}
          ta.remove(); done();
        }
      });
    });
  }

  // Initialize cart drop target after DOM ready
  wireCartDropTarget();
  updateCartBadge();
  window.openCart = openCart;

  // ============ GAME-WIN DISCOUNT POPUP ============
  // One-per-customer per code is enforced both client-side (UX) and at
  // checkout (Shopify discount: usage limit of 1 per customer). This popup
  // only governs whether to *show* the code again on the same browser.
  function showDiscountPopup(code, gameLabel) {
    var seenKey = 'effn_winpop_' + code;
    if (localStorage.getItem(seenKey) === '1') return;
    localStorage.setItem(seenKey, '1');

    var overlay = document.createElement('div');
    overlay.className = 'discount-popup-overlay';
    overlay.innerHTML =
      '<div class="window discount-popup">' +
        '<div class="title-bar">' +
          '<div class="title-bar-text">Congratulations</div>' +
          '<div class="title-bar-controls">' +
            '<button aria-label="Close" data-close></button>' +
          '</div>' +
        '</div>' +
        '<div class="window-body" style="padding:14px;text-align:center;">' +
          '<div style="font-size:32px;line-height:1;margin-bottom:8px;">🏆</div>' +
          '<p style="margin:0 0 4px;font-weight:bold;">You beat ' + effnEscapeAttr(gameLabel) + '.</p>' +
          '<p style="margin:0 0 10px;font-size:11px;color:#444;">Use this code at checkout for 10% off.</p>' +
          '<div class="discount-code" data-code="' + effnEscapeAttr(code) + '" ' +
               'style="font: bold 14px ui-monospace, Menlo, monospace;letter-spacing:1px;padding:8px 12px;background:#fff;border:1px solid #000;box-shadow: inset 1px 1px #000, inset -1px -1px #fff, inset 2px 2px #808080, inset -2px -2px #dfdfdf;display:inline-block;margin-bottom:10px;">' +
            effnEscapeAttr(code) +
          '</div>' +
          '<p style="margin:0 0 10px;font-size:10px;color:#666;">Limited to one use per customer.</p>' +
          '<div style="display:flex;gap:6px;justify-content:center;">' +
            '<button data-copy>Copy code</button>' +
            '<button data-close>Close</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.querySelectorAll('[data-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { overlay.remove(); });
    });
    var copyBtn = overlay.querySelector('[data-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var done = function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 1400); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          ta.remove(); done();
        }
      });
    }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });
  }

  // ============ KONAMI CODE (desktop) + 10-TAP COPYRIGHT (mobile) ============
  // Either input path unlocks the same hidden discount code.
  (function () {
    var SEQUENCE = [
      'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
      'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
      'b', 'a'
    ];
    var pos = 0;
    document.addEventListener('keydown', function (e) {
      var key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      if (key === SEQUENCE[pos]) {
        pos++;
        if (pos === SEQUENCE.length) {
          pos = 0;
          showDiscountPopup('CHEATCODE10', 'the Konami code');
        }
      } else {
        // Allow restart if the wrong key is itself the start of the sequence
        pos = (key === SEQUENCE[0]) ? 1 : 0;
      }
    });

    // Mobile: 10 taps on the copyright text within 6 seconds.
    var taps = 0;
    var first = 0;
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      if (!target.closest('.desktop-copyright')) return;
      var now = Date.now();
      if (taps === 0 || now - first > 6000) { taps = 1; first = now; return; }
      taps++;
      if (taps >= 10) {
        taps = 0;
        showDiscountPopup('CHEATCODE10', 'the secret tap code');
      }
    });
  })();

  // ============ MINESWEEPER ============
  var minesWindow = null;
  // ============ PAINT (coloring-in app — XP-style UI with 3 layers + sliders) ============
  var paintWindow = null;
  function openPaint() {
    if (paintWindow) {
      paintWindow.classList.remove('minimized');
      bringToFront(paintWindow);
      return;
    }
    var templates = Array.isArray(window.EFFN_PAINT_TEMPLATES) ? window.EFFN_PAINT_TEMPLATES.filter(function (t) { return t && t.src; }) : [];

    var palette = [
      '#000000','#808080','#800000','#808000','#008000','#008080','#000080','#800080','#808040','#004040','#0080ff','#004080','#4000ff','#804000',
      '#ffffff','#c0c0c0','#ff0000','#ffff00','#00ff00','#00ffff','#0000ff','#ff00ff','#ffff80','#00ff80','#80ffff','#8080ff','#ff0080','#ff8040'
    ];

    /* Tool icons — pixel-art XP Paint replicas (jspaint-style).
       Each is a 16×16 viewBox using shape-rendering="crispEdges" so the
       1px rect "pixels" render sharply at any size. */
    var TOOL_ICONS = {
      /* Paintbrush — angled wooden handle, silver ferrule, black bristle tip */
      'brush':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          /* Wooden handle (brown) */
          '<rect x="11" y="2" width="2" height="1" fill="#000"/>' +
          '<rect x="10" y="3" width="3" height="1" fill="#a87332"/>' + '<rect x="13" y="3" width="1" height="1" fill="#000"/>' +
          '<rect x="9"  y="4" width="4" height="1" fill="#a87332"/>' + '<rect x="13" y="4" width="1" height="1" fill="#000"/>' +
          '<rect x="8"  y="5" width="5" height="1" fill="#a87332"/>' + '<rect x="13" y="5" width="1" height="1" fill="#000"/>' +
          '<rect x="7"  y="6" width="5" height="1" fill="#a87332"/>' + '<rect x="12" y="6" width="1" height="1" fill="#000"/>' +
          /* Handle highlight */
          '<rect x="10" y="3" width="1" height="1" fill="#e8c084"/>' +
          '<rect x="9"  y="4" width="1" height="1" fill="#e8c084"/>' +
          '<rect x="8"  y="5" width="1" height="1" fill="#e8c084"/>' +
          /* Silver ferrule */
          '<rect x="6"  y="7" width="6" height="1" fill="#000"/>' +
          '<rect x="6"  y="8" width="1" height="1" fill="#000"/>' + '<rect x="7" y="8" width="4" height="1" fill="#dcdcdc"/>' + '<rect x="11" y="8" width="1" height="1" fill="#000"/>' +
          '<rect x="5"  y="9" width="6" height="1" fill="#000"/>' +
          /* Bristle tip (black, fans out) */
          '<rect x="3"  y="10" width="7" height="1" fill="#000"/>' +
          '<rect x="2"  y="11" width="7" height="1" fill="#000"/>' +
          '<rect x="2"  y="12" width="6" height="1" fill="#000"/>' +
          '<rect x="3"  y="13" width="4" height="1" fill="#000"/>' +
        '</svg>',

      /* Textured brush — wider fanned bristles with vertical striations */
      'textured':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          /* Handle */
          '<rect x="11" y="2" width="2" height="1" fill="#000"/>' +
          '<rect x="10" y="3" width="3" height="1" fill="#7a4a18"/>' + '<rect x="13" y="3" width="1" height="1" fill="#000"/>' +
          '<rect x="9"  y="4" width="4" height="1" fill="#7a4a18"/>' + '<rect x="13" y="4" width="1" height="1" fill="#000"/>' +
          '<rect x="8"  y="5" width="5" height="1" fill="#7a4a18"/>' + '<rect x="13" y="5" width="1" height="1" fill="#000"/>' +
          /* Ferrule (wider) */
          '<rect x="6"  y="6" width="7" height="1" fill="#000"/>' +
          '<rect x="6"  y="7" width="1" height="1" fill="#000"/>' + '<rect x="7" y="7" width="5" height="1" fill="#dcdcdc"/>' + '<rect x="12" y="7" width="1" height="1" fill="#000"/>' +
          '<rect x="5"  y="8" width="8" height="1" fill="#000"/>' +
          /* Bristle bundle with white gaps between strands */
          '<rect x="3"  y="9"  width="9" height="1" fill="#000"/>' +
          '<rect x="3"  y="10" width="1" height="3" fill="#000"/>' +
          '<rect x="5"  y="10" width="1" height="4" fill="#000"/>' +
          '<rect x="7"  y="10" width="1" height="4" fill="#000"/>' +
          '<rect x="9"  y="10" width="1" height="3" fill="#000"/>' +
          '<rect x="11" y="10" width="1" height="2" fill="#000"/>' +
        '</svg>',

      /* Eraser — pink rubber block at slight tilt */
      'eraser':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          '<g transform="rotate(-18 8 8)">' +
            '<rect x="2"  y="5" width="12" height="1" fill="#000"/>' +
            '<rect x="2"  y="6" width="1"  height="1" fill="#000"/>' + '<rect x="3" y="6" width="10" height="1" fill="#ffc0cb"/>' + '<rect x="13" y="6" width="1" height="1" fill="#000"/>' +
            '<rect x="2"  y="7" width="1"  height="1" fill="#000"/>' + '<rect x="3" y="7" width="10" height="1" fill="#ff9aa5"/>' + '<rect x="13" y="7" width="1" height="1" fill="#000"/>' +
            '<rect x="2"  y="8" width="1"  height="1" fill="#000"/>' + '<rect x="3" y="8" width="10" height="1" fill="#ffe6ea"/>' + '<rect x="13" y="8" width="1" height="1" fill="#000"/>' +
            '<rect x="2"  y="9" width="12" height="1" fill="#000"/>' +
          '</g>' +
        '</svg>',

      /* Paint bucket — tilted bucket with pouring stream */
      'bucket':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          '<g transform="rotate(-14 8 9)">' +
            /* Bucket outline */
            '<rect x="3"  y="4" width="9" height="1" fill="#000"/>' +
            '<rect x="3"  y="5" width="1" height="1" fill="#000"/>' + '<rect x="4" y="5" width="7" height="1" fill="#d0d0d0"/>' + '<rect x="11" y="5" width="1" height="1" fill="#000"/>' +
            '<rect x="3"  y="6" width="1" height="1" fill="#000"/>' + '<rect x="4" y="6" width="7" height="1" fill="#a8a8a8"/>' + '<rect x="11" y="6" width="1" height="1" fill="#000"/>' +
            /* Paint level (color stripe) */
            '<rect x="4"  y="7" width="7" height="1" fill="#000080"/>' +
            '<rect x="4"  y="8" width="7" height="1" fill="#000080"/>' +
            '<rect x="4"  y="9" width="7" height="1" fill="#000080"/>' +
            /* Bucket base taper */
            '<rect x="4"  y="10" width="7" height="1" fill="#a8a8a8"/>' +
            '<rect x="4"  y="11" width="1" height="1" fill="#000"/>' + '<rect x="5" y="11" width="5" height="1" fill="#a8a8a8"/>' + '<rect x="10" y="11" width="1" height="1" fill="#000"/>' +
            '<rect x="5"  y="12" width="5" height="1" fill="#000"/>' +
            /* Handle (small arc) */
            '<rect x="12" y="4" width="1" height="1" fill="#000"/>' +
            '<rect x="13" y="5" width="1" height="2" fill="#000"/>' +
          '</g>' +
          /* Pour stream + drop, untilted so it falls straight */
          '<rect x="13" y="6" width="1" height="3" fill="#000080"/>' +
          '<rect x="12" y="9" width="3" height="1" fill="#000080"/>' +
        '</svg>',

      /* Spray (airbrush) — tilted can with spray dots */
      'spray':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          /* Can body */
          '<rect x="3" y="6" width="6" height="1" fill="#000"/>' +
          '<rect x="3" y="7" width="1" height="1" fill="#000"/>' + '<rect x="4" y="7" width="4" height="1" fill="#d0d0d0"/>' + '<rect x="8" y="7" width="1" height="1" fill="#000"/>' +
          '<rect x="3" y="8" width="1" height="1" fill="#000"/>' + '<rect x="4" y="8" width="4" height="1" fill="#e00000"/>' + '<rect x="8" y="8" width="1" height="1" fill="#000"/>' +
          '<rect x="3" y="9" width="1" height="1" fill="#000"/>' + '<rect x="4" y="9" width="4" height="1" fill="#a8a8a8"/>' + '<rect x="8" y="9" width="1" height="1" fill="#000"/>' +
          '<rect x="3" y="10" width="1" height="1" fill="#000"/>' + '<rect x="4" y="10" width="4" height="1" fill="#a8a8a8"/>' + '<rect x="8" y="10" width="1" height="1" fill="#000"/>' +
          '<rect x="3" y="11" width="1" height="1" fill="#000"/>' + '<rect x="4" y="11" width="4" height="1" fill="#a8a8a8"/>' + '<rect x="8" y="11" width="1" height="1" fill="#000"/>' +
          '<rect x="3" y="12" width="6" height="1" fill="#000"/>' +
          /* Nozzle */
          '<rect x="4" y="5" width="3" height="1" fill="#000"/>' +
          '<rect x="4" y="4" width="1" height="2" fill="#000"/>' + '<rect x="5" y="4" width="2" height="1" fill="#808080"/>' + '<rect x="7" y="4" width="1" height="2" fill="#000"/>' +
          /* Spray dots */
          '<rect x="9"  y="3" width="1" height="1" fill="#000"/>' +
          '<rect x="11" y="2" width="1" height="1" fill="#000"/>' +
          '<rect x="13" y="3" width="1" height="1" fill="#000"/>' +
          '<rect x="11" y="4" width="1" height="1" fill="#000"/>' +
          '<rect x="14" y="5" width="1" height="1" fill="#000"/>' +
          '<rect x="10" y="5" width="1" height="1" fill="#000"/>' +
          '<rect x="12" y="6" width="1" height="1" fill="#000"/>' +
        '</svg>',

      /* Line — clean diagonal stroke from bottom-left to top-right */
      'line':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          '<rect x="13" y="2"  width="2" height="1" fill="#000"/>' +
          '<rect x="11" y="3"  width="2" height="1" fill="#000"/>' +
          '<rect x="9"  y="4"  width="2" height="1" fill="#000"/>' +
          '<rect x="8"  y="5"  width="2" height="1" fill="#000"/>' +
          '<rect x="7"  y="6"  width="2" height="1" fill="#000"/>' +
          '<rect x="5"  y="7"  width="2" height="1" fill="#000"/>' +
          '<rect x="4"  y="8"  width="2" height="1" fill="#000"/>' +
          '<rect x="3"  y="9"  width="2" height="1" fill="#000"/>' +
          '<rect x="2"  y="10" width="2" height="1" fill="#000"/>' +
          '<rect x="1"  y="11" width="2" height="1" fill="#000"/>' +
          '<rect x="1"  y="12" width="1" height="2" fill="#000"/>' +
        '</svg>',

      /* Ellipse — hollow circle */
      'circle':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          '<rect x="6"  y="2"  width="4" height="1" fill="#000"/>' +
          '<rect x="4"  y="3"  width="2" height="1" fill="#000"/>' + '<rect x="10" y="3" width="2" height="1" fill="#000"/>' +
          '<rect x="3"  y="4"  width="1" height="1" fill="#000"/>' + '<rect x="12" y="4" width="1" height="1" fill="#000"/>' +
          '<rect x="2"  y="5"  width="1" height="2" fill="#000"/>' + '<rect x="13" y="5" width="1" height="2" fill="#000"/>' +
          '<rect x="2"  y="7"  width="1" height="2" fill="#000"/>' + '<rect x="13" y="7" width="1" height="2" fill="#000"/>' +
          '<rect x="3"  y="11" width="1" height="1" fill="#000"/>' + '<rect x="12" y="11" width="1" height="1" fill="#000"/>' +
          '<rect x="4"  y="12" width="2" height="1" fill="#000"/>' + '<rect x="10" y="12" width="2" height="1" fill="#000"/>' +
          '<rect x="6"  y="13" width="4" height="1" fill="#000"/>' +
          '<rect x="2"  y="9"  width="1" height="2" fill="#000"/>' + '<rect x="13" y="9" width="1" height="2" fill="#000"/>' +
        '</svg>',

      /* Zoom in — magnifying glass with + */
      'zoom':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          /* Lens outer */
          '<rect x="3" y="1" width="6" height="1" fill="#000"/>' +
          '<rect x="2" y="2" width="1" height="1" fill="#000"/>' + '<rect x="3" y="2" width="6" height="1" fill="#fff"/>' + '<rect x="9" y="2" width="1" height="1" fill="#000"/>' +
          '<rect x="1" y="3" width="1" height="1" fill="#000"/>' + '<rect x="2" y="3" width="8" height="1" fill="#fff"/>' + '<rect x="10" y="3" width="1" height="1" fill="#000"/>' +
          '<rect x="1" y="4" width="1" height="3" fill="#000"/>' + '<rect x="2" y="4" width="8" height="3" fill="#fff"/>' + '<rect x="10" y="4" width="1" height="3" fill="#000"/>' +
          '<rect x="1" y="7" width="1" height="1" fill="#000"/>' + '<rect x="2" y="7" width="8" height="1" fill="#fff"/>' + '<rect x="10" y="7" width="1" height="1" fill="#000"/>' +
          '<rect x="2" y="8" width="1" height="1" fill="#000"/>' + '<rect x="3" y="8" width="6" height="1" fill="#fff"/>' + '<rect x="9" y="8" width="1" height="1" fill="#000"/>' +
          '<rect x="3" y="9" width="6" height="1" fill="#000"/>' +
          /* Plus inside lens */
          '<rect x="5" y="3" width="2" height="5" fill="#000"/>' +
          '<rect x="3" y="5" width="6" height="1" fill="#000"/>' +
          /* Handle */
          '<rect x="9"  y="10" width="2" height="1" fill="#000"/>' +
          '<rect x="10" y="11" width="2" height="1" fill="#000"/>' +
          '<rect x="11" y="12" width="2" height="1" fill="#000"/>' +
          '<rect x="12" y="13" width="2" height="1" fill="#000"/>' +
          '<rect x="13" y="14" width="2" height="1" fill="#000"/>' +
        '</svg>',

      /* Zoom out — same as zoom but with – (no vertical bar) */
      'zoomOut':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          '<rect x="3" y="1" width="6" height="1" fill="#000"/>' +
          '<rect x="2" y="2" width="1" height="1" fill="#000"/>' + '<rect x="3" y="2" width="6" height="1" fill="#fff"/>' + '<rect x="9" y="2" width="1" height="1" fill="#000"/>' +
          '<rect x="1" y="3" width="1" height="1" fill="#000"/>' + '<rect x="2" y="3" width="8" height="1" fill="#fff"/>' + '<rect x="10" y="3" width="1" height="1" fill="#000"/>' +
          '<rect x="1" y="4" width="1" height="3" fill="#000"/>' + '<rect x="2" y="4" width="8" height="3" fill="#fff"/>' + '<rect x="10" y="4" width="1" height="3" fill="#000"/>' +
          '<rect x="1" y="7" width="1" height="1" fill="#000"/>' + '<rect x="2" y="7" width="8" height="1" fill="#fff"/>' + '<rect x="10" y="7" width="1" height="1" fill="#000"/>' +
          '<rect x="2" y="8" width="1" height="1" fill="#000"/>' + '<rect x="3" y="8" width="6" height="1" fill="#fff"/>' + '<rect x="9" y="8" width="1" height="1" fill="#000"/>' +
          '<rect x="3" y="9" width="6" height="1" fill="#000"/>' +
          '<rect x="3" y="5" width="6" height="1" fill="#000"/>' +
          '<rect x="9"  y="10" width="2" height="1" fill="#000"/>' +
          '<rect x="10" y="11" width="2" height="1" fill="#000"/>' +
          '<rect x="11" y="12" width="2" height="1" fill="#000"/>' +
          '<rect x="12" y="13" width="2" height="1" fill="#000"/>' +
          '<rect x="13" y="14" width="2" height="1" fill="#000"/>' +
        '</svg>',

      /* Text — bold A in the XP style */
      'text':
        '<svg viewBox="0 0 16 16" shape-rendering="crispEdges">' +
          '<rect x="7"  y="2"  width="2" height="1" fill="#000"/>' +
          '<rect x="6"  y="3"  width="4" height="1" fill="#000"/>' +
          '<rect x="5"  y="4"  width="2" height="1" fill="#000"/>' + '<rect x="9"  y="4" width="2" height="1" fill="#000"/>' +
          '<rect x="5"  y="5"  width="2" height="1" fill="#000"/>' + '<rect x="9"  y="5" width="2" height="1" fill="#000"/>' +
          '<rect x="4"  y="6"  width="2" height="1" fill="#000"/>' + '<rect x="10" y="6" width="2" height="1" fill="#000"/>' +
          '<rect x="4"  y="7"  width="8" height="1" fill="#000"/>' +
          '<rect x="3"  y="8"  width="2" height="1" fill="#000"/>' + '<rect x="11" y="8" width="2" height="1" fill="#000"/>' +
          '<rect x="3"  y="9"  width="2" height="1" fill="#000"/>' + '<rect x="11" y="9" width="2" height="1" fill="#000"/>' +
          '<rect x="2"  y="10" width="2" height="1" fill="#000"/>' + '<rect x="12" y="10" width="2" height="1" fill="#000"/>' +
          '<rect x="2"  y="11" width="2" height="1" fill="#000"/>' + '<rect x="12" y="11" width="2" height="1" fill="#000"/>' +
          '<rect x="1"  y="12" width="3" height="1" fill="#000"/>' + '<rect x="12" y="12" width="3" height="1" fill="#000"/>' +
        '</svg>'
    };
    /* Canonical MS Paint / jspaint 16-tool layout — 2 columns × 8 rows */
    var TOOLS = [
      'select-free', 'select-rect',
      'eraser',      'bucket',
      'eyedropper',  'zoom',
      'pencil',      'brush',
      'spray',       'text',
      'line',        'curve',
      'rect',        'polygon',
      'circle',      'rect-round'
    ];

    var win = document.createElement('div');
    win.className = 'window draggable paint-window';
    var isMobileViewport = (window.innerWidth || 393) <= 640;
    effnPlaceWindow(win, {
      baseX: isMobileViewport ? 8 : 80,
      baseY: isMobileViewport ? 16 : 40,
      step: 28,
      width:  isMobileViewport ? 520 : 760,
      height: isMobileViewport ? 640 : 720
    });

    win.innerHTML =
      '<div class="title-bar paint-titlebar">' +
        '<div class="title-bar-text"><span class="paint-titlebar-icon"></span>untitled - Paint</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="paint-menubar">' +
        '<button data-paint-menu="file">Choose your artwork</button>' +
        '<button data-paint-menu="undo"><u>U</u>ndo</button>' +
        '<button data-paint-menu="clip"><span data-clip-check>☑</span> Stay in lines</button>' +
      '</div>' +
      '<div class="paint-body">' +
        '<div class="paint-toolbox">' +
          '<div class="paint-toolbox-grid">' +
            TOOLS.map(function (t) {
              /* Icon comes from CSS via ::before + sprite background.
                 TOOL_ICONS is preserved as a fallback for older themes
                 that don't load the sprite, but the sprite is preferred. */
              return '<button class="paint-tool' + (t === 'brush' ? ' is-active' : '') + '" data-tool="' + t + '" title="' + t + '"></button>';
            }).join('') +
          '</div>' +
          '<div class="paint-circle-mode" data-circle-mode style="display:none;">' +
            '<button class="paint-mini" data-cmode="outline" title="Outline only">○</button>' +
            '<button class="paint-mini is-active" data-cmode="filled" title="Filled">●</button>' +
            '<button class="paint-mini" data-cmode="both" title="Both">◉</button>' +
          '</div>' +
        '</div>' +
        '<div class="paint-canvas-wrap">' +
          '<div class="paint-canvas-stack" data-stack>' +
            '<canvas class="paint-canvas paint-canvas-bg"      width="800" height="800"></canvas>' +
            '<canvas class="paint-canvas paint-canvas-color"   width="800" height="800"></canvas>' +
            '<canvas class="paint-canvas paint-canvas-outline" width="800" height="800"></canvas>' +
            '<canvas class="paint-canvas paint-canvas-preview" width="800" height="800"></canvas>' +
            '<div class="paint-ghost" data-paint-ghost></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="paint-layer-panel" data-layer-panel>' +
        ['background','color','outline'].map(function (k) {
          var locked = (k === 'outline');
          var active = (k === 'color');
          return '<button class="paint-layer' + (active ? ' is-active' : '') + (locked ? ' is-locked' : '') + '" data-layer="' + k + '">' +
                   '<span class="paint-layer-eye is-on" data-eye>👁</span>' +
                   '<span class="paint-layer-name">' + k.charAt(0).toUpperCase() + k.slice(1) + '</span>' +
                   '<span class="paint-layer-lock' + (locked ? ' is-on' : '') + '" data-lock>' + (locked ? '🔒' : '') + '</span>' +
                 '</button>';
        }).join('') +
      '</div>' +
      '<div class="paint-palette-row">' +
        '<div class="paint-current-color">' +
          '<div class="paint-current-color-fg" data-paint-current-fg></div>' +
          '<div class="paint-current-color-bg" data-paint-current-bg></div>' +
        '</div>' +
        '<div class="paint-palette" data-paint-palette>' +
          palette.map(function (c, i) {
            return '<button class="paint-swatch' + (i === 0 ? ' is-active' : '') + '" data-color="' + c + '" style="background:' + c + ';" title="' + c + '"></button>';
          }).join('') +
        '</div>' +
        '<button class="paint-rainbow" data-paint-rainbow title="More colors"></button>' +
        '<input type="color" data-paint-color-input class="paint-color-input" value="#000000">' +
      '</div>' +
      '<div class="paint-slider-row">' +
        '<div class="paint-slider">' +
          '<label>Width <span data-width-val>6</span></label>' +
          '<input type="range" min="1" max="60" value="6" data-width-slider>' +
        '</div>' +
        '<div class="paint-slider">' +
          '<label>Feather <span data-feather-val>0</span></label>' +
          '<input type="range" min="0" max="40" value="0" data-feather-slider>' +
        '</div>' +
      '</div>' +
      '<div class="paint-statusbar">' +
        '<span data-paint-template-name>For Help, click Help Topics on the Help Menu.</span>' +
      '</div>' +
      '<div class="paint-resize-handle" data-paint-resize aria-label="Resize" title="Drag to resize"></div>';

    document.getElementById('scene-desktop').appendChild(win);
    paintWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, 'PAINT.EXE');

    /* X button — actually close the window. wireWindowChrome only cleans
       up the taskbar tab; each app provides its own removal handler. */
    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      /* Clean up timers + listeners so paint state doesn't leak */
      if (state.spray)     { clearInterval(state.spray); state.spray = null; }
      if (typeof ro !== 'undefined' && ro && ro.disconnect) try { ro.disconnect(); } catch (_) {}
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('keyup',   onKeyUp);
      win.remove();
      paintWindow = null;
    });

    var bgCanvas      = win.querySelector('.paint-canvas-bg');
    var colorCanvas   = win.querySelector('.paint-canvas-color');
    var outlineCanvas = win.querySelector('.paint-canvas-outline');
    var previewCanvas = win.querySelector('.paint-canvas-preview');
    var bgCtx      = bgCanvas.getContext('2d');
    var colorCtx   = colorCanvas.getContext('2d');
    var outlineCtx = outlineCanvas.getContext('2d');
    var previewCtx = previewCanvas.getContext('2d');
    bgCtx.fillStyle = '#ffffff';
    bgCtx.fillRect(0, 0, bgCanvas.width, bgCanvas.height);

    var layers = {
      background: { canvas: bgCanvas,      ctx: bgCtx,      visible: true, locked: false },
      color:      { canvas: colorCanvas,   ctx: colorCtx,   visible: true, locked: false },
      outline:    { canvas: outlineCanvas, ctx: outlineCtx, visible: true, locked: true  }
    };

    var state = {
      tool: 'brush',
      color: '#000000',
      size: 6,
      feather: 0,
      activeLayer: 'color',
      circleMode: 'filled',
      zoom: 1,
      panX: 0,
      panY: 0,
      spaceDown: false,
      panning: false,
      panStartX: 0, panStartY: 0,
      drawing: false,
      spray: null,
      lastX: 0, lastY: 0,
      startX: 0, startY: 0,
      currentTemplateName: '',
      clipToOutline: true,
      clipMask: null,    /* offscreen canvas: black where painting is allowed */
      clipMaskURL: ''    /* data URL of clipMask, used for CSS mask */
    };
    updateCurrentColorChip();

    function activeCtx()    { return layers[state.activeLayer].ctx; }
    function activeCanvas() { return layers[state.activeLayer].canvas; }

    function pointerPos(e) {
      var rect = previewCanvas.getBoundingClientRect();
      var sx = previewCanvas.width  / rect.width;
      var sy = previewCanvas.height / rect.height;
      return { x: (e.clientX - rect.left) * sx, y: (e.clientY - rect.top) * sy };
    }

    function applyStyle(ctx) {
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = state.size;
      ctx.strokeStyle = state.color;
      ctx.fillStyle = state.color;
      ctx.globalAlpha = 1;
      ctx.shadowBlur = state.feather > 0 ? state.feather : 0;
      ctx.shadowColor = state.feather > 0 ? state.color : 'transparent';
      ctx.globalCompositeOperation = (state.tool === 'eraser') ? 'destination-out' : 'source-over';
    }

    function stampTextured(ctx, x, y) {
      var r = Math.max(1, state.size / 2);
      ctx.save();
      ctx.shadowBlur = 0;
      ctx.fillStyle = state.color;
      for (var i = 0; i < 7; i++) {
        var a = Math.random() * Math.PI * 2;
        var d = Math.random() * r;
        var rr = Math.max(0.4, Math.random() * r * 0.55);
        ctx.globalAlpha = 0.35 + Math.random() * 0.45;
        ctx.beginPath();
        ctx.arc(x + Math.cos(a) * d, y + Math.sin(a) * d, rr, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    }
    function stampSpray(ctx, x, y) {
      var r = state.size * 1.2;
      var count = Math.max(28, Math.round(state.size * 3));
      var dotR = 0.6 + state.size / 14;
      ctx.save();
      ctx.shadowBlur = 0;
      ctx.fillStyle = state.color;
      for (var i = 0; i < count; i++) {
        var a = Math.random() * Math.PI * 2;
        /* Gaussian-ish falloff: bias dots toward the center for a denser core */
        var d = Math.pow(Math.random(), 0.6) * r;
        ctx.beginPath();
        ctx.arc(x + Math.cos(a) * d, y + Math.sin(a) * d, dotR, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    }

    function flashLockedLayer() {
      var row = win.querySelector('[data-layer="' + state.activeLayer + '"]');
      if (row) { row.classList.add('flash'); setTimeout(function(){ row.classList.remove('flash'); }, 300); }
    }

    previewCanvas.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      e.preventDefault();

      /* Spacebar + drag → pan, regardless of active tool */
      if (state.spaceDown) {
        state.panning = true;
        state.panStartX = e.clientX - state.panX;
        state.panStartY = e.clientY - state.panY;
        previewCanvas.style.cursor = 'grabbing';
        ghost.style.display = 'none';
        try { previewCanvas.setPointerCapture(e.pointerId); } catch (_) {}
        return;
      }

      var p = pointerPos(e);

      /* Magnifier — cycles 1× → 2× → 4× → 1×. Click anywhere; canvas
         zooms toward the click point via transform-origin. */
      if (state.tool === 'zoom') {
        var levels = [1, 2, 4];
        var idx = levels.indexOf(state.zoom);
        if (idx < 0) idx = 0;
        state.zoom = levels[(idx + 1) % levels.length];
        if (state.zoom === 1) { state.panX = 0; state.panY = 0; }
        applyStackTransform();
        return;
      }

      /* Eyedropper — sample composite color, set as current */
      if (state.tool === 'eyedropper') {
        sampleColorAt(Math.round(p.x), Math.round(p.y));
        return;
      }

      if (layers[state.activeLayer].locked) { flashLockedLayer(); return; }

      if (state.tool === 'bucket') {
        pushUndo();
        floodFill(Math.round(p.x), Math.round(p.y), state.color);
        return;
      }

      if (state.tool === 'text') {
        var txt = window.prompt('Text:');
        if (txt) {
          pushUndo();
          var ctx = activeCtx();
          ctx.save();
          applyStyle(ctx);
          ctx.font = 'bold ' + Math.max(14, state.size * 3) + 'px "Trebuchet MS", sans-serif';
          ctx.textBaseline = 'top';
          ctx.fillText(txt, p.x, p.y);
          ctx.restore();
        }
        return;
      }

      pushUndo();
      state.drawing = true;
      state.lastX = p.x; state.lastY = p.y;
      state.startX = p.x; state.startY = p.y;

      var ctx2 = activeCtx();
      /* Brush family — brush, pencil (forced 1px), eraser, plus the
         select/polygon tools which fall through to brush for now. */
      var brushlike = (state.tool === 'brush' || state.tool === 'eraser' ||
                       state.tool === 'pencil' ||
                       state.tool === 'select-free' || state.tool === 'select-rect' ||
                       state.tool === 'polygon');
      if (brushlike) {
        applyStyle(ctx2);
        if (state.tool === 'pencil') { ctx2.lineWidth = 1; ctx2.shadowBlur = 0; }
        ctx2.beginPath();
        ctx2.moveTo(p.x, p.y);
        ctx2.lineTo(p.x + 0.01, p.y + 0.01);
        ctx2.stroke();
      } else if (state.tool === 'textured') {
        stampTextured(ctx2, p.x, p.y);
      } else if (state.tool === 'spray') {
        stampSpray(ctx2, p.x, p.y);
        state.spray = setInterval(function () { stampSpray(activeCtx(), state.lastX, state.lastY); }, 22);
      }
      /* line / curve / rect / rect-round / circle just need the start
         point recorded; preview + commit happen in pointermove/end. */

      try { previewCanvas.setPointerCapture(e.pointerId); } catch(_) {}
    });

    previewCanvas.addEventListener('pointermove', function (e) {
      if (state.panning) {
        e.preventDefault();
        state.panX = e.clientX - state.panStartX;
        state.panY = e.clientY - state.panStartY;
        applyStackTransform();
        return;
      }
      if (!state.drawing) return;
      e.preventDefault();
      var p = pointerPos(e);
      var ctx = activeCtx();

      var brushlikeMove = (state.tool === 'brush' || state.tool === 'eraser' ||
                           state.tool === 'pencil' ||
                           state.tool === 'select-free' || state.tool === 'select-rect' ||
                           state.tool === 'polygon');
      if (brushlikeMove) {
        applyStyle(ctx);
        if (state.tool === 'pencil') { ctx.lineWidth = 1; ctx.shadowBlur = 0; }
        ctx.beginPath();
        ctx.moveTo(state.lastX, state.lastY);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
      } else if (state.tool === 'textured') {
        var dx = p.x - state.lastX, dy = p.y - state.lastY;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var step = Math.max(1, state.size / 4);
        var steps = Math.max(1, Math.ceil(dist / step));
        for (var i = 1; i <= steps; i++) {
          var t = i / steps;
          stampTextured(ctx, state.lastX + dx * t, state.lastY + dy * t);
        }
      } else if (state.tool === 'line' || state.tool === 'curve') {
        previewCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
        applyStyle(previewCtx);
        previewCtx.beginPath();
        previewCtx.moveTo(state.startX, state.startY);
        previewCtx.lineTo(p.x, p.y);
        previewCtx.stroke();
      } else if (state.tool === 'rect' || state.tool === 'rect-round') {
        previewCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
        applyStyle(previewCtx);
        var rx0 = Math.min(state.startX, p.x), ry0 = Math.min(state.startY, p.y);
        var rw  = Math.abs(p.x - state.startX), rh = Math.abs(p.y - state.startY);
        if (state.tool === 'rect-round') {
          var rr = Math.min(rw, rh, 14);
          previewCtx.beginPath();
          previewCtx.moveTo(rx0 + rr, ry0);
          previewCtx.arcTo(rx0 + rw, ry0,     rx0 + rw, ry0 + rh, rr);
          previewCtx.arcTo(rx0 + rw, ry0 + rh, rx0,      ry0 + rh, rr);
          previewCtx.arcTo(rx0,      ry0 + rh, rx0,      ry0,      rr);
          previewCtx.arcTo(rx0,      ry0,      rx0 + rw, ry0,      rr);
          previewCtx.closePath();
          previewCtx.stroke();
        } else {
          previewCtx.strokeRect(rx0, ry0, rw, rh);
        }
      } else if (state.tool === 'circle') {
        previewCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
        applyStyle(previewCtx);
        var cx = (state.startX + p.x) / 2, cy = (state.startY + p.y) / 2;
        var rx = Math.abs(p.x - state.startX) / 2, ry = Math.abs(p.y - state.startY) / 2;
        if (state.circleMode === 'filled' || state.circleMode === 'both') {
          previewCtx.beginPath(); previewCtx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2); previewCtx.fill();
        }
        if (state.circleMode === 'outline' || state.circleMode === 'both') {
          previewCtx.beginPath(); previewCtx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2); previewCtx.stroke();
        }
      }
      state.lastX = p.x; state.lastY = p.y;
    });

    function endStroke() {
      if (state.panning) {
        state.panning = false;
        previewCanvas.style.cursor = state.spaceDown ? 'grab' : '';
        return;
      }
      if (!state.drawing) return;
      if (state.spray) { clearInterval(state.spray); state.spray = null; }
      var ctx = activeCtx();
      if (state.tool === 'line' || state.tool === 'curve') {
        applyStyle(ctx);
        ctx.beginPath();
        ctx.moveTo(state.startX, state.startY);
        ctx.lineTo(state.lastX, state.lastY);
        ctx.stroke();
        previewCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
      } else if (state.tool === 'rect' || state.tool === 'rect-round') {
        applyStyle(ctx);
        var rxC = Math.min(state.startX, state.lastX);
        var ryC = Math.min(state.startY, state.lastY);
        var rwC = Math.abs(state.lastX - state.startX);
        var rhC = Math.abs(state.lastY - state.startY);
        if (state.tool === 'rect-round') {
          var rrC = Math.min(rwC, rhC, 14);
          ctx.beginPath();
          ctx.moveTo(rxC + rrC, ryC);
          ctx.arcTo(rxC + rwC, ryC,        rxC + rwC, ryC + rhC, rrC);
          ctx.arcTo(rxC + rwC, ryC + rhC,  rxC,       ryC + rhC, rrC);
          ctx.arcTo(rxC,       ryC + rhC,  rxC,       ryC,       rrC);
          ctx.arcTo(rxC,       ryC,        rxC + rwC, ryC,       rrC);
          ctx.closePath();
          ctx.stroke();
        } else {
          ctx.strokeRect(rxC, ryC, rwC, rhC);
        }
        previewCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
      } else if (state.tool === 'circle') {
        applyStyle(ctx);
        var cx = (state.startX + state.lastX) / 2, cy = (state.startY + state.lastY) / 2;
        var rx = Math.abs(state.lastX - state.startX) / 2, ry = Math.abs(state.lastY - state.startY) / 2;
        if (state.circleMode === 'filled' || state.circleMode === 'both') {
          ctx.beginPath(); ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2); ctx.fill();
        }
        if (state.circleMode === 'outline' || state.circleMode === 'both') {
          ctx.beginPath(); ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2); ctx.stroke();
        }
        previewCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
      }
      state.drawing = false;
      ctx.shadowBlur = 0;
      ctx.globalCompositeOperation = 'source-over';
    }
    previewCanvas.addEventListener('pointerup',     endStroke);
    previewCanvas.addEventListener('pointercancel', endStroke);
    previewCanvas.addEventListener('pointerleave',  endStroke);

    function updateCurrentColorChip() {
      var fg = win.querySelector('[data-paint-current-fg]');
      var bg = win.querySelector('[data-paint-current-bg]');
      if (fg) fg.style.background = state.color;
      if (bg) bg.style.background = '#ffffff';
    }

    /* Tool buttons */
    win.querySelectorAll('[data-tool]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        state.tool = btn.dataset.tool;
        win.querySelectorAll('[data-tool]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var cm = win.querySelector('[data-circle-mode]');
        if (cm) cm.style.display = (state.tool === 'circle') ? '' : 'none';
      });
    });

    /* Width / feather sliders */
    var widthSlider  = win.querySelector('[data-width-slider]');
    var widthVal     = win.querySelector('[data-width-val]');
    var featherSlider = win.querySelector('[data-feather-slider]');
    var featherVal    = win.querySelector('[data-feather-val]');
    widthSlider.addEventListener('input', function () {
      state.size = Number(widthSlider.value);
      widthVal.textContent = state.size;
    });
    featherSlider.addEventListener('input', function () {
      state.feather = Number(featherSlider.value);
      featherVal.textContent = state.feather;
    });

    /* Circle sub-mode toggle */
    win.querySelectorAll('[data-cmode]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        state.circleMode = btn.dataset.cmode;
        win.querySelectorAll('[data-cmode]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    /* Layer panel: row = activate; eye / lock have their own handlers */
    win.querySelectorAll('[data-layer]').forEach(function (btn) {
      var key = btn.dataset.layer;
      btn.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-eye') || e.target.hasAttribute('data-lock')) return;
        e.stopPropagation();
        state.activeLayer = key;
        win.querySelectorAll('[data-layer]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.layer === key); });
      });
      var eye = btn.querySelector('[data-eye]');
      eye.addEventListener('click', function (e) {
        e.stopPropagation();
        var L = layers[key];
        L.visible = !L.visible;
        eye.classList.toggle('is-on', L.visible);
        eye.textContent = L.visible ? '👁' : '–';
        L.canvas.style.display = L.visible ? '' : 'none';
      });
      var lock = btn.querySelector('[data-lock]');
      lock.addEventListener('click', function (e) {
        e.stopPropagation();
        var L = layers[key];
        L.locked = !L.locked;
        lock.classList.toggle('is-on', L.locked);
        lock.textContent = L.locked ? '🔒' : '';
        btn.classList.toggle('is-locked', L.locked);
      });
    });

    win.querySelectorAll('[data-color]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        state.color = btn.dataset.color;
        updateCurrentColorChip();
        win.querySelectorAll('[data-color]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    /* Custom color picker: rainbow swatch triggers a native color input */
    var colorInput = win.querySelector('[data-paint-color-input]');
    var rainbowBtn = win.querySelector('[data-paint-rainbow]');
    rainbowBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      colorInput.value = state.color;
      colorInput.click();
    });
    colorInput.addEventListener('input', function () {
      state.color = colorInput.value;
      updateCurrentColorChip();
      win.querySelectorAll('[data-color]').forEach(function (b) { b.classList.remove('is-active'); });
      rainbowBtn.classList.add('is-active');
      rainbowBtn.style.boxShadow = 'inset 0 0 0 2px ' + state.color + ', inset 0 0 0 3px #fff';
    });
    /* Tapping a fixed swatch clears the rainbow active state */
    win.querySelectorAll('[data-color]').forEach(function (b) {
      b.addEventListener('click', function () { rainbowBtn.classList.remove('is-active'); rainbowBtn.style.boxShadow = ''; });
    });

    win.querySelector('[data-paint-menu="file"]').addEventListener('click', function (e) {
      e.stopPropagation();
      openTemplatePicker();
    });
    win.querySelector('[data-paint-menu="undo"]').addEventListener('click', function (e) {
      e.stopPropagation();
      undo();
    });
    var clipCheck = win.querySelector('[data-clip-check]');
    win.querySelector('[data-paint-menu="clip"]').addEventListener('click', function (e) {
      e.stopPropagation();
      state.clipToOutline = !state.clipToOutline;
      clipCheck.textContent = state.clipToOutline ? '☑' : '☐';
      applyClipDOM();
    });

    function openTemplatePicker() {
      var picker = document.createElement('div');
      picker.className = 'paint-template-picker';
      picker.innerHTML =
        '<div class="paint-template-picker-inner">' +
          '<div class="paint-template-picker-title">Open coloring page</div>' +
          '<div class="paint-template-grid">' +
            templates.map(function (t, i) {
              return '<button class="paint-template-card" data-template-index="' + i + '">' +
                       '<img src="' + effnEscapeAttr(t.src) + '" alt="' + effnEscapeAttr(t.name) + '">' +
                       '<span>' + effnEscapeAttr(t.name) + '</span>' +
                     '</button>';
            }).join('') +
          '</div>' +
          '<div class="paint-template-picker-actions">' +
            '<button data-paint-action="save">Save current</button>' +
            '<button data-template-action="blank">Blank canvas</button>' +
            '<button data-template-action="cancel">Cancel</button>' +
          '</div>' +
        '</div>';
      win.appendChild(picker);
      picker.querySelectorAll('[data-template-index]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          loadTemplate(templates[Number(b.dataset.templateIndex)]);
          picker.remove();
        });
      });
      picker.querySelector('[data-template-action="blank"]').addEventListener('click', function (e) {
        e.stopPropagation();
        clearAllLayers();
        state.currentTemplateName = '';
        updateStatus();
        picker.remove();
      });
      picker.querySelector('[data-template-action="cancel"]').addEventListener('click', function (e) {
        e.stopPropagation();
        picker.remove();
      });
      picker.querySelector('[data-paint-action="save"]').addEventListener('click', function (e) {
        e.stopPropagation();
        saveCanvas();
      });
    }

    function loadTemplate(t) {
      if (!t || !t.src) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        clearAllLayers();
        var s = Math.min(outlineCanvas.width / img.width, outlineCanvas.height / img.height);
        var dw = img.width * s, dh = img.height * s;
        outlineCtx.drawImage(img, (outlineCanvas.width - dw) / 2, (outlineCanvas.height - dh) / 2, dw, dh);
        state.currentTemplateName = t.name || 'template';
        updateStatus();
        buildClipMask();
        applyClipDOM();
      };
      img.onerror = function () {
        state.currentTemplateName = '(failed to load — try another)';
        updateStatus();
      };
      img.src = t.src;
    }

    /* Build a clipping mask from the outline layer: flood-fill from canvas edges
       treating dark (line-art) pixels as walls. Reachable pixels = OUTSIDE the
       garment shape. Pixels left unflooded = INSIDE → mask is opaque there. */
    function buildClipMask() {
      var w = outlineCanvas.width, h = outlineCanvas.height;
      var src;
      try { src = outlineCtx.getImageData(0, 0, w, h).data; }
      catch (_) { state.clipMask = null; state.clipMaskURL = ''; return; }
      var visited = new Uint8Array(w * h);
      var outside = new Uint8Array(w * h);
      var stack = [];
      for (var x = 0; x < w; x++) { stack.push(x, 0); stack.push(x, h - 1); }
      for (var y = 0; y < h; y++) { stack.push(0, y); stack.push(w - 1, y); }
      while (stack.length) {
        var py = stack.pop(), px = stack.pop();
        if (px < 0 || py < 0 || px >= w || py >= h) continue;
        var vi = py * w + px;
        if (visited[vi]) continue;
        visited[vi] = 1;
        var i4 = vi * 4;
        var sum = src[i4] + src[i4 + 1] + src[i4 + 2];
        var a = src[i4 + 3];
        /* Wall if dark and present (anti-alias safe at sum < 540) */
        if (a > 80 && sum < 540) continue;
        outside[vi] = 1;
        stack.push(px + 1, py); stack.push(px - 1, py);
        stack.push(px, py + 1); stack.push(px, py - 1);
      }
      var mask = document.createElement('canvas');
      mask.width = w; mask.height = h;
      var mctx = mask.getContext('2d');
      var img = mctx.createImageData(w, h);
      var d = img.data;
      for (var i = 0; i < outside.length; i++) {
        if (!outside[i]) {
          var j = i * 4;
          d[j] = 0; d[j + 1] = 0; d[j + 2] = 0; d[j + 3] = 255;
        }
      }
      mctx.putImageData(img, 0, 0);
      state.clipMask = mask;
      try { state.clipMaskURL = mask.toDataURL(); } catch (_) { state.clipMaskURL = ''; }
    }

    function applyClipDOM() {
      var url = (state.clipToOutline && state.clipMaskURL) ? 'url(' + state.clipMaskURL + ')' : '';
      colorCanvas.style.maskImage = url;
      colorCanvas.style.webkitMaskImage = url;
      colorCanvas.style.maskSize = '100% 100%';
      colorCanvas.style.webkitMaskSize = '100% 100%';
    }
    /* Undo stack: snapshot the active layer before each destructive action. */
    var undoStack = [];
    var UNDO_LIMIT = 24;
    function pushUndo() {
      var key = state.activeLayer;
      var c = layers[key].canvas;
      try {
        var snap = layers[key].ctx.getImageData(0, 0, c.width, c.height);
        undoStack.push({ layer: key, data: snap });
        if (undoStack.length > UNDO_LIMIT) undoStack.shift();
      } catch (_) {}
    }
    function undo() {
      if (!undoStack.length) return;
      var s = undoStack.pop();
      layers[s.layer].ctx.putImageData(s.data, 0, 0);
    }

    function hexToRgb(hex) {
      var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return m ? { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) } : null;
    }
    function rgbToHex(r, g, b) {
      var pad = function (n) { var s = n.toString(16); return s.length < 2 ? '0' + s : s; };
      return '#' + pad(r) + pad(g) + pad(b);
    }
    /* Eyedropper — sample composite pixel and set current color */
    function sampleColorAt(x, y) {
      var w = bgCanvas.width, h = bgCanvas.height;
      var temp = document.createElement('canvas');
      temp.width = w; temp.height = h;
      var tc = temp.getContext('2d');
      if (layers.background.visible) tc.drawImage(bgCanvas, 0, 0);
      if (layers.color.visible)      tc.drawImage(colorCanvas, 0, 0);
      if (layers.outline.visible) {
        tc.globalCompositeOperation = 'multiply';
        tc.drawImage(outlineCanvas, 0, 0);
        tc.globalCompositeOperation = 'source-over';
      }
      try {
        var d = tc.getImageData(Math.max(0, Math.min(w - 1, x)), Math.max(0, Math.min(h - 1, y)), 1, 1).data;
        state.color = rgbToHex(d[0], d[1], d[2]);
        updateCurrentColorChip();
        win.querySelectorAll('[data-color]').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.color.toLowerCase() === state.color.toLowerCase());
        });
      } catch (_) {}
    }

    /* Flood fill on the active layer using the composite (bg+color+outline) to
       detect region boundaries. Two-pass approach for clean edges:
         1. Tight-threshold flood builds a mask of clearly-interior pixels.
         2. Dilate the mask 2px so fill creeps into anti-aliased line edges,
            eliminating the halo without making the boundary fuzzy. */
    function floodFill(x, y, color) {
      var w = bgCanvas.width, h = bgCanvas.height;
      var temp = document.createElement('canvas');
      temp.width = w; temp.height = h;
      var tc = temp.getContext('2d');
      if (layers.background.visible) tc.drawImage(bgCanvas, 0, 0);
      if (layers.color.visible)      tc.drawImage(colorCanvas, 0, 0);
      if (layers.outline.visible) {
        tc.globalCompositeOperation = 'multiply';
        tc.drawImage(outlineCanvas, 0, 0);
        tc.globalCompositeOperation = 'source-over';
      }
      var src;
      try { src = tc.getImageData(0, 0, w, h).data; } catch (_) { return; }
      var idx0 = (y * w + x) * 4;
      var sr = src[idx0], sg = src[idx0 + 1], sb = src[idx0 + 2];
      var c = hexToRgb(color);
      if (!c) return;
      /* Tight tolerance: stops cleanly at anti-aliased line edges */
      var TOL = 10;
      var mask = new Uint8Array(w * h);
      var stack = [x, y];
      while (stack.length) {
        var py = stack.pop(), px = stack.pop();
        if (px < 0 || py < 0 || px >= w || py >= h) continue;
        var vi = py * w + px;
        if (mask[vi]) continue;
        var i4 = vi * 4;
        if (Math.abs(src[i4]     - sr) > TOL) continue;
        if (Math.abs(src[i4 + 1] - sg) > TOL) continue;
        if (Math.abs(src[i4 + 2] - sb) > TOL) continue;
        mask[vi] = 1;
        stack.push(px + 1, py); stack.push(px - 1, py);
        stack.push(px, py + 1); stack.push(px, py - 1);
      }
      /* Dilate 2 passes — fills creep into AA pixels for crisp boundary */
      var DILATE = 2;
      for (var pass = 0; pass < DILATE; pass++) {
        var next = new Uint8Array(mask);
        for (var yy = 0; yy < h; yy++) {
          var row = yy * w;
          for (var xx = 0; xx < w; xx++) {
            var i = row + xx;
            if (mask[i]) continue;
            if ((xx > 0     && mask[i - 1]) ||
                (xx < w - 1 && mask[i + 1]) ||
                (yy > 0     && mask[i - w]) ||
                (yy < h - 1 && mask[i + w])) {
              next[i] = 1;
            }
          }
        }
        mask = next;
      }
      /* Paint dilated mask onto active layer */
      var ctx = activeCtx();
      var dest = ctx.getImageData(0, 0, w, h);
      var dd = dest.data;
      for (var i = 0; i < mask.length; i++) {
        if (mask[i]) {
          var j = i * 4;
          dd[j]     = c.r;
          dd[j + 1] = c.g;
          dd[j + 2] = c.b;
          dd[j + 3] = 255;
        }
      }
      ctx.putImageData(dest, 0, 0);
    }

    function clearAllLayers() {
      bgCtx.fillStyle = '#ffffff';
      bgCtx.fillRect(0, 0, bgCanvas.width, bgCanvas.height);
      colorCtx.clearRect(0, 0, colorCanvas.width, colorCanvas.height);
      outlineCtx.clearRect(0, 0, outlineCanvas.width, outlineCanvas.height);
    }

    /* Save — flatten visible layers + EFFN watermark */
    function saveCanvas() {
      var out = document.createElement('canvas');
      out.width = bgCanvas.width;
      out.height = bgCanvas.height;
      var oc = out.getContext('2d');
      if (layers.background.visible) oc.drawImage(bgCanvas, 0, 0);
      if (layers.color.visible) {
        if (state.clipToOutline && state.clipMask) {
          var tmp = document.createElement('canvas');
          tmp.width = colorCanvas.width; tmp.height = colorCanvas.height;
          var tc = tmp.getContext('2d');
          tc.drawImage(colorCanvas, 0, 0);
          tc.globalCompositeOperation = 'destination-in';
          tc.drawImage(state.clipMask, 0, 0);
          oc.drawImage(tmp, 0, 0);
        } else {
          oc.drawImage(colorCanvas, 0, 0);
        }
      }
      if (layers.outline.visible) {
        oc.globalCompositeOperation = 'multiply';
        oc.drawImage(outlineCanvas, 0, 0);
        oc.globalCompositeOperation = 'source-over';
      }
      /* EFFN watermark — bottom-right, italic serif */
      oc.font = 'italic 900 36px "Times New Roman", serif';
      oc.textAlign = 'right';
      oc.textBaseline = 'bottom';
      oc.fillStyle = 'rgba(0,0,0,0.55)';
      oc.fillText(effnBrandShort(), out.width - 22, out.height - 22);
      oc.fillStyle = 'rgba(255,255,255,0.8)';
      oc.fillText(effnBrandShort(), out.width - 24, out.height - 24);
      try {
        var url = out.toDataURL('image/png');
        var a = document.createElement('a');
        a.href = url;
        a.download = (state.currentTemplateName || effnBrandShort() + '-paint') + '.png';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () { a.remove(); }, 100);
      } catch (err) {
        try { window.open(out.toDataURL(), '_blank'); }
        catch (e2) { alert('Save unavailable — try a different template.'); }
      }
    }

    function updateStatus() {
      var el = win.querySelector('[data-paint-template-name]');
      if (!el) return;
      el.textContent = state.currentTemplateName ? ('Template: ' + state.currentTemplateName) : 'For Help, click Help Topics on the Help Menu.';
    }

    /* Stack transform = pan + zoom; centered origin */
    function applyStackTransform() {
      var stack = win.querySelector('[data-stack]');
      stack.style.transformOrigin = '50% 50%';
      stack.style.transform = 'translate(' + state.panX + 'px, ' + state.panY + 'px) scale(' + state.zoom + ')';
    }

    /* Spacebar held → pan mode (Photoshop-style). Tracked globally so the
       cursor + pointer handlers can branch even mid-drag. */
    function paintIsActive() {
      return paintWindow && !paintWindow.classList.contains('minimized');
    }
    var onKeyDown = function (e) {
      if (e.code === 'Space' && !state.spaceDown && paintIsActive()) {
        state.spaceDown = true;
        e.preventDefault();
        previewCanvas.style.cursor = 'grab';
        ghost.style.display = 'none';
      }
    };
    var onKeyUp = function (e) {
      if (e.code === 'Space') {
        state.spaceDown = false;
        previewCanvas.style.cursor = '';
      }
    };
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('keyup',   onKeyUp);

    /* Ghost cursor: outlined circle that mirrors the brush footprint */
    var ghost = win.querySelector('[data-paint-ghost]');
    var GHOST_TOOLS = { brush:1, eraser:1, textured:1, spray:1, line:1, circle:1 };
    /* Brush footprint diameter in screen CSS pixels.
       Canvas stroke uses lineCap:'round' and lineWidth=state.size — so the
       round end-cap diameter is exactly state.size in canvas pixels. Scale
       to screen pixels via the canvas-to-CSS ratio. */
    function ghostDiameterPx() {
      var rect = previewCanvas.getBoundingClientRect();
      var scale = rect.width / previewCanvas.width || 1;
      var d = state.size * scale;
      if (state.tool === 'spray') d *= 2.4; /* spray covers ~1.2× radius around the pointer */
      return d;
    }
    function showGhost(clientX, clientY) {
      if (state.spaceDown || state.panning || !GHOST_TOOLS[state.tool]) {
        ghost.style.display = 'none';
        return;
      }
      var stack = win.querySelector('.paint-canvas-stack');
      var sRect = stack.getBoundingClientRect();
      /* Position is in the stack's local coordinate system. Since the stack
         may have a CSS transform (zoom/pan), we need to undo the visual
         scale when mapping clientX → local px. */
      var scaleX = sRect.width  / stack.offsetWidth  || 1;
      var scaleY = sRect.height / stack.offsetHeight || 1;
      ghost.style.display = 'block';
      ghost.style.left = ((clientX - sRect.left) / scaleX) + 'px';
      ghost.style.top  = ((clientY - sRect.top)  / scaleY) + 'px';
      /* Diameter in CSS px of the actual stroke footprint */
      var d = state.size * (stack.offsetWidth / previewCanvas.width);
      if (state.tool === 'spray') d *= 2.4;
      ghost.style.width  = d + 'px';
      ghost.style.height = d + 'px';
    }
    function hideGhost() { ghost.style.display = 'none'; }
    previewCanvas.addEventListener('pointermove', function (e) { showGhost(e.clientX, e.clientY); });
    previewCanvas.addEventListener('pointerenter', function (e) { showGhost(e.clientX, e.clientY); });
    previewCanvas.addEventListener('pointerleave', hideGhost);

    /* Keep canvas-stack square + as large as fits its wrap */
    function fitCanvasStack() {
      var wrap = win.querySelector('.paint-canvas-wrap');
      var stack = win.querySelector('.paint-canvas-stack');
      if (!wrap || !stack) return;
      var pad = 8; /* wrap padding ~ 4px each side */
      var w = wrap.clientWidth  - pad;
      var h = wrap.clientHeight - pad;
      var side = Math.max(40, Math.min(w, h));
      stack.style.width  = side + 'px';
      stack.style.height = side + 'px';
    }
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(fitCanvasStack);
      ro.observe(win);
    } else {
      window.addEventListener('resize', fitCanvasStack);
    }
    /* Initial fit (after layout) */
    setTimeout(fitCanvasStack, 0);

    /* Resize handle (desktop only — hidden on mobile via CSS) */
    var resizeHandle = win.querySelector('[data-paint-resize]');
    if (resizeHandle) {
      resizeHandle.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        var startX = e.clientX, startY = e.clientY;
        var startW = win.offsetWidth, startH = win.offsetHeight;
        try { resizeHandle.setPointerCapture(e.pointerId); } catch (_) {}
        function onMove(ev) {
          ev.preventDefault();
          var w = Math.max(420, Math.min(window.innerWidth  - 16, startW + (ev.clientX - startX)));
          var h = Math.max(480, Math.min(window.innerHeight - 48, startH + (ev.clientY - startY)));
          win.style.width  = w + 'px';
          win.style.height = h + 'px';
        }
        function onUp() {
          resizeHandle.removeEventListener('pointermove', onMove);
          resizeHandle.removeEventListener('pointerup',     onUp);
          resizeHandle.removeEventListener('pointercancel', onUp);
        }
        resizeHandle.addEventListener('pointermove', onMove);
        resizeHandle.addEventListener('pointerup',     onUp);
        resizeHandle.addEventListener('pointercancel', onUp);
      });
    }

    /* Auto-open template picker so user knows the feature exists. */
    setTimeout(openTemplatePicker, 300);
  }

  function openMinesweeper() {
    if (minesWindow) {
      minesWindow.classList.remove('minimized');
      bringToFront(minesWindow);
      return;
    }

    var ROWS = 9;
    var COLS = 9;
    var MINES = 10;
    var board = [];        // 2d array of cell objects {mine, revealed, flagged, n}
    var firstClick = true;
    var alive = true;
    var won = false;
    var flagsPlaced = 0;
    var revealedCount = 0;
    var timer = 0;
    var timerInterval = null;
    var counterEl, smileyEl, timerEl, gridEl;

    function buildBoard() {
      board = [];
      for (var r = 0; r < ROWS; r++) {
        var row = [];
        for (var c = 0; c < COLS; c++) {
          row.push({ mine: false, revealed: false, flagged: false, n: 0 });
        }
        board.push(row);
      }
    }

    function placeMines(safeR, safeC) {
      var placed = 0;
      while (placed < MINES) {
        var r = Math.floor(Math.random() * ROWS);
        var c = Math.floor(Math.random() * COLS);
        if (board[r][c].mine) continue;
        // Don't place on the first-clicked cell or its neighbors
        if (Math.abs(r - safeR) <= 1 && Math.abs(c - safeC) <= 1) continue;
        board[r][c].mine = true;
        placed++;
      }
      // Compute neighbor counts
      for (var r = 0; r < ROWS; r++) {
        for (var c = 0; c < COLS; c++) {
          if (board[r][c].mine) continue;
          var n = 0;
          for (var dr = -1; dr <= 1; dr++) {
            for (var dc = -1; dc <= 1; dc++) {
              if (dr === 0 && dc === 0) continue;
              var nr = r + dr, nc = c + dc;
              if (nr >= 0 && nr < ROWS && nc >= 0 && nc < COLS && board[nr][nc].mine) n++;
            }
          }
          board[r][c].n = n;
        }
      }
    }

    function reveal(r, c) {
      if (r < 0 || r >= ROWS || c < 0 || c >= COLS) return;
      var cell = board[r][c];
      if (cell.revealed || cell.flagged) return;
      cell.revealed = true;
      revealedCount++;
      // Flood-fill on zeros
      if (!cell.mine && cell.n === 0) {
        for (var dr = -1; dr <= 1; dr++) {
          for (var dc = -1; dc <= 1; dc++) {
            if (dr === 0 && dc === 0) continue;
            reveal(r + dr, c + dc);
          }
        }
      }
    }

    function revealAllMines() {
      for (var r = 0; r < ROWS; r++) {
        for (var c = 0; c < COLS; c++) {
          if (board[r][c].mine) board[r][c].revealed = true;
        }
      }
    }

    function checkWin() {
      // Win when all non-mine cells are revealed
      var nonMines = ROWS * COLS - MINES;
      if (revealedCount >= nonMines && alive) {
        won = true;
        alive = false;
        clearInterval(timerInterval);
        setTimeout(function () { showDiscountPopup('MINESWEEPER', 'Minesweeper'); }, 400);
      }
    }

    function startTimer() {
      if (timerInterval) return;
      timer = 0;
      updateTimerDisplay();
      timerInterval = setInterval(function () {
        if (timer < 999) timer++;
        updateTimerDisplay();
      }, 1000);
    }

    function updateTimerDisplay() {
      if (timerEl) timerEl.textContent = String(timer).padStart(3, '0');
    }

    function updateCounter() {
      if (counterEl) counterEl.textContent = String(MINES - flagsPlaced).padStart(3, '0');
    }

    function updateSmiley() {
      if (!smileyEl) return;
      if (won) smileyEl.textContent = '😎';
      else if (!alive) smileyEl.textContent = '💀';
      else smileyEl.textContent = '🙂';
    }

    function render() {
      gridEl.innerHTML = '';
      gridEl.style.gridTemplateColumns = 'repeat(' + COLS + ', 22px)';
      for (var r = 0; r < ROWS; r++) {
        for (var c = 0; c < COLS; c++) {
          var cell = board[r][c];
          var el = document.createElement('div');
          el.className = 'mines-cell';
          el.dataset.r = r;
          el.dataset.c = c;
          if (cell.revealed) {
            el.classList.add('revealed');
            if (cell.mine) {
              el.classList.add('mine');
              el.textContent = '💣';
            } else if (cell.n > 0) {
              el.textContent = cell.n;
              el.dataset.n = cell.n;
            }
          } else if (cell.flagged) {
            el.classList.add('flagged');
            el.textContent = '⚑';
          }
          gridEl.appendChild(el);
        }
      }
      updateCounter();
      updateSmiley();
    }

    function reset() {
      buildBoard();
      firstClick = true;
      alive = true;
      won = false;
      flagsPlaced = 0;
      revealedCount = 0;
      clearInterval(timerInterval);
      timerInterval = null;
      timer = 0;
      updateTimerDisplay();
      render();
    }

    // Build the window
    var win = document.createElement('div');
    win.className = 'window draggable mines-window';
    var baseX = 80, baseY = 60, step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">Minesweeper</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="window-body">' +
        '<div class="mines-frame">' +
          '<div class="mines-hud">' +
            '<div class="mines-counter" data-counter>010</div>' +
            '<button class="mines-smiley" data-smiley>🙂</button>' +
            '<div class="mines-counter" data-timer>000</div>' +
          '</div>' +
          '<div class="mines-grid" data-grid></div>' +
        '</div>' +
      '</div>';

    document.getElementById('scene-desktop').appendChild(win);
    minesWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, 'Minesweeper');

    counterEl = win.querySelector('[data-counter]');
    smileyEl  = win.querySelector('[data-smiley]');
    timerEl   = win.querySelector('[data-timer]');
    gridEl    = win.querySelector('[data-grid]');

    // Window controls
    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      clearInterval(timerInterval);
      win.remove();
      minesWindow = null;
    });
    win.querySelector('[data-action="min"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });

    // Smiley resets
    smileyEl.addEventListener('click', function (e) {
      e.stopPropagation();
      reset();
    });

    // Cell interaction (delegated)
    gridEl.addEventListener('click', function (e) {
      var cellEl = e.target.closest('.mines-cell');
      if (!cellEl || !alive) return;
      var r = parseInt(cellEl.dataset.r, 10);
      var c = parseInt(cellEl.dataset.c, 10);
      var cell = board[r][c];
      if (cell.flagged || cell.revealed) return;

      if (firstClick) {
        placeMines(r, c);
        firstClick = false;
        startTimer();
      }

      if (cell.mine) {
        cell.revealed = true;
        revealAllMines();
        alive = false;
        clearInterval(timerInterval);
      } else {
        reveal(r, c);
        checkWin();
      }
      render();
    });

    // Right-click to flag
    gridEl.addEventListener('contextmenu', function (e) {
      e.preventDefault();
      var cellEl = e.target.closest('.mines-cell');
      if (!cellEl || !alive) return;
      var r = parseInt(cellEl.dataset.r, 10);
      var c = parseInt(cellEl.dataset.c, 10);
      var cell = board[r][c];
      if (cell.revealed) return;
      if (cell.flagged) {
        cell.flagged = false;
        flagsPlaced--;
      } else {
        cell.flagged = true;
        flagsPlaced++;
      }
      render();
    });

    reset();
  }

  // ============ SPIDER SOLITAIRE ============
  var spiderWindow = null;
  function openSpiderSolitaire() {
    if (spiderWindow) {
      spiderWindow.classList.remove('minimized');
      bringToFront(spiderWindow);
      return;
    }

    var columns = [];
    var stock = [];
    var completed = 0;
    var moves = 0;
    var score = 500;             /* XP Spider scoring: start 500, -1/move, +100/run */
    var difficulty = 1;          /* 1, 2, or 4 suits */
    var undoStack = [];          /* full game snapshots for undo */
    var selected = null;
    var dragState = null;
    var ignoreNextSpiderClick = false;
    var tableEl, stockEl, completedEl, movesEl, scoreEl, messageEl;
    /* These get recomputed on every render + window resize so cards
       scale with the available column width. Defaults are the
       smallest comfortable size; real values overwritten in fitSpider(). */
    var CARD_STEP_FACE_UP = 18;
    var CARD_STEP_FACE_DOWN = 8;
    var CARD_HEIGHT = 72;
    var CARD_WIDTH = 48;
    var SUITS = ['♠', '♥', '♣', '♦'];
    var RED_SUITS = { '♥': 1, '♦': 1 };

    function cardLabel(rank) {
      if (rank === 1) return 'A';
      if (rank === 11) return 'J';
      if (rank === 12) return 'Q';
      if (rank === 13) return 'K';
      return String(rank);
    }
    function suitColor(suit) { return RED_SUITS[suit] ? 'red' : 'black'; }

    function makeDeck() {
      var deck = [];
      var id = 0;
      /* 8 sets total, distributed across N suits */
      var suitsForSets;
      if (difficulty === 1)      suitsForSets = ['♠','♠','♠','♠','♠','♠','♠','♠'];
      else if (difficulty === 2) suitsForSets = ['♠','♥','♠','♥','♠','♥','♠','♥'];
      else                       suitsForSets = ['♠','♥','♣','♦','♠','♥','♣','♦'];
      for (var set = 0; set < 8; set++) {
        var suit = suitsForSets[set];
        for (var rank = 1; rank <= 13; rank++) {
          deck.push({ id: id++, rank: rank, suit: suit, faceUp: false });
        }
      }
      for (var i = deck.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = deck[i];
        deck[i] = deck[j];
        deck[j] = tmp;
      }
      return deck;
    }

    function setMessage(text) {
      if (messageEl) messageEl.textContent = text || '';
    }

    function cardOffset(col, cardIndex) {
      var y = 0;
      for (var i = 0; i < cardIndex; i++) {
        y += col[i].faceUp ? CARD_STEP_FACE_UP : CARD_STEP_FACE_DOWN;
      }
      return y;
    }

    function canMoveRun(colIndex, cardIndex) {
      var col = columns[colIndex];
      if (!col || cardIndex < 0 || cardIndex >= col.length) return false;
      for (var i = cardIndex; i < col.length; i++) {
        if (!col[i].faceUp) return false;
        if (i > cardIndex) {
          /* Spider rule: a group can only move together if same-suit AND
             strictly descending rank. A single card always moves. */
          if (col[i].rank !== col[i - 1].rank - 1) return false;
          if (col[i].suit !== col[i - 1].suit)     return false;
        }
      }
      return true;
    }

    function canPlaceRun(run, destIndex) {
      if (!run || !run.length) return false;
      var dest = columns[destIndex];
      if (!dest || dest.length === 0) return true;
      var top = dest[dest.length - 1];
      /* Standard XP Spider rule: placement requires only rank+1, any suit.
         Same-suit only matters for group moves (canMoveRun) and for
         completing K-to-A runs (checkCompletedRuns). */
      return top.faceUp && top.rank === run[0].rank + 1;
    }

    function flipTopCard(colIndex) {
      var col = columns[colIndex];
      if (col && col.length && !col[col.length - 1].faceUp) {
        col[col.length - 1].faceUp = true;
      }
    }

    function clearSelection() {
      selected = null;
    }

    function checkCompletedRuns() {
      var changed = false;
      columns.forEach(function (col, colIndex) {
        if (col.length < 13) return;
        var start = col.length - 13;
        var suit = col[start].suit;
        for (var i = 0; i < 13; i++) {
          var card = col[start + i];
          /* Same-suit K..A required */
          if (!card.faceUp || card.rank !== 13 - i || card.suit !== suit) return;
        }
        col.splice(start, 13);
        completed++;
        score += 100;
        flipTopCard(colIndex);
        changed = true;
      });
      if (changed && completed >= 8) {
        setMessage('You cleared the table.');
        setTimeout(function () { showDiscountPopup('SOLITAIREWINNER', 'Spider Solitaire'); }, 400);
      }
    }

    /* Undo / snapshot machinery — deep-clone game state before each
       state-changing action so we can roll back. */
    function snapshotState() {
      return {
        columns:  columns.map(function (c) { return c.map(function (card) { return { id: card.id, rank: card.rank, suit: card.suit, faceUp: card.faceUp }; }); }),
        stock:    stock.map(function (card) { return { id: card.id, rank: card.rank, suit: card.suit, faceUp: card.faceUp }; }),
        completed: completed,
        moves:     moves,
        score:     score
      };
    }
    function pushUndoSnapshot() {
      undoStack.push(snapshotState());
      if (undoStack.length > 100) undoStack.shift();
    }
    function spiderUndo() {
      if (!undoStack.length) { setMessage('Nothing to undo.'); return; }
      var s = undoStack.pop();
      columns = s.columns;
      stock = s.stock;
      completed = s.completed;
      moves = s.moves;
      score = s.score;
      clearSelection();
      render();
      setMessage('Undone.');
    }

    /* Hint — find any legal move and flash the source card. Prefers
       moves that uncover a face-down card or empty a column. */
    function spiderHint() {
      var best = null;
      for (var srcCol = 0; srcCol < columns.length; srcCol++) {
        var col = columns[srcCol];
        for (var srcIdx = 0; srcIdx < col.length; srcIdx++) {
          if (!canMoveRun(srcCol, srcIdx)) continue;
          var run = col.slice(srcIdx);
          for (var dstCol = 0; dstCol < columns.length; dstCol++) {
            if (dstCol === srcCol) continue;
            if (!canPlaceRun(run, dstCol)) continue;
            /* Score the move: prefer flipping a face-down card */
            var rating = 1;
            if (srcIdx > 0 && !col[srcIdx - 1].faceUp) rating += 5;
            if (columns[dstCol].length > 0) rating += 1;
            if (!best || rating > best.rating) {
              best = { srcCol: srcCol, srcIdx: srcIdx, dstCol: dstCol, rating: rating };
            }
          }
        }
      }
      if (!best) { setMessage('No moves available — deal another row.'); return; }
      var srcEl = tableEl.querySelector('.spider-col[data-col="' + best.srcCol + '"] .spider-card[data-index="' + best.srcIdx + '"]');
      var dstEl = tableEl.querySelector('.spider-col[data-col="' + best.dstCol + '"]');
      if (srcEl) { srcEl.classList.add('hint-flash'); setTimeout(function () { srcEl.classList.remove('hint-flash'); }, 1400); }
      if (dstEl) { dstEl.classList.add('hint-flash'); setTimeout(function () { dstEl.classList.remove('hint-flash'); }, 1400); }
      setMessage('Hint shown.');
    }

    function newGame() {
      var deck = makeDeck();
      columns = Array.from({ length: 10 }, function () { return []; });
      stock = [];
      completed = 0;
      moves = 0;
      score = 500;
      undoStack = [];
      selected = null;

      for (var colIndex = 0; colIndex < 10; colIndex++) {
        var count = colIndex < 4 ? 6 : 5;
        for (var i = 0; i < count; i++) {
          var card = deck.pop();
          card.faceUp = i === count - 1;
          columns[colIndex].push(card);
        }
      }
      stock = deck.map(function (card) {
        card.faceUp = false;
        return card;
      });
      render();
      var label = difficulty === 1 ? 'One Suit' : difficulty === 2 ? 'Two Suits' : 'Four Suits';
      setMessage('New game — ' + label + '. Build King-to-Ace same-suit runs.');
    }

    function dealRow() {
      if (stock.length < 10) {
        setMessage('No more cards in the stock.');
        return;
      }
      if (columns.some(function (col) { return col.length === 0; })) {
        setMessage('Fill empty spaces before dealing.');
        return;
      }
      pushUndoSnapshot();
      for (var i = 0; i < 10; i++) {
        var card = stock.pop();
        card.faceUp = true;
        columns[i].push(card);
      }
      moves++;
      score = Math.max(0, score - 1);
      clearSelection();
      checkCompletedRuns();
      render();
      setMessage('Dealt one row.');
    }

    function selectRun(colIndex, cardIndex) {
      if (!canMoveRun(colIndex, cardIndex)) {
        setMessage('Only complete descending face-up runs can move.');
        return;
      }
      selected = { col: colIndex, index: cardIndex };
      render();
      setMessage('Choose where to move the stack.');
    }

    function moveSelected(destIndex) {
      if (!selected) return false;
      if (destIndex === selected.col) {
        clearSelection();
        render();
        setMessage('');
        return true;
      }
      var source = columns[selected.col];
      var run = source.slice(selected.index);
      if (!canPlaceRun(run, destIndex)) {
        setMessage('That stack cannot go there.');
        return false;
      }
      pushUndoSnapshot();
      columns[destIndex] = columns[destIndex].concat(run);
      source.splice(selected.index);
      flipTopCard(selected.col);
      moves++;
      score = Math.max(0, score - 1);
      clearSelection();
      checkCompletedRuns();
      render();
      if (completed >= 8) setMessage('You won Spider Solitaire.');
      else setMessage('');
      return true;
    }

    function columnFromPoint(x, y) {
      var el = document.elementFromPoint(x, y);
      var colEl = el && el.closest ? el.closest('.spider-col') : null;
      if (!colEl || !tableEl || !tableEl.contains(colEl)) return null;
      return parseInt(colEl.dataset.col, 10);
    }

    function removeDragTargetHighlights() {
      if (!tableEl) return;
      tableEl.querySelectorAll('.spider-col.drag-target').forEach(function (el) {
        el.classList.remove('drag-target');
      });
    }

    function updateDragTarget(x, y) {
      removeDragTargetHighlights();
      var colIndex = columnFromPoint(x, y);
      if (colIndex === null || !selected) return;
      var colEl = tableEl.querySelector('.spider-col[data-col="' + colIndex + '"]');
      var run = columns[selected.col].slice(selected.index);
      if (colEl && canPlaceRun(run, colIndex)) colEl.classList.add('drag-target');
    }

    function createDragGhost(run) {
      var ghost = document.createElement('div');
      ghost.className = 'spider-drag-ghost';
      run.forEach(function (card, i) {
        var cardEl = document.createElement('div');
        cardEl.className = 'spider-ghost-card spider-card';
        cardEl.dataset.color = suitColor(card.suit);
        cardEl.dataset.suit  = card.suit;
        cardEl.style.top = (i * CARD_STEP_FACE_UP) + 'px';
        cardEl.style.zIndex = String(i + 1);
        cardEl.innerHTML = cardFaceHTML(card);
        ghost.appendChild(cardEl);
      });
      document.body.appendChild(ghost);
      return ghost;
    }

    function beginSpiderDrag(e, cardEl) {
      if (e.button !== 0) return;
      var colIndex = parseInt(cardEl.dataset.col, 10);
      var cardIndex = parseInt(cardEl.dataset.index, 10);
      if (!canMoveRun(colIndex, cardIndex)) return;

      dragState = {
        col: colIndex,
        index: cardIndex,
        startX: e.clientX,
        startY: e.clientY,
        offsetX: 21,
        offsetY: 12,
        dragging: false,
        ghost: null
      };

      function onMove(moveEvent) {
        if (!dragState) return;
        var dx = Math.abs(moveEvent.clientX - dragState.startX);
        var dy = Math.abs(moveEvent.clientY - dragState.startY);
        if (!dragState.dragging && dx + dy > 5) {
          var run = columns[dragState.col].slice(dragState.index);
          selected = { col: dragState.col, index: dragState.index };
          dragState.ghost = createDragGhost(run);
          dragState.dragging = true;
          render();
          setMessage('Drop the stack onto a matching card.');
        }
        if (dragState.dragging && dragState.ghost) {
          moveEvent.preventDefault();
          dragState.ghost.style.left = (moveEvent.clientX - dragState.offsetX) + 'px';
          dragState.ghost.style.top = (moveEvent.clientY - dragState.offsetY) + 'px';
          updateDragTarget(moveEvent.clientX, moveEvent.clientY);
        }
      }

      function onUp(upEvent) {
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        removeDragTargetHighlights();
        if (!dragState) return;
        if (dragState.dragging) {
          ignoreNextSpiderClick = true;
          var destIndex = columnFromPoint(upEvent.clientX, upEvent.clientY);
          if (destIndex !== null) moveSelected(destIndex);
          else {
            clearSelection();
            render();
            setMessage('');
          }
        }
        if (dragState.ghost) dragState.ghost.remove();
        dragState = null;
      }

      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
    }

    function renderStock() {
      if (!stockEl) return;
      stockEl.innerHTML = '';
      var dealsLeft = Math.floor(stock.length / 10);
      for (var i = 0; i < Math.min(dealsLeft, 5); i++) {
        var stack = document.createElement('span');
        stack.className = 'spider-stock-card';
        stack.style.left = (i * 7) + 'px';
        stockEl.appendChild(stack);
      }
      stockEl.title = dealsLeft + ' deals left';
      if (completedEl) completedEl.textContent = 'Completed: ' + completed + '/8';
      if (movesEl)     movesEl.textContent     = 'Moves: ' + moves;
      if (scoreEl)     scoreEl.textContent     = 'Score: ' + score;
    }

    /* Build the inner HTML of a face-up card — XP-style corners
       (rank + suit, top-left & rotated bottom-right) + a big centered
       suit (or court letter for J/Q/K). */
    function cardFaceHTML(card) {
      var lab = cardLabel(card.rank);
      var center = (card.rank >= 11) ? lab : card.suit;
      return (
        '<span class="spider-corner spider-corner-tl">' +
          '<span class="spider-card-rank">' + lab + '</span>' +
          '<span class="spider-card-suit">' + card.suit + '</span>' +
        '</span>' +
        '<span class="spider-card-center">' + center + '</span>' +
        '<span class="spider-corner spider-corner-br">' +
          '<span class="spider-card-rank">' + lab + '</span>' +
          '<span class="spider-card-suit">' + card.suit + '</span>' +
        '</span>'
      );
    }
    var SUIT_NAME = { '♠': 'spades', '♥': 'hearts', '♣': 'clubs', '♦': 'diamonds' };

    function render() {
      if (!tableEl) return;
      fitSpiderCards();
      tableEl.innerHTML = '';
      columns.forEach(function (col, colIndex) {
        var colEl = document.createElement('div');
        colEl.className = 'spider-col';
        colEl.dataset.col = colIndex;
        /* Column reserves space for the card stack; floor at one
           card height so empty columns still show their dashed slot. */
        var colMinEmpty = CARD_HEIGHT + 16;
        var colHeight = col.length ? cardOffset(col, col.length - 1) + CARD_HEIGHT + 12 : colMinEmpty;
        colEl.style.minHeight = Math.max(colMinEmpty, colHeight) + 'px';
        if (selected && canPlaceRun(columns[selected.col].slice(selected.index), colIndex)) {
          colEl.classList.add('is-target');
        }
        col.forEach(function (card, cardIndex) {
          var cardEl = document.createElement('button');
          cardEl.type = 'button';
          cardEl.className = 'spider-card';
          cardEl.dataset.col = colIndex;
          cardEl.dataset.index = cardIndex;
          cardEl.style.top = cardOffset(col, cardIndex) + 'px';
          cardEl.style.zIndex = String(cardIndex + 1);
          if (!card.faceUp) {
            cardEl.classList.add('face-down');
            cardEl.setAttribute('aria-label', 'Face down card');
          } else {
            cardEl.dataset.color = suitColor(card.suit);
            cardEl.dataset.suit  = card.suit;
            cardEl.innerHTML = cardFaceHTML(card);
            cardEl.setAttribute('aria-label', cardLabel(card.rank) + ' of ' + (SUIT_NAME[card.suit] || ''));
          }
          if (selected && selected.col === colIndex && cardIndex >= selected.index) {
            cardEl.classList.add('selected');
          }
          colEl.appendChild(cardEl);
        });
        tableEl.appendChild(colEl);
      });
      renderStock();
    }

    /* Card dimensions follow column width × 5:7 (playing-card aspect).
       Stack offsets are a fixed % of card height so the visual rhythm
       stays consistent at any window size. */
    function fitSpiderCards() {
      if (!tableEl) return;
      var firstCol = tableEl.querySelector('.spider-col');
      var colW = firstCol ? firstCol.clientWidth : 0;
      if (!colW) return;
      var cw = Math.max(34, colW - 4);
      var ch = Math.round(cw * 7 / 5);
      CARD_WIDTH          = cw;
      CARD_HEIGHT         = ch;
      CARD_STEP_FACE_UP   = Math.max(14, Math.round(ch * 0.26));
      CARD_STEP_FACE_DOWN = Math.max(6,  Math.round(ch * 0.11));
      tableEl.style.setProperty('--spider-card-w', cw + 'px');
      tableEl.style.setProperty('--spider-card-h', ch + 'px');
    }

    var win = document.createElement('div');
    win.className = 'window draggable spider-window';
    var baseX = 120, baseY = 64, step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step, width: 720, height: 600 });

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">Spider Solitaire</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="window-body spider-body">' +
        '<div class="spider-toolbar">' +
          '<button type="button" data-spider-new>New Game</button>' +
          '<button type="button" data-spider-deal>Deal</button>' +
          '<button type="button" data-spider-undo>Undo</button>' +
          '<button type="button" data-spider-hint>Hint</button>' +
          '<span class="spider-difficulty">' +
            '<span class="spider-diff-label">Suits:</span>' +
            '<button type="button" data-spider-diff="1" class="is-active">1</button>' +
            '<button type="button" data-spider-diff="2">2</button>' +
            '<button type="button" data-spider-diff="4">4</button>' +
          '</span>' +
          '<div class="spider-stock" data-spider-stock aria-label="Stock pile"></div>' +
          '<span class="spider-status" data-spider-score>Score: 500</span>' +
          '<span class="spider-status" data-spider-completed>Completed: 0/8</span>' +
          '<span class="spider-status" data-spider-moves>Moves: 0</span>' +
        '</div>' +
        '<div class="spider-table" data-spider-table></div>' +
        '<div class="spider-message" data-spider-message></div>' +
      '</div>' +
      '<div class="spider-resize-handle" data-spider-resize aria-label="Resize" title="Drag to resize"></div>';

    document.getElementById('scene-desktop').appendChild(win);
    spiderWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, 'Spider Solitaire');

    tableEl = win.querySelector('[data-spider-table]');
    stockEl = win.querySelector('[data-spider-stock]');
    completedEl = win.querySelector('[data-spider-completed]');
    movesEl = win.querySelector('[data-spider-moves]');
    scoreEl = win.querySelector('[data-spider-score]');
    messageEl = win.querySelector('[data-spider-message]');

    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.remove();
      spiderWindow = null;
    });
    win.querySelector('[data-action="min"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });
    win.querySelector('[data-spider-new]').addEventListener('click', function (e) {
      e.stopPropagation();
      newGame();
    });
    win.querySelector('[data-spider-deal]').addEventListener('click', function (e) {
      e.stopPropagation();
      dealRow();
    });
    win.querySelector('[data-spider-undo]').addEventListener('click', function (e) {
      e.stopPropagation();
      spiderUndo();
    });
    win.querySelector('[data-spider-hint]').addEventListener('click', function (e) {
      e.stopPropagation();
      spiderHint();
    });
    win.querySelectorAll('[data-spider-diff]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        difficulty = parseInt(btn.dataset.spiderDiff, 10) || 1;
        win.querySelectorAll('[data-spider-diff]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        newGame();
      });
    });
    stockEl.addEventListener('click', function (e) {
      e.stopPropagation();
      dealRow();
    });
    tableEl.addEventListener('pointerdown', function (e) {
      var cardEl = e.target.closest('.spider-card');
      if (!cardEl) return;
      e.stopPropagation();
      beginSpiderDrag(e, cardEl);
    });
    tableEl.addEventListener('click', function (e) {
      e.stopPropagation();
      if (ignoreNextSpiderClick) {
        ignoreNextSpiderClick = false;
        return;
      }
      var cardEl = e.target.closest('.spider-card');
      var colEl = e.target.closest('.spider-col');
      if (!colEl) return;
      var colIndex = parseInt(colEl.dataset.col, 10);
      if (selected && (!cardEl || colIndex !== selected.col)) {
        moveSelected(colIndex);
        return;
      }
      if (!cardEl) {
        if (selected) moveSelected(colIndex);
        return;
      }
      var cardIndex = parseInt(cardEl.dataset.index, 10);
      if (selected && selected.col !== colIndex) {
        moveSelected(colIndex);
        return;
      }
      selectRun(colIndex, cardIndex);
    });

    /* Resize handle — drag bottom-right to grow the window. Cards
       scale via fitSpiderCards on each render. */
    var spiderResize = win.querySelector('[data-spider-resize]');
    if (spiderResize) {
      spiderResize.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        var startX = e.clientX, startY = e.clientY;
        var startW = win.offsetWidth, startH = win.offsetHeight;
        try { spiderResize.setPointerCapture(e.pointerId); } catch (_) {}
        function onMove(ev) {
          ev.preventDefault();
          var w = Math.max(520, Math.min(window.innerWidth  - 16, startW + (ev.clientX - startX)));
          var h = Math.max(420, Math.min(window.innerHeight - 48, startH + (ev.clientY - startY)));
          win.style.width  = w + 'px';
          win.style.height = h + 'px';
        }
        function onUp() {
          spiderResize.removeEventListener('pointermove', onMove);
          spiderResize.removeEventListener('pointerup',     onUp);
          spiderResize.removeEventListener('pointercancel', onUp);
        }
        spiderResize.addEventListener('pointermove', onMove);
        spiderResize.addEventListener('pointerup',     onUp);
        spiderResize.addEventListener('pointercancel', onUp);
      });
    }
    /* Auto-rescale cards whenever the window changes size */
    if (window.ResizeObserver) {
      var spiderRO = new ResizeObserver(function () { render(); });
      spiderRO.observe(win);
    } else {
      window.addEventListener('resize', function () { render(); });
    }

    newGame();
  }

  // ============ NOTEPAD (suggestions box) ============
  var notepadWindow = null;
  var notepadDeleted = false;
  var notepadDraft = '';

  function openNotepad() {
    if (notepadDeleted) {
      restoreNotepad();
    }
    if (notepadWindow) {
      notepadWindow.classList.remove('minimized');
      bringToFront(notepadWindow);
      return;
    }

    var win = document.createElement('div');
    win.className = 'window draggable notepad-window';

    var baseX = 100, baseY = 70, step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">SUGGEST.TXT — Notepad</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="notepad-menubar">' +
        '<button>File</button>' +
        '<button>Edit</button>' +
        '<button>Format</button>' +
        '<button>View</button>' +
        '<button>Help</button>' +
      '</div>' +
      '<div class="notepad-area">' +
        '<input type="email" class="notepad-email" placeholder="your@email.com (so we can reply)" ' +
          'style="display:block;width:100%;box-sizing:border-box;margin-bottom:4px;padding:4px 6px;' +
          'font-family:inherit;font-size:12px;border:1px solid #000;background:#fff;' +
          'box-shadow:inset 1px 1px 0 #808080;"/>' +
        '<textarea class="notepad-textarea" placeholder="Type your suggestion. We read all of them.">' +
          escapeHtml(notepadDraft) +
        '</textarea>' +
      '</div>' +
      '<div class="notepad-actions">' +
        '<button data-action="cancel" style="min-width:80px;padding:5px 14px;font-size:11px;">Cancel</button>' +
        '<button data-action="submit" style="min-width:90px;padding:5px 14px;font-size:11px;font-weight:bold;">Submit</button>' +
      '</div>' +
      '<div class="notepad-statusbar">' +
        '<span data-status-pos>Ln 1, Col 1</span>' +
        '<span>To: admin@' + effnEscapeAttr(String(effnBrandShort()).toLowerCase().replace(/\s+/g, '')) + '</span>' +
      '</div>';

    document.getElementById('scene-desktop').appendChild(win);
    notepadWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, 'SUGGEST.TXT');

    var ta = win.querySelector('.notepad-textarea');
    var pos = win.querySelector('[data-status-pos]');
    function updatePos() {
      var v = ta.value.substring(0, ta.selectionStart);
      var lines = v.split('\n');
      pos.textContent = 'Ln ' + lines.length + ', Col ' + (lines[lines.length - 1].length + 1);
    }
    ta.addEventListener('keyup', updatePos);
    ta.addEventListener('click', updatePos);
    ta.addEventListener('input', function () { notepadDraft = ta.value; });
    setTimeout(function () { ta.focus(); }, 50);

    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.remove();
      notepadWindow = null;
    });
    win.querySelector('[data-action="min"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });
    win.querySelector('[data-action="cancel"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.remove();
      notepadWindow = null;
    });
    win.querySelector('[data-action="submit"]').addEventListener('click', function (e) {
      e.stopPropagation();
      var emailInput = win.querySelector('.notepad-email');
      submitNotepad(ta.value, emailInput ? emailInput.value : '');
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c];
    });
  }

  function showNotepadWarning(message) {
    var win = popupShell('Notepad', 340);
    win.style.left = '50%';
    win.style.top  = '40%';
    win.style.transform = 'translate(-50%, -50%)';
    win.innerHTML +=
      '<div class="window-body" style="padding:16px;display:flex;gap:12px;align-items:center;">' +
        '<div class="warn-glyph"></div>' +
        '<div style="font-size:12px;line-height:1.5;flex:1;">' + effnEscapeAttr(message) + '</div>' +
      '</div>' +
      '<div style="text-align:right;padding:0 14px 14px;">' +
        '<button data-action="close" style="min-width:72px;padding:5px 14px;font-size:11px;">OK</button>' +
      '</div>';
    document.getElementById('scene-desktop').appendChild(win);
    makeDraggable(win);
    bringToFront(win);
    wirePopupClose(win);
  }

  function submitNotepad(text, email) {
    if (!text || !text.trim()) {
      showNotepadWarning('Empty suggestion. Type something first.');
      return;
    }
    var emailTrim = String(email || '').trim();
    if (!emailTrim || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailTrim)) {
      showNotepadWarning('Add an email so we can write back.');
      return;
    }

    // Fire-and-forget POST to Shopify's contact form endpoint — Shopify
    // emails this to the address set in admin → Settings → Notifications →
    // "Customer contact" form sender. Local stash kept as a fallback.
    try {
      var queue = JSON.parse(localStorage.getItem('effn_suggestions') || '[]');
      queue.push({ text: text, email: emailTrim, at: new Date().toISOString() });
      localStorage.setItem('effn_suggestions', JSON.stringify(queue));
    } catch (e) {}

    try {
      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '✓');
      fd.append('contact[email]', emailTrim);
      fd.append('contact[subject]', 'SUGGEST.TXT submission');
      fd.append('contact[body]', text);
      fetch('/contact#contact_form', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      });
    } catch (e) {}

    notepadDraft = '';
    if (notepadWindow) {
      notepadWindow.querySelector('.notepad-area').innerHTML =
        '<div style="padding:48px 24px;text-align:center;font-size:13px;line-height:1.5;">' +
          '<div style="font-size:36px;line-height:1;margin-bottom:10px;">✓</div>' +
          '<strong>Submitted.</strong><br>' +
          '<span style="color:#444;font-size:11px;">We read all of them.</span>' +
        '</div>';
      notepadWindow.querySelector('.notepad-actions').innerHTML =
        '<button data-action="close-after-submit" style="min-width:80px;padding:5px 14px;font-size:11px;">Close</button>';
      notepadWindow.querySelector('[data-action="close-after-submit"]').addEventListener('click', function () {
        if (notepadWindow) {
          notepadWindow.remove();
          notepadWindow = null;
        }
      });
    }
  }

  // WMO easter egg: dragging WMO to the trash flips the whole site into
  // "broken LCD" mode. Restoring WMO from trash undoes it.
  var wmoDeleted = false;
  function setBrokenLcdMode(on) {
    document.body.classList.toggle('effn-broken-lcd', !!on);
    var layers = ['effn-lcd-pixels', 'effn-lcd-tear', 'effn-lcd-blobs'];
    layers.forEach(function (cls) {
      var el = document.querySelector('.' + cls);
      if (on) {
        if (!el) {
          el = document.createElement('div');
          el.className = cls;
          document.body.appendChild(el);
        }
      } else if (el) {
        el.remove();
      }
    });
  }
  function deleteWMO() {
    wmoDeleted = true;
    var iconEl = document.querySelector('.icon-wmo');
    if (iconEl) iconEl.classList.add('deleted');
    setBrokenLcdMode(true);
    updateTrashIconState();
    if (trashWindow) renderTrashContents();
  }
  function restoreWMO() {
    wmoDeleted = false;
    var iconEl = document.querySelector('.icon-wmo');
    if (iconEl) {
      iconEl.classList.remove('deleted');
      iconEl.style.left = '';
      iconEl.style.top = '';
      iconEl.style.right = '';
      iconEl.style.bottom = '';
    }
    setBrokenLcdMode(false);
    updateTrashIconState();
    if (trashWindow) renderTrashContents();
  }

  function updateTrashIconState() {
    var trashEl = document.querySelector('.icon-trash');
    if (!trashEl) return;
    if (notepadDeleted || wmoDeleted) trashEl.classList.add('has-items');
    else trashEl.classList.remove('has-items');
  }

  function deleteNotepad() {
    notepadDeleted = true;
    var iconEl = document.querySelector('.icon-notepad');
    if (iconEl) iconEl.classList.add('deleted');
    if (notepadWindow) {
      notepadWindow.remove();
      notepadWindow = null;
    }
    updateTrashIconState();
    if (trashWindow) renderTrashContents();
  }

  function restoreNotepad() {
    notepadDeleted = false;
    var iconEl = document.querySelector('.icon-notepad');
    if (iconEl) {
      iconEl.classList.remove('deleted');
      // Clear inline drag overrides so it returns to the CSS default position
      iconEl.style.left = '';
      iconEl.style.top = '';
      iconEl.style.right = '';
      iconEl.style.bottom = '';
    }
    updateTrashIconState();
    if (trashWindow) renderTrashContents();
  }

  // Generic free-drag for desktop icons; supports drop-on-bin
  function makeIconFreeDraggable(icon, options) {
    options = options || {};
    var dragging = false, started = false;
    var ox = 0, oy = 0, sx = 0, sy = 0;
    var pointerId = null;
    var longPressTimer = null;
    var LONG_PRESS_MS = 450;
    var isTouchInput = false;

    function isMobileViewport() {
      return (window.innerWidth || document.documentElement.clientWidth) <= 640;
    }

    function startDrag() {
      dragging = true;
      icon.classList.add('dragging');
      if (navigator.vibrate) { try { navigator.vibrate(20); } catch (_) {} }
    }

    icon.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      var r = icon.getBoundingClientRect();
      ox = e.clientX - r.left;
      oy = e.clientY - r.top;
      sx = e.clientX;
      sy = e.clientY;
      pointerId = e.pointerId;
      started = false;
      isTouchInput = (e.pointerType === 'touch') || isMobileViewport();

      if (isTouchInput) {
        /* Mobile: long-press unlocks drag mode. Tap-and-release does
           nothing (regular click goes through). Movement before timeout
           cancels — that's a scroll gesture. */
        longPressTimer = setTimeout(function () {
          longPressTimer = null;
          startDrag();
        }, LONG_PRESS_MS);
      } else {
        /* Desktop: any mousedown starts a potential drag (after threshold). */
        dragging = true;
      }
    });

    document.addEventListener('pointermove', function (e) {
      if (pointerId !== null && e.pointerId !== pointerId) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      var moved = dx * dx + dy * dy;

      /* Touch: any meaningful movement before long-press fires cancels
         drag intent so the page can scroll naturally. */
      if (longPressTimer && moved > 64) {
        clearTimeout(longPressTimer);
        longPressTimer = null;
        pointerId = null;
        return;
      }

      if (!dragging) return;
      if (!started) {
        if (moved < 16 && !isTouchInput) return; /* 4px threshold for mouse */
        started = true;
      }
      e.preventDefault();

      var parent = icon.offsetParent || document.body;
      var pr = parent.getBoundingClientRect();
      var x = e.clientX - pr.left - ox;
      var y = e.clientY - pr.top  - oy;
      x = Math.max(0, Math.min(x, parent.clientWidth - 70));
      y = Math.max(0, Math.min(y, parent.clientHeight - 90));
      icon.style.setProperty('left',   x + 'px', 'important');
      icon.style.setProperty('top',    y + 'px', 'important');
      icon.style.setProperty('right',  'auto', 'important');
      icon.style.setProperty('bottom', 'auto', 'important');

      if (options.binSelector) {
        var bin = document.querySelector(options.binSelector);
        if (bin) {
          var br = bin.getBoundingClientRect();
          var hover = e.clientX >= br.left && e.clientX <= br.right &&
                      e.clientY >= br.top  && e.clientY <= br.bottom;
          bin.classList.toggle('drop-target', hover);
        }
      }
    }, { passive: false });

    document.addEventListener('pointerup', function (e) {
      if (pointerId !== null && e.pointerId !== pointerId) return;
      if (longPressTimer) { clearTimeout(longPressTimer); longPressTimer = null; }
      if (!dragging) { pointerId = null; return; }
      dragging = false;
      var didMove = started;
      started = false;
      icon.classList.remove('dragging');
      if (options.binSelector) {
        var bin = document.querySelector(options.binSelector);
        if (bin) {
          bin.classList.remove('drop-target');
          if (didMove) {
            var br = bin.getBoundingClientRect();
            var hover = e.clientX >= br.left && e.clientX <= br.right &&
                        e.clientY >= br.top  && e.clientY <= br.bottom;
            if (hover && typeof options.onDropOnBin === 'function') {
              options.onDropOnBin();
            }
          }
        }
      }
      pointerId = null;
    });

    document.addEventListener('pointercancel', function () {
      if (longPressTimer) { clearTimeout(longPressTimer); longPressTimer = null; }
      if (dragging) {
        dragging = false;
        icon.classList.remove('dragging');
      }
      pointerId = null;
    });
  }

  // Wire up notepad icon free-drag
  (function () {
    var iconEl = document.querySelector('.icon-notepad');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {
        binSelector: '.icon-trash',
        onDropOnBin: deleteNotepad
      });
    }
  })();

  // Wire up EFFN_CD_MIX icon free-drag (no bin behavior — not deletable)
  (function () {
    var iconEl = document.querySelector('.icon-cdmix');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {});
    }
  })();

  // Wire up VIDEO icon free-drag
  (function () {
    var iconEl = document.querySelector('.icon-video');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {});
    }
  })();

  // Wire up PHOTOS icon free-drag
  (function () {
    var iconEl = document.querySelector('.icon-photos');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {});
    }
  })();

  // Wire up INTERNET icon free-drag
  (function () {
    var iconEl = document.querySelector('.icon-internet');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {});
    }
  })();

  // Wire up WMO icon free-drag (drop-on-trash triggers broken-LCD mode)
  (function () {
    var iconEl = document.querySelector('.icon-wmo');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {
        binSelector: '.icon-trash',
        onDropOnBin: deleteWMO
      });
    }
  })();

  // Wire up Customer Support icon free-drag
  (function () {
    var iconEl = document.querySelector('.icon-support');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {});
    }
  })();

  // Wire up Minesweeper icon free-drag
  (function () {
    var iconEl = document.querySelector('.icon-game-mines');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {});
    }
  })();

  // Wire up Spider Solitaire icon free-drag
  (function () {
    var iconEl = document.querySelector('.icon-game-spider');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {});
    }
  })();

  // Wire up DO NOT CLICK!!! icon free-drag
  (function () {
    var iconEl = document.querySelector('.icon-danger');
    if (iconEl) {
      makeIconFreeDraggable(iconEl, {});
    }
  })();

  // ============ DO NOT CLICK virus spam ============
  // Click DO NOT CLICK!!! → spawns 10 ad-style popups. Closing one spawns 2.
  // Click Mines (single click) → cancels the whole cascade.
  // Body gets `.virus-spam-active` while running so the Mines label rainbows.
  var spamActive = false;
  var spamPopups = [];
  var SPAM_AUDIO_CTX = null;

  function playPopupSound() {
    try {
      if (!SPAM_AUDIO_CTX) {
        var Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return;
        SPAM_AUDIO_CTX = new Ctx();
      }
      var ctx = SPAM_AUDIO_CTX;
      var t = ctx.currentTime;
      // Two-tone Win98-style alert chirp, slight random pitch per popup
      var f1 = 880  + (Math.random() - 0.5) * 200;
      var f2 = 1320 + (Math.random() - 0.5) * 200;
      function chirp(freq, start, dur) {
        var osc  = ctx.createOscillator();
        var gain = ctx.createGain();
        osc.type = 'square';
        osc.frequency.setValueAtTime(freq, start);
        gain.gain.setValueAtTime(0, start);
        gain.gain.linearRampToValueAtTime(0.08, start + 0.005);
        gain.gain.exponentialRampToValueAtTime(0.001, start + dur);
        osc.connect(gain).connect(ctx.destination);
        osc.start(start);
        osc.stop(start + dur);
      }
      chirp(f1, t,        0.06);
      chirp(f2, t + 0.05, 0.10);
    } catch (e) { /* ignore */ }
  }

  // Ad templates — custom blocks first, default 90s-style variants otherwise.
  var AD_TEMPLATES = (Array.isArray(window.EFFN_SPAM_POPUPS) && window.EFFN_SPAM_POPUPS.length) ? window.EFFN_SPAM_POPUPS : [
    {
      title:'GET_RICH.EXE', bg:'popup-ad-bg-1', headline:'CONGRATULATIONS!!!',
      sub:'You have been chosen to receive a <strong>FREE Gateway PC</strong>.<br>One in a million qualified.',
      badge:'FREE!', cta:'CLICK HERE TO CLAIM →'
    },
    {
      title:'SWEEPSTAKES.HTM', bg:'popup-ad-bg-2', headline:'WIN $11,000!!!',
      sub:'Enter our daily sweepstakes.<br>No purchase necessary.',
      badge:'WIN!', cta:'ENTER NOW'
    },
    {
      title:'BEFORE_U_GO.EXE', bg:'popup-ad-bg-3', headline:'BEFORE YOU GO!',
      sub:'Did you know you can add <strong>' + effnEscapeAttr(effnBrandShort()) + '+ Broadband</strong> to any drop access plan?<br>Save up to 70%.',
      badge:'70% OFF', cta:'GET A FREE TRIAL'
    },
    {
      title:'SAVINGS.HTM', bg:'popup-ad-bg-4', headline:'ARE YOU PAYING TOO MUCH?',
      sub:'New rates on streetwear insurance.<br>Drop coverage in 60 seconds.',
      badge:'NEW!', cta:'GET MY QUOTE'
    },
    {
      title:'WhatsNew.exe', bg:'popup-ad-bg-5', headline:'SCIENCE PROVES IT',
      sub:'• Tour Tee causes glow-ups<br>• Teen girls beware<br>• Click to see what your bag is missing',
      badge:'NEW!', cta:'READ MORE!'
    },
    {
      title:'DROP_ALERT.EXE', bg:'popup-ad-bg-6', headline:'15 FREE GIFTS',
      sub:'Plus <strong>2 risk-free issues</strong> of ' + effnEscapeAttr(effnBrandShort()) + ' MAGAZINE.<br>Limited time only.',
      badge:'FREE×15', cta:'YES! SIGN ME UP'
    }
  ];

  function spawnSpamPopup() {
    if (!spamActive) return;
    var ad = AD_TEMPLATES[Math.floor(Math.random() * AD_TEMPLATES.length)];
    var popupWidth = Math.max(260, Math.min(parseInt(ad.width || 340, 10) || 340, 720));
    var win = popupShell(ad.title, popupWidth);
    var deskScene = document.getElementById('scene-desktop');
    var maxX = Math.max(40, (deskScene ? deskScene.clientWidth  : 800) - (popupWidth + 20));
    var maxY = Math.max(40, (deskScene ? deskScene.clientHeight : 600) - 240);
    win.style.left = Math.floor(Math.random() * maxX) + 'px';
    win.style.top  = Math.floor(Math.random() * maxY) + 'px';
    win.dataset.spam = '1';
    /* Conditionally render each part. Empty fields render nothing —
       no auto-fill defaults. bg="none" (or empty) drops the colored
       gradient so image + button can stand alone. */
    var bgClass = (ad.bg && ad.bg !== 'none') ? ad.bg : '';
    var headlineText = (ad.headline || '').trim();
    var subText      = (ad.sub      || '').trim();
    var badgeText    = (ad.badge    || '').trim();
    var ctaText      = (ad.cta      || '').trim();
    win.innerHTML +=
      '<div class="popup-ad ' + effnEscapeAttr(bgClass) + (bgClass ? '' : ' popup-ad-plain') + '">' +
        (ad.image ? '<div class="popup-ad-image popup-ad-image-natural"><img src="' + effnEscapeAttr(ad.image) + '" alt=""></div>' : '') +
        (headlineText ? '<div class="popup-ad-headline">' + effnEscapeAttr(headlineText) + '</div>' : '') +
        (subText      ? '<div class="popup-ad-sub">' + effnEscapeAttr(subText).replace(/\n/g, '<br>') + '</div>' : '') +
        (badgeText    ? '<div class="popup-ad-badge tr">' + effnEscapeAttr(badgeText) + '</div>' : '') +
        (ctaText      ? '<button class="popup-ad-cta" data-action="close">' + effnEscapeAttr(ctaText) + '</button>' : '<button class="popup-ad-close-fallback" data-action="close" aria-label="Close">×</button>') +
      '</div>';
    document.getElementById('scene-desktop').appendChild(win);
    makeDraggable(win);
    bringToFront(win);
    playPopupSound();

    function closeAndSpawn(e) {
      if (e) e.stopPropagation();
      var idx = spamPopups.indexOf(win);
      if (idx >= 0) spamPopups.splice(idx, 1);
      win.remove();
      if (spamActive) {
        spawnSpamPopup();
        spawnSpamPopup();
      }
    }
    win.querySelectorAll('[data-action="close"]').forEach(function (btn) {
      btn.addEventListener('click', closeAndSpawn);
    });
    spamPopups.push(win);
  }

  function startVirusSpam() {
    if (spamActive) return;
    spamActive = true;
    document.body.classList.add('virus-spam-active');
    for (var i = 0; i < 10; i++) {
      (function (n) { setTimeout(spawnSpamPopup, n * 80); })(i);
    }
  }

  function cancelVirusSpam() {
    spamActive = false;
    document.body.classList.remove('virus-spam-active');
    spamPopups.forEach(function (w) { try { w.remove(); } catch (e) {} });
    spamPopups = [];
  }

  // DO NOT CLICK!!! dblclick → start spam; single-click on Mines while spam active → cancel
  (function () {
    var dangerIcon = document.querySelector('.icon-danger');
    if (dangerIcon) {
      dangerIcon.addEventListener('dblclick', function (e) {
        e.stopPropagation();
        startVirusSpam();
      });
    }
    var minesIcon = document.querySelector('.icon-game-mines');
    if (minesIcon) {
      minesIcon.addEventListener('click', function (e) {
        if (spamActive || spamPopups.length > 0) {
          e.stopPropagation();
          cancelVirusSpam();
        }
      });
    }
  })();

  // ============ DISPLAY PROPERTIES (Change Background) ============
  // Built-in background presets plus packaged Win98-style wallpapers.
  function effnBgUrl(src) {
    return src ? "url('" + String(src).replace(/'/g, '%27') + "')" : 'none';
  }
  var BG_ASSETS = window.EFFN_BACKGROUND_ASSETS || {};
  var BG_PRESETS = {
    'default': { label: 'Default Teal', value: '#008080', thumb: '#008080' },
    'navy':    { label: 'Win Navy',     value: '#3a6691', thumb: '#3a6691' },
    'magenta': { label: 'Hot Pink',     value: '#c0258a', thumb: '#c0258a' },
    'black':   { label: 'Black',        value: '#000',    thumb: '#000' },
    'effn1':   { label: 'EFFN BG 1',    value: effnBgUrl(BG_ASSETS.bg01), thumb: '#008080 ' + effnBgUrl(BG_ASSETS.bg01) + ' center/cover no-repeat' },
    'effn2':   { label: 'EFFN BG 2',    value: effnBgUrl(BG_ASSETS.bg02), thumb: '#008080 ' + effnBgUrl(BG_ASSETS.bg02) + ' center/cover no-repeat' },
    'effn3':   { label: 'EFFN BG 3',    value: effnBgUrl(BG_ASSETS.bg03), thumb: '#008080 ' + effnBgUrl(BG_ASSETS.bg03) + ' center/cover no-repeat' },
    'classic': { label: 'Windows Classic', value: effnBgUrl(BG_ASSETS.winClassic), thumb: '#008080 ' + effnBgUrl(BG_ASSETS.winClassic) + ' center/cover no-repeat' }
  };
  // Merge in user-uploaded custom backgrounds from theme settings
  (function () {
    var customs = window.EFFN_CUSTOM_BACKGROUNDS || [];
    customs.forEach(function (c) {
      if (!c || !c.url) return;
      BG_PRESETS[c.id] = {
        label: c.label || c.id,
        value: effnBgUrl(c.url),
        thumb: '#008080 ' + effnBgUrl(c.url) + ' center/cover no-repeat'
      };
    });
  })();

  function applyBackground(value) {
    var isImage = String(value || '').indexOf('url(') === 0;
    document.documentElement.style.setProperty('--effn-bg', isImage ? '#008080' : value);
    document.documentElement.style.setProperty('--effn-bg-image', isImage ? value : 'none');
    try {
      localStorage.setItem('effn_bg', isImage ? '#008080' : value);
      localStorage.setItem('effn_bg_image', isImage ? value : 'none');
    } catch (e) {}
  }

  var displayPropsWindow = null;

  function openDisplayProperties() {
    if (displayPropsWindow) {
      displayPropsWindow.classList.remove('minimized');
      bringToFront(displayPropsWindow);
      return;
    }
    var win = document.createElement('div');
    win.className = 'window draggable display-properties';
    var baseX = 140, baseY = 90, step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    var presetHtml = Object.keys(BG_PRESETS).map(function (k) {
      var p = BG_PRESETS[k];
      return '<div class="dp-preset" data-preset="' + k + '" ' +
                  'style="background:' + (p.thumb || p.value) + ';" title="' + p.label + '"></div>';
    }).join('');

    var styles = getComputedStyle(document.documentElement);
    var currentBg = styles.getPropertyValue('--effn-bg').trim() || '#008080';
    var currentImage = styles.getPropertyValue('--effn-bg-image').trim();
    var currentValue = currentImage && currentImage !== 'none' ? currentImage : currentBg;

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">Display Properties</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="dp-tabs">' +
        '<button class="dp-tab-active">Background</button>' +
      '</div>' +
      '<div class="dp-body">' +
        '<div class="dp-preview" data-dp-preview></div>' +
        '<div class="dp-section-title">Saved backgrounds</div>' +
        '<div class="dp-presets">' + presetHtml + '</div>' +
        '<div class="dp-section-title">Custom colour</div>' +
        '<div class="dp-color-row">' +
          '<input type="color" data-dp-color value="' + (currentBg.indexOf('#') === 0 ? currentBg : '#008080') + '"/>' +
          '<span data-dp-color-label>' + (currentBg.indexOf('#') === 0 ? currentBg : '(custom)') + '</span>' +
        '</div>' +
      '</div>' +
      '<div class="dp-actions">' +
        '<button data-action="apply">Apply</button>' +
        '<button data-action="ok">OK</button>' +
        '<button data-action="cancel">Cancel</button>' +
      '</div>';

    document.getElementById('scene-desktop').appendChild(win);
    displayPropsWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, 'Display Properties');

    var preview = win.querySelector('[data-dp-preview]');
    var colorInput = win.querySelector('[data-dp-color]');
    var colorLabel = win.querySelector('[data-dp-color-label]');
    var pendingValue = currentValue;

    function showPreview(value) {
      pendingValue = value;
      if (String(value || '').indexOf('url(') === 0) {
        preview.style.backgroundColor = '#008080';
        preview.style.backgroundImage = value;
        preview.style.backgroundSize = 'cover';
        preview.style.backgroundPosition = 'center';
        preview.style.backgroundRepeat = 'no-repeat';
      } else {
        preview.style.background = value;
        preview.style.backgroundImage = '';
      }
    }
    showPreview(currentValue);

    win.querySelectorAll('.dp-preset').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        win.querySelectorAll('.dp-preset.selected').forEach(function (s) { s.classList.remove('selected'); });
        el.classList.add('selected');
        var k = el.dataset.preset;
        showPreview(BG_PRESETS[k].value);
      });
    });

    colorInput.addEventListener('input', function () {
      win.querySelectorAll('.dp-preset.selected').forEach(function (s) { s.classList.remove('selected'); });
      colorLabel.textContent = colorInput.value;
      showPreview(colorInput.value);
    });

    function close() {
      win.remove();
      displayPropsWindow = null;
    }

    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      close();
    });
    win.querySelector('[data-action="min"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });
    win.querySelector('[data-action="apply"]').addEventListener('click', function (e) {
      e.stopPropagation();
      applyBackground(pendingValue);
    });
    win.querySelector('[data-action="ok"]').addEventListener('click', function (e) {
      e.stopPropagation();
      applyBackground(pendingValue);
      close();
    });
    win.querySelector('[data-action="cancel"]').addEventListener('click', function (e) {
      e.stopPropagation();
      close();
    });
  }

  // ============ CUSTOMER SUPPORT CHAT ============
  // Adapted from effn-support-widget.liquid — same Win98 chat experience,
  // running inside our window-manager so it minimizes/maximizes/closes
  // like every other window. Backend wiring is stubbed for prototype.
  var supportWindow = null;

  var SUPPORT_REPLIES = [
    {
      keywords: ['order', 'tracking', 'where', 'shipped', 'courier', 'coming', 'track'],
      text: effnCfg('supportOrderReply', 'Send your order number and the email used at checkout. We can check the latest status and let you know the next step.')
    },
    {
      keywords: ['return', 'swap', 'exchange', 'wrong', 'size'],
      text: effnCfg('supportReturnReply', 'We can help with returns or swaps if the item is unworn and tags are still attached. Send your order number and what you would like to change.')
    },
    {
      keywords: ['sizing', 'fit', 'fitted', 'cap', 'hat', 'size'],
      text: effnCfg('supportSizingReply', 'Fitted caps run true to size. If you are between sizes, we usually recommend going up. Tell us your usual size and the item you are looking at.')
    },
    {
      keywords: ['drop', 'restock', 'next', 'release', 'when'],
      text: effnCfg('supportDropReply', 'Drop and restock updates are shared through EFFN socials and email first. If you are looking for a specific item, tell us which one and we can check what is confirmed.')
    }
  ];

  function supportFallbackReply(text) {
    var lower = (text || '').toLowerCase();
    for (var i = 0; i < SUPPORT_REPLIES.length; i++) {
      var r = SUPPORT_REPLIES[i];
      for (var j = 0; j < r.keywords.length; j++) {
        if (lower.indexOf(r.keywords[j]) !== -1) return r.text;
      }
    }
    return effnCfg('supportFallbackReply', 'Thanks. Send through your order number or the product you need help with, and we will point you in the right direction.');
  }

  function escapeSupportHtml(text) {
    return String(text || '').replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;' })[c];
    });
  }

  function openSupportChat() {
    /* If Gorgias chat is wired up in theme settings, defer to it so the
       customer gets real-time human support instead of the simulated
       reply window. Falls back to the Win98 simulator when Gorgias is
       not configured or hasn't loaded yet. */
    if (window.EFFN_GORGIAS && window.EFFN_GORGIAS.enabled) {
      if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
        try { window.GorgiasChat.open(); return; } catch (_) {}
      }
      /* Widget script may still be loading — poll briefly then open. */
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
          clearInterval(poll);
          try { window.GorgiasChat.open(); } catch (_) {}
        } else if (tries > 20) {
          /* ~4s elapsed and Gorgias still not loaded — fall back. */
          clearInterval(poll);
          openSimulatedSupportChat();
        }
      }, 200);
      return;
    }
    openSimulatedSupportChat();
  }

  function openSimulatedSupportChat() {
    if (supportWindow) {
      supportWindow.classList.remove('minimized');
      bringToFront(supportWindow);
      return;
    }
    var win = document.createElement('div');
    win.className = 'window draggable support-window';
    var supportTitle = effnCfg('supportWindowTitle', 'EFFN Support Chat');
    var supportAgent = effnCfg('supportAgentName', 'EFFN Support');
    var supportProfile = effnCfg('supportProfileImage', '');
    var supportLogoHtml = supportProfile
      ? '<img src="' + effnEscapeAttr(supportProfile) + '" alt=""/>'
      : '<svg viewBox="0 0 80 60" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<ellipse cx="40" cy="32" rx="34" ry="14" fill="none" stroke="#000" stroke-width="3.5"/>' +
          '<text x="38" y="38" text-anchor="middle" font-family="Times New Roman, serif" font-style="italic" font-weight="900" font-size="22" letter-spacing="-1" fill="#000">' + effnEscapeAttr(effnBrandShort()) + '</text>' +
          '<polygon points="68,12 72,22 82,22 74,28 78,40 68,32 58,40 62,28 54,22 64,22" fill="#000"/>' +
        '</svg>';
    var baseX = 130, baseY = 80, step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">' + effnEscapeAttr(supportTitle) + '</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="support-body">' +
        '<header class="support-intro">' +
          '<div class="support-logo">' + supportLogoHtml + '</div>' +
          '<div>' +
            '<strong>' + effnEscapeAttr(effnCfg('supportIntroTitle', 'Need help?')) + '</strong>' +
            '<p>' + effnEscapeAttr(effnCfg('supportIntroText', 'Ask about orders, delivery, returns, sizing, or upcoming drops.')) + '</p>' +
            '<span class="support-status" data-support-status>' + effnEscapeAttr(effnCfg('supportStatusText', 'Safe reply mode')) + '</span>' +
          '</div>' +
        '</header>' +
        '<div class="support-chat" data-support-chat aria-live="polite">' +
          '<div class="support-msg notice">' + effnEscapeAttr(effnCfg('supportNoticeText', 'Do not share payment details here. For private info, our team will move you to email.')) + '</div>' +
          '<div class="support-msg agent"><strong>' + effnEscapeAttr(supportAgent) + '</strong>' + effnEscapeAttr(effnCfg('supportInitialMessage', 'Hi, how can we help today?')) + '</div>' +
        '</div>' +
        '<form class="support-composer" data-support-form>' +
          '<div class="support-quick" aria-label="Common support topics">' +
            '<button type="button" data-prompt="Where is my order?">Track order</button>' +
            '<button type="button" data-prompt="Can I return or swap an item?">Returns</button>' +
            '<button type="button" data-prompt="How do I choose my cap size?">Sizing</button>' +
            '<button type="button" data-prompt="When is the next drop?">Next drop</button>' +
          '</div>' +
          '<div class="support-input-row">' +
            '<textarea class="support-input" aria-label="Message to support" placeholder="Type your message..."></textarea>' +
            '<button class="support-send" type="submit">Send</button>' +
          '</div>' +
        '</form>' +
      '</div>';

    document.getElementById('scene-desktop').appendChild(win);
    supportWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, supportTitle);

    var chat   = win.querySelector('[data-support-chat]');
    var input  = win.querySelector('.support-input');
    var form   = win.querySelector('[data-support-form]');
    var status = win.querySelector('[data-support-status]');
    var quickBtns = win.querySelectorAll('[data-prompt]');

    function addMessage(role, text) {
      var msg = document.createElement('div');
      msg.className = 'support-msg ' + role;
      var label = role === 'customer' ? 'You' : supportAgent;
      msg.innerHTML = '<strong>' + effnEscapeAttr(label) + '</strong>' + escapeSupportHtml(text);
      chat.appendChild(msg);
      chat.scrollTop = chat.scrollHeight;
    }

    quickBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = b.dataset.prompt;
        input.focus();
      });
    });

    /* Conversation history for the AI backend. role: 'user' | 'assistant' */
    var aiHistory = [];
    var aiEndpoint = effnCfg('aiChatEndpoint', '');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = input.value.trim();
      if (!text) return;
      addMessage('customer', text);
      input.value = '';
      status.textContent = 'Typing...';

      if (aiEndpoint) {
        aiHistory.push({ role: 'user', content: text });
        /* Keep last 20 turns to bound payload size */
        if (aiHistory.length > 20) aiHistory = aiHistory.slice(-20);
        fetch(aiEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ messages: aiHistory })
        }).then(function (r) {
          if (!r.ok) return r.text().then(function (t) { return Promise.reject(new Error(t || ('HTTP ' + r.status))); });
          return r.json();
        }).then(function (data) {
          var reply = data && data.reply ? String(data.reply) : '';
          if (!reply) reply = supportFallbackReply(text);
          aiHistory.push({ role: 'assistant', content: reply });
          addMessage('agent', reply);
          status.textContent = effnCfg('supportStatusText', 'Safe reply mode');
        }).catch(function (err) {
          /* AI unreachable — fall back to canned reply so user isn't left hanging */
          console.warn('[EFFN AI chat] error:', err);
          addMessage('agent', supportFallbackReply(text));
          status.textContent = 'Offline — using fallback';
        });
        return;
      }

      /* No AI endpoint configured — canned reply path */
      setTimeout(function () {
        addMessage('agent', supportFallbackReply(text));
        status.textContent = effnCfg('supportStatusText', 'Safe reply mode');
      }, 600);
    });

    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.remove();
      supportWindow = null;
    });
    win.querySelector('[data-action="min"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });

    setTimeout(function () { input.focus(); }, 50);
  }

  // Open the configured sister-brand URL via programmatic anchor click
  // (real link click — not blocked by popup blockers like window.open)
  function openWMOSite() {
    var a = document.createElement('a');
    a.href = effnCfg('wmoUrl', 'https://wairuamaurioho.com');
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { a.remove(); }, 100);
  }

  // ============ DIAL-UP MODAL + INSTAGRAM REDIRECT ============
  var dialupActive = false;

  function playDialupTones() {
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      var ctx = new Ctx();
      var t0 = ctx.currentTime;
      function beep(time, freq, dur, vol) {
        var osc = ctx.createOscillator();
        var gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0, time);
        gain.gain.linearRampToValueAtTime(vol || 0.08, time + 0.01);
        gain.gain.linearRampToValueAtTime(0, time + dur);
        osc.connect(gain).connect(ctx.destination);
        osc.start(time);
        osc.stop(time + dur);
      }
      // Dial tones
      var dialFreqs = [697, 1209, 770, 1336, 852, 1477, 941, 1633];
      for (var i = 0; i < dialFreqs.length; i++) {
        beep(t0 + i * 0.1, dialFreqs[i], 0.08, 0.06);
      }
      // Handshake tones
      beep(t0 + 0.9, 440,  0.25, 0.08);
      beep(t0 + 1.2, 2100, 0.30, 0.05);
      beep(t0 + 1.4, 1750, 0.20, 0.05);
      // Iconic hiss
      var noiseDur = 0.7;
      var nbuf = ctx.createBuffer(1, ctx.sampleRate * noiseDur, ctx.sampleRate);
      var data = nbuf.getChannelData(0);
      for (var j = 0; j < data.length; j++) data[j] = (Math.random() * 2 - 1) * 0.5;
      var noise = ctx.createBufferSource();
      noise.buffer = nbuf;
      var ng = ctx.createGain();
      ng.gain.setValueAtTime(0, t0 + 1.1);
      ng.gain.linearRampToValueAtTime(0.04, t0 + 1.2);
      ng.gain.linearRampToValueAtTime(0, t0 + 1.1 + noiseDur);
      noise.connect(ng).connect(ctx.destination);
      noise.start(t0 + 1.1);
    } catch (e) {
      
    }
  }

  function openDialupAndInstagram() {
    if (dialupActive) return;
    dialupActive = true;
    var instagramUrl = effnCfg('instagramUrl', 'https://instagram.com/effnclo');
    var instagramLabel = effnCfg('instagramLabel', 'instagram.com/effnclo');

    var modal = document.createElement('div');
    modal.className = 'dialup-modal';
    modal.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">Connect to: ' + effnEscapeAttr(effnBrandShort()) + '-NET</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="dialup-body">' +
        '<div class="dialup-row">' +
          '<div class="dialup-modem"></div>' +
          '<div class="dialup-status" data-status>Dialing 0177 555 0123...</div>' +
        '</div>' +
        '<div class="dialup-progress"><div class="dialup-progress-fill"></div></div>' +
        '<div class="dialup-meta">' +
          '<span>Speed: 56 kbps</span>' +
          '<span>' + effnEscapeAttr(instagramLabel) + '</span>' +
        '</div>' +
      '</div>';
    document.getElementById('scene-desktop').appendChild(modal);

    var statusEl = modal.querySelector('[data-status]');
    var stages = [
      { t: 0,    text: 'Dialing 0177 555 0123...' },
      { t: 600,  text: 'Negotiating connection...' },
      { t: 1200, text: 'Authenticating...' },
      { t: 1800, text: 'Connected. Opening browser...' }
    ];
    var timers = stages.map(function (s) {
      return setTimeout(function () { statusEl.textContent = s.text; }, s.t);
    });

    var closed = false;
    var finishTimer;
    function cleanup() {
      if (closed) return;
      closed = true;
      timers.forEach(clearTimeout);
      if (finishTimer) clearTimeout(finishTimer);
      modal.remove();
      dialupActive = false;
    }
    var closeBtn = modal.querySelector('[data-action="close"]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      cleanup();
    });

    playDialupTones();

    // Once the dial completes, swap the modal body to a "Connected" state with a
    // real <a target="_blank"> link. Browsers don't pop-up-block real link clicks.
    finishTimer = setTimeout(function () {
      timers.forEach(clearTimeout);
      var body = modal.querySelector('.dialup-body');
      if (body) {
        body.innerHTML =
          '<div class="dialup-row" style="margin-bottom:6px;">' +
            '<div class="dialup-modem" style="animation:none;filter:none;"></div>' +
            '<div class="dialup-status" data-status>' +
              '<strong>Connected.</strong><br>' +
              'Ready to open ' + effnEscapeAttr(instagramLabel) +
            '</div>' +
          '</div>' +
          '<div style="display:flex;gap:8px;justify-content:flex-end;margin-top:6px;">' +
            '<button data-action="cancel" style="min-width:80px;padding:5px 14px;font-size:11px;">Cancel</button>' +
            '<a href="' + effnEscapeAttr(instagramUrl) + '" target="_blank" rel="noopener noreferrer" ' +
              'class="dialup-go" style="min-width:120px;padding:5px 14px;font-size:11px;font-weight:bold;' +
              'text-decoration:none;text-align:center;display:inline-block;color:#000;' +
              'background:var(--effn-window);border:2px solid;' +
              'border-color:var(--effn-window-light) var(--effn-window-darker) var(--effn-window-darker) var(--effn-window-light);">' +
              'View profile →' +
            '</a>' +
          '</div>';
        body.querySelector('[data-action="cancel"]').addEventListener('click', function (e) {
          e.stopPropagation();
          cleanup();
        });
        body.querySelector('.dialup-go').addEventListener('click', function () {
          // The link itself opens in a new tab; we just clean up the modal
          setTimeout(cleanup, 50);
        });
      }
    }, 2000);
  }

  // ============ PHOTO LIBRARY ============
  var photoLibrary = (Array.isArray(window.EFFN_PHOTO_LIBRARY) && window.EFFN_PHOTO_LIBRARY.length) ? window.EFFN_PHOTO_LIBRARY : [
    { name: 'LOOKBOOK01.JPG', size: '2.4 MB' },
    { name: 'DROP_SS26.JPG',  size: '1.8 MB' },
    { name: 'RUNWAY_24.JPG',  size: '3.2 MB' },
    { name: 'BTS_NYC01.JPG',  size: '2.7 MB' },
    { name: 'BTS_NYC02.JPG',  size: '2.5 MB' },
    { name: 'AKL_POP.JPG',    size: '1.6 MB' },
    { name: 'CITY_RUN.JPG',   size: '2.1 MB' },
    { name: 'CAMPAIGN.JPG',   size: '3.8 MB' }
  ];
  var photoLibraryWindow = null;

  function openPhotoLibrary() {
    if (photoLibraryWindow) {
      photoLibraryWindow.classList.remove('minimized');
      bringToFront(photoLibraryWindow);
      return;
    }
    var win = document.createElement('div');
    win.className = 'window draggable video-library';

    var baseX = 100, baseY = 70, step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    var listHtml = photoLibrary.map(function (p, idx) {
      return '<li class="video-item photo-file" data-photo-index="' + idx + '">' +
               '<span class="vi-glyph photo-glyph"></span>' +
               '<span class="vi-name">' + effnEscapeAttr(p.name) + '</span>' +
               '<span class="vi-size">' + effnEscapeAttr(p.size || '') + '</span>' +
             '</li>';
    }).join('');

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">Photos</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="collection-toolbar">' +
        '<button>←</button>' +
        '<button>→</button>' +
        '<span class="breadcrumb">C:\\' + String(effnDriveName()).toUpperCase().replace(/\s+/g, '_') + '\\PHOTOS</span>' +
      '</div>' +
      '<ul class="video-list">' + listHtml + '</ul>' +
      '<div class="collection-statusbar">' +
        '<span>' + photoLibrary.length + ' object(s)</span>' +
        '<span>20.1 MB</span>' +
      '</div>';

    document.getElementById('scene-desktop').appendChild(win);
    photoLibraryWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, 'Photos');

    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.remove();
      photoLibraryWindow = null;
    });
    win.querySelector('[data-action="min"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });

    win.querySelectorAll('.video-item').forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.stopPropagation();
        win.querySelectorAll('.video-item.selected').forEach(function (s) { s.classList.remove('selected'); });
        item.classList.add('selected');
      });
      item.addEventListener('dblclick', function (e) {
        e.stopPropagation();
        openPhotoViewer(photoLibrary[Number(item.dataset.photoIndex)]);
      });
    });
  }

  function openPhotoViewer(photo) {
    photo = photo || {};
    var win = document.createElement('div');
    win.className = 'window draggable photo-viewer';
    effnPlaceWindow(win, { baseX: 150, baseY: 110, step: 24 });
    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">' + effnEscapeAttr(photo.name || 'Photo') + '</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="photo-screen">' + (photo.src ? '<img src="' + effnEscapeAttr(photo.src) + '" alt="' + effnEscapeAttr(photo.name || '') + '">' : 'No image uploaded') + '</div>';
    document.getElementById('scene-desktop').appendChild(win);
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, photo.name || 'Photo');
    win.querySelector('[data-action="close"]').addEventListener('click', function (e) { e.stopPropagation(); win.remove(); });
    win.querySelector('[data-action="min"]').addEventListener('click', function (e) { e.stopPropagation(); win.classList.toggle('minimized'); });
  }

  // ============ VIDEO LIBRARY + PLAYER ============
  var videoLibrary = (Array.isArray(window.EFFN_VIDEO_LIBRARY) && window.EFFN_VIDEO_LIBRARY.length) ? window.EFFN_VIDEO_LIBRARY : [
    { name: 'LOOKBK26.MP4', size: '12.4 MB' },
    { name: 'DROP_SS.MP4',  size: '8.7 MB' },
    { name: 'RUNWAY24.MP4', size: '21.2 MB' },
    { name: 'BTS_NYC.MP4',  size: '15.8 MB' },
    { name: 'AKL_POP.MP4',  size: '6.3 MB' },
    { name: 'CITY_RUN.MP4', size: '9.1 MB' }
  ];
  var videoLibraryWindow = null;

  function openVideoLibrary() {
    if (videoLibraryWindow) {
      videoLibraryWindow.classList.remove('minimized');
      bringToFront(videoLibraryWindow);
      return;
    }
    var win = document.createElement('div');
    win.className = 'window draggable video-library';

    var baseX = 110, baseY = 80, step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    var listHtml = videoLibrary.map(function (v, idx) {
      return '<li class="video-item video-file" data-video-index="' + idx + '">' +
               '<span class="vi-glyph"></span>' +
               '<span class="vi-name">' + effnEscapeAttr(v.name) + '</span>' +
               '<span class="vi-size">' + effnEscapeAttr(v.size || '') + '</span>' +
             '</li>';
    }).join('');

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">Video Library</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="collection-toolbar">' +
        '<button>←</button>' +
        '<button>→</button>' +
        '<span class="breadcrumb">C:\\' + String(effnDriveName()).toUpperCase().replace(/\s+/g, '_') + '\\VIDEO</span>' +
      '</div>' +
      '<ul class="video-list">' + listHtml + '</ul>' +
      '<div class="collection-statusbar">' +
        '<span>' + videoLibrary.length + ' object(s)</span>' +
        '<span>73.5 MB</span>' +
      '</div>';

    document.getElementById('scene-desktop').appendChild(win);
    videoLibraryWindow = win;
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, 'Video Library');

    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.remove();
      videoLibraryWindow = null;
    });
    win.querySelector('[data-action="min"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });

    win.querySelectorAll('.video-item').forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.stopPropagation();
        win.querySelectorAll('.video-item.selected').forEach(function (s) { s.classList.remove('selected'); });
        item.classList.add('selected');
      });
      item.addEventListener('dblclick', function (e) {
        e.stopPropagation();
        openVideoPlayer(videoLibrary[Number(item.dataset.videoIndex)]);
      });
    });
  }

  function openVideoPlayer(video) {
    video = typeof video === 'string' ? { name: video } : (video || {});
    var filename = video.name || 'Video';
    var win = document.createElement('div');
    win.className = 'window draggable video-player';

    var baseX = 160, baseY = 110, step = 28;
    effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">' + filename + ' — Media Player</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Minimize" data-action="min"></button>' +
          '<button aria-label="Maximize"></button>' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>' +
      '<div class="video-screen">' +
        (video.src ? '<video controls playsinline' + (video.poster ? ' poster="' + effnEscapeAttr(video.poster) + '"' : '') + ' src="' + effnEscapeAttr(video.src) + '"></video>' : '— no signal —') +
      '</div>' +
      '<div class="video-controls">' +
        '<button class="video-btn" aria-label="Play">▶</button>' +
        '<button class="video-btn" aria-label="Pause">‖</button>' +
        '<button class="video-btn" aria-label="Stop">■</button>' +
        '<span class="video-time">00:00 / 00:00</span>' +
      '</div>';

    document.getElementById('scene-desktop').appendChild(win);
    makeDraggable(win);
    bringToFront(win);
    wireWindowChrome(win, filename);

    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.remove();
    });
    win.querySelector('[data-action="min"]').addEventListener('click', function (e) {
      e.stopPropagation();
      win.classList.toggle('minimized');
    });
  }

  // ============ SUBSCRIBE POPUP (virus aesthetic) ============
  var subscribePopupShown = false;
  var subscribePopupTimer = null;
  var subscribePopups = [];
  var SUBSCRIBE_DISMISS_KEY = 'effn_signup_dismissed';

  function isSubscribeDismissedThisSession() {
    try { return sessionStorage.getItem(SUBSCRIBE_DISMISS_KEY) === '1'; } catch (_) { return false; }
  }
  function markSubscribeDismissed() {
    try { sessionStorage.setItem(SUBSCRIBE_DISMISS_KEY, '1'); } catch (_) {}
  }

  function closeAllSubscribePopups() {
    subscribePopups.forEach(function (w) { if (w && w.parentNode) w.remove(); });
    subscribePopups = [];
    /* User closed it OR it auto-closed after a successful submit. Either
       way: don't show it again this session. */
    markSubscribeDismissed();
  }

  function scheduleSubscribePopup() {
    if (!effnCfg('emailPopupEnabled', true)) return;
    if (subscribePopupShown) return;
    if (subscribePopupTimer) return;
    if (isSubscribeDismissedThisSession()) return;
    var delay = parseInt(effnCfg('emailPopupDelayMs', 10000), 10);
    subscribePopupTimer = setTimeout(spawnSubscribePopups, Math.max(0, delay || 0));
  }

  function spawnSubscribePopups() {
    if (subscribePopupShown) return;
    if (isSubscribeDismissedThisSession()) return;
    subscribePopupShown = true;
    var deskScene = document.getElementById('scene-desktop');
    if (!deskScene || !deskScene.classList.contains('active')) {
      // user navigated away; defer until they come back
      subscribePopupShown = false;
      subscribePopupTimer = null;
      return;
    }
    var w = deskScene.clientWidth;
    var h = deskScene.clientHeight;
    var cx = Math.max(40, w / 2 - 175);
    var cy = Math.max(40, h / 2 - 150);

    /* Single popup: just the Email Sign up window (with its photo).
       WARNING.EXE and DROP_LOADER.EXE retired per design. */
    var isMobile = (window.innerWidth || document.documentElement.clientWidth) <= 640;
    if (isMobile) {
      var mobileX = Math.max(8, Math.round((w - 340) / 2));
      setTimeout(function () { spawnSignup(mobileX, 100); }, 0);
      return;
    }
    setTimeout(function () { spawnSignup(cx, cy); }, 0);
  }

  function popupShell(title, w) {
    var win = document.createElement('div');
    win.className = 'window draggable popup-virus';
    win.style.width = w + 'px';
    win.innerHTML =
      '<div class="title-bar">' +
        '<div class="title-bar-text">' + title + '</div>' +
        '<div class="title-bar-controls">' +
          '<button aria-label="Close" data-action="close"></button>' +
        '</div>' +
      '</div>';
    return win;
  }

  function wirePopupClose(win) {
    win.querySelectorAll('[data-action="close"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        /* If this is one of the subscribe popups, dismissing any one of
           them should suppress the whole stack for the rest of the
           session. */
        if (subscribePopups.indexOf(win) !== -1) {
          closeAllSubscribePopups();
          return;
        }
        win.remove();
      });
    });
  }

  function spawnVirusWarning(x, y) {
    var win = popupShell(effnCfg('emailWarningTitle', 'WARNING.EXE'), 340);
    effnPlaceWindow(win, { baseX: x, baseY: y, step: 32 });
    win.innerHTML +=
      '<div class="window-body" style="padding:16px;display:flex;gap:14px;align-items:center;">' +
        '<div class="warn-glyph"></div>' +
        '<div style="font-size:12px;line-height:1.45;flex:1;">' +
          '<strong>' + effnEscapeAttr(effnCfg('emailWarningHeading', 'EFFN_FAMILY.EXE not installed.')) + '</strong><br>' +
          effnEscapeAttr(effnCfg('emailWarningBody', 'Your system is missing critical drops.')).replace(/\n/g, '<br>') +
        '</div>' +
      '</div>' +
      '<div style="text-align:right;padding:0 14px 14px;">' +
        '<button data-action="close" style="min-width:72px;padding:5px 14px;font-size:11px;">OK</button>' +
      '</div>';
    document.getElementById('scene-desktop').appendChild(win);
    makeDraggable(win);
    bringToFront(win);
    wirePopupClose(win);
    subscribePopups.push(win);
  }

  function spawnDropLoader(x, y) {
    var win = popupShell(effnCfg('emailLoaderTitle', 'DROP_LOADER.EXE'), 340);
    effnPlaceWindow(win, { baseX: x, baseY: y, step: 32 });
    win.innerHTML +=
      '<div class="window-body" style="padding:16px;font-size:12px;line-height:1.5;">' +
        '<div style="margin-bottom:10px;">' + effnEscapeAttr(effnCfg('emailLoaderText', 'Locating new collection')) + '<span class="dot-anim"></span></div>' +
        '<div class="popup-progress"><div class="popup-progress-fill"></div></div>' +
        '<div style="margin-top:10px;color:#444;font-size:11px;">Source: C:\\' + String(effnDriveName()).toUpperCase().replace(/\s+/g, '_') + '\\' + effnEscapeAttr(effnCfg('emailLoaderSource', 'DROPS\\\\2026_SS')) + '</div>' +
      '</div>';
    document.getElementById('scene-desktop').appendChild(win);
    makeDraggable(win);
    bringToFront(win);
    wirePopupClose(win);
    subscribePopups.push(win);
  }

  function spawnSignup(x, y) {
    var popupWidth = Math.max(280, Math.min(560, parseInt(effnCfg('emailPopupWindowWidth', 360), 10) || 360));
    var win = popupShell(effnCfg('emailPopupTitle', 'Email Sign up'), popupWidth);
    effnPlaceWindow(win, { baseX: x, baseY: y, step: 32 });
    var imgUrl = effnCfg('emailPopupImageUrl', '');
    var imgAlt = effnCfg('emailPopupImageAlt', '');
    var imgHtml = imgUrl
      ? '<div class="email-popup-image"><img src="' + effnEscapeAttr(imgUrl) + '" alt="' + effnEscapeAttr(imgAlt) + '"/></div>'
      : '';
    win.innerHTML +=
      '<div class="window-body" style="padding:0;font-size:12px;line-height:1.4;">' +
        imgHtml +
        '<div class="email-popup-form">' +
          '<p class="email-popup-headline"><strong>' + effnEscapeAttr(effnCfg('emailPopupHeading', "Don't miss a drop")) + '</strong> — ' +
            effnEscapeAttr(effnCfg('emailPopupBody', 'Family First.')).replace(/\n/g, '<br>') +
          '</p>' +
          '<form data-subscribe-form method="post" action="/contact#contact_form" accept-charset="UTF-8" style="display:flex;flex-direction:column;">' +
            '<input type="hidden" name="form_type" value="customer">' +
            '<input type="hidden" name="utf8" value="&#10003;">' +
            '<input type="hidden" name="contact[tags]" value="newsletter,EFFN98">' +
            '<input type="hidden" name="contact[accepts_marketing]" value="true">' +
            '<input type="email" name="contact[email]" required placeholder="' + effnEscapeAttr(effnCfg('emailPopupPlaceholder', 'you@domain.com')) + '" ' +
              'style="font-family:inherit;border:1px solid #000;background:#fff;box-shadow:inset 1px 1px 0 #808080;"/>' +
            '<div class="email-popup-actions">' +
              '<button type="button" data-action="close-all">' + effnEscapeAttr(effnCfg('emailPopupCancelLabel', 'Cancel')) + '</button>' +
              '<button type="submit" style="font-weight:bold;">' + effnEscapeAttr(effnCfg('emailPopupSubmitLabel', 'Join family')) + '</button>' +
            '</div>' +
          '</form>' +
        '</div>' +
      '</div>';
    document.getElementById('scene-desktop').appendChild(win);
    makeDraggable(win);
    bringToFront(win);
    wirePopupClose(win);
    subscribePopups.push(win);

    // Cancel button closes ALL three popups at once (consistent with submit)
    win.querySelector('[data-action="close-all"]').addEventListener('click', function (e) {
      e.stopPropagation();
      closeAllSubscribePopups();
    });

    var form = win.querySelector('[data-subscribe-form]');
    var submitBtn = form.querySelector('[type="submit"]');
    function showSignupSuccess() {
      var body = win.querySelector('.window-body');
      body.innerHTML =
        '<div style="padding:8px 0;font-size:12px;line-height:1.5;text-align:center;">' +
          '<div style="font-size:28px;line-height:1;margin-bottom:6px;">✓</div>' +
          '<strong>' + effnEscapeAttr(effnCfg('emailPopupSuccessTitle', 'Welcome to the family.')) + '</strong><br>' +
          '<span style="color:#444;font-size:11px;">' + effnEscapeAttr(effnCfg('emailPopupSuccessText', 'Drop alerts active.')) + '</span>' +
        '</div>';
      setTimeout(closeAllSubscribePopups, 1600);
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Saving...';
      }
      fetch(form.getAttribute('action'), {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      }).then(function () {
        showSignupSuccess();
      }).catch(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = effnCfg('emailPopupSubmitLabel', 'Join family');
        }
        var input = form.querySelector('input[type="email"]');
        if (input) input.focus();
      });
    });
  }

  // ============ DEAL / PROMO POPUP ============
  // Second Win98 popup: image + headline + body + button linking to a
  // product, collection, or URL. Independent dismiss flag from email popup.
  var dealPopupShown = false;
  var dealPopupTimer = null;
  var DEAL_DISMISS_KEY = 'effn_deal_dismissed';

  function isDealDismissedThisSession() {
    try { return sessionStorage.getItem(DEAL_DISMISS_KEY) === '1'; } catch (_) { return false; }
  }
  function markDealDismissed() {
    try { sessionStorage.setItem(DEAL_DISMISS_KEY, '1'); } catch (_) {}
  }

  function scheduleDealPopup() {
    if (!effnCfg('dealPopupEnabled', false)) return;
    if (dealPopupShown) return;
    if (dealPopupTimer) return;
    if (isDealDismissedThisSession()) return;
    var delay = parseInt(effnCfg('dealPopupDelayMs', 15000), 10);
    dealPopupTimer = setTimeout(spawnDealPopupNow, Math.max(0, delay || 0));
  }

  function spawnDealPopupNow() {
    if (dealPopupShown) return;
    if (isDealDismissedThisSession()) return;
    var deskScene = document.getElementById('scene-desktop');
    if (!deskScene || !deskScene.classList.contains('active')) {
      dealPopupTimer = null;
      return;
    }
    dealPopupShown = true;
    var w = deskScene.clientWidth;
    var h = deskScene.clientHeight;
    var isMobile = (window.innerWidth || document.documentElement.clientWidth) <= 640;
    var x, y;
    if (isMobile) {
      x = Math.max(8, Math.round((w - 340) / 2));
      y = 140;
    } else {
      // Stack diagonally over the email popup so its titlebar stays visible
      // (mirrors Win98's cascade-window behavior). Email popup centers at
      // (w/2 - 175, h/2 - 150); we offset down-right by 36px.
      x = Math.max(40, w / 2 - 175 + 36);
      y = Math.max(40, h / 2 - 150 + 36);
    }
    spawnDealPopup(x, y);
  }

  function spawnDealPopup(x, y) {
    var popupWidth = Math.max(280, Math.min(560, parseInt(effnCfg('dealPopupWindowWidth', 360), 10) || 360));
    var win = popupShell(effnCfg('dealPopupTitle', 'SPECIAL_OFFER.EXE'), popupWidth);
    effnPlaceWindow(win, { baseX: x, baseY: y, step: 32 });
    // Override cascade so this stacks diagonally over the email popup
    // (Win98 "cascade windows" feel — titlebar of underneath stays visible).
    win.style.left = x + 'px';
    win.style.top  = y + 'px';
    var imgUrl = effnCfg('dealPopupImageUrl', '');
    var imgAlt = effnCfg('dealPopupImageAlt', '');
    var imgHtml = imgUrl
      ? '<div class="email-popup-image"><img src="' + effnEscapeAttr(imgUrl) + '" alt="' + effnEscapeAttr(imgAlt) + '"/></div>'
      : '';
    var link = String(effnCfg('dealPopupLink', '') || '').trim();
    var safeLink = link && /^(https?:|\/)/i.test(link) ? link : (link ? '/' + link.replace(/^\/+/, '') : '');
    win.innerHTML +=
      '<div class="window-body" style="padding:0;font-size:12px;line-height:1.4;">' +
        imgHtml +
        '<div class="email-popup-form">' +
          '<p class="email-popup-headline"><strong>' + effnEscapeAttr(effnCfg('dealPopupHeading', 'Deal alert')) + '</strong> — ' +
            effnEscapeAttr(effnCfg('dealPopupBody', 'Limited time only.')).replace(/\n/g, '<br>') +
          '</p>' +
          '<div class="email-popup-actions">' +
            '<button type="button" data-action="deal-cancel">' + effnEscapeAttr(effnCfg('dealPopupCancelLabel', 'Close')) + '</button>' +
            '<button type="button" data-action="deal-cta" style="font-weight:bold;">' + effnEscapeAttr(effnCfg('dealPopupButtonLabel', 'Shop now')) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.getElementById('scene-desktop').appendChild(win);
    makeDraggable(win);
    bringToFront(win);

    function closeDealPopup() {
      markDealDismissed();
      if (win && win.parentNode) win.remove();
    }
    win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
      e.stopPropagation();
      closeDealPopup();
    });
    win.querySelector('[data-action="deal-cancel"]').addEventListener('click', function (e) {
      e.stopPropagation();
      closeDealPopup();
    });
    win.querySelector('[data-action="deal-cta"]').addEventListener('click', function (e) {
      e.stopPropagation();
      markDealDismissed();
      if (safeLink) {
        window.location.href = safeLink;
      } else {
        closeDealPopup();
      }
    });
  }

  // Icon interactions: single click selects, double click opens
  document.querySelectorAll('.icon').forEach(icon => {
    icon.addEventListener('click', e => {
      if (!(window.Shopify && window.Shopify.designMode)) e.stopPropagation();
      if (e.detail === 1) {
        document.querySelectorAll('.icon.selected').forEach(i => { if (i !== icon) i.classList.remove('selected'); });
        icon.classList.toggle('selected');
      }
    });
    icon.addEventListener('dblclick', e => {
      if (window.Shopify && window.Shopify.designMode) return;
      e.stopPropagation();
      if (icon.hasAttribute('data-cart')) {
        openCart();
        return;
      }
      if (icon.hasAttribute('data-trash')) {
        openTrash();
        return;
      }
      if (icon.hasAttribute('data-notepad')) {
        openNotepad();
        return;
      }
      if (icon.hasAttribute('data-video')) {
        openVideoLibrary();
        return;
      }
      if (icon.hasAttribute('data-photos')) {
        openPhotoLibrary();
        return;
      }
      if (icon.hasAttribute('data-internet')) {
        openDialupAndInstagram();
        return;
      }
      if (icon.hasAttribute('data-wmo')) {
        openWMOSite();
        return;
      }
      if (icon.hasAttribute('data-support')) {
        openSupportChat();
        return;
      }
      if (icon.hasAttribute('data-paint')) {
        openPaint();
        return;
      }
      var game = icon.dataset.game;
      if (game === 'minesweeper') {
        openMinesweeper();
        return;
      }
      if (game === 'spider') {
        openSpiderSolitaire();
        return;
      }
      var key = icon.dataset.collection;
      if (key) openCollection(key);
    });
  });

  // Click empty desktop deselects icons
  var deskScene = document.getElementById('scene-desktop');
  if (deskScene) {
    deskScene.addEventListener('click', e => {
      if (e.target === deskScene) {
        document.querySelectorAll('.icon.selected').forEach(i => i.classList.remove('selected'));
      }
    });
  }

  // ============ PRODUCT — variant selection, qty, image ============
  document.querySelectorAll('[data-variant-group]').forEach(group => {
    var name = group.dataset.variantGroup;
    group.querySelectorAll('button').forEach(b => {
      b.addEventListener('click', () => {
        group.querySelectorAll('button').forEach(x => x.classList.remove('selected'));
        b.classList.add('selected');
        var disp = document.getElementById(name + '-display');
        if (disp) disp.textContent = b.textContent;
      });
    });
  });
  function changeQty(d) {
    var q = document.getElementById('qty');
    q.value = Math.max(1, parseInt(q.value, 10) + d);
  }
  function setMain(emoji, btn) {
    document.getElementById('main-img').textContent = emoji;
    document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
    btn.classList.add('active');
  }

  // ============ CLOCK ============
  function tick() {
    var d = new Date();
    var h = d.getHours(); var m = d.getMinutes();
    var ap = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    document.getElementById('clock').textContent = h + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
  }
  tick(); setInterval(tick, 30000);

  // If the page initially loads with desktop active, kick off the popup timer.
  if (document.getElementById('scene-desktop').classList.contains('active')) {
    scheduleSubscribePopup();
    scheduleDealPopup();
  }

  // ============ MUSIC PLAYER ============
  (function () {
    var audio    = document.getElementById('music-audio');
    if (!audio) return;
    var nameEl   = document.querySelector('[data-track-name]');
    var prevBtn  = document.querySelector('[data-music="prev"]');
    var nextBtn  = document.querySelector('[data-music="next"]');

    /* Tracks flagged secret:true are gated behind a localStorage purchase
       flag set on Shopify's Order Status page. Filter them out unless
       the customer has bought something. */
    var purchaseUnlocked = false;
    try { purchaseUnlocked = localStorage.getItem('effn_purchased') === '1'; } catch (_) {}
    var tracks = Array.isArray(window.EFFN_TRACKS)
      ? window.EFFN_TRACKS.filter(function (t) { return t && t.src && (!t.secret || purchaseUnlocked); })
      : [];
    if (!tracks.length && window.EFFN_TRACK_URL) {
      tracks = [{ name: effnCfg('musicTrackName', 'Chill_Shit.mp3'), src: window.EFFN_TRACK_URL }];
    }

    var currentIdx  = 0;
    var autoStarted = false;
    var musicLibraryWindow = null;
    var widget   = document.getElementById('music-widget');
    var closeBtn = widget && widget.querySelector('[data-music="close"]');
    var minBtn   = widget && widget.querySelector('[data-music="min"]');
    var playBtn  = widget && widget.querySelector('[data-music="play"]');
    var pauseBtn = widget && widget.querySelector('[data-music="pause"]');

    /* Persist track + playhead across page navigations so music feels
       continuous when customer clicks into a product page. */
    var MUSIC_STATE_KEY = 'effn_music_state';
    function saveState() {
      try {
        sessionStorage.setItem(MUSIC_STATE_KEY, JSON.stringify({
          idx: currentIdx,
          time: audio.currentTime || 0,
          paused: !!audio.paused
        }));
      } catch (_) {}
    }
    function readSavedState() {
      try { return JSON.parse(sessionStorage.getItem(MUSIC_STATE_KEY) || 'null'); }
      catch (_) { return null; }
    }
    /* Save on every page exit (pagehide covers iOS bfcache too). */
    window.addEventListener('pagehide', saveState);
    window.addEventListener('beforeunload', saveState);
    window.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveState();
    });
    /* Save on audio state changes so the latest playhead/track is always in sessionStorage. */
    audio.addEventListener('play',  saveState);
    audio.addEventListener('pause', saveState);
    audio.addEventListener('timeupdate', (function () {
      var last = 0;
      return function () {
        var now = Date.now();
        if (now - last > 1500) { last = now; saveState(); }
      };
    })());
    /* And save before ANY internal link click — covers product navigation. */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (a && a.getAttribute('href') && a.getAttribute('href').charAt(0) === '/') saveState();
    }, true);

    function pickInitial() {
      var saved = readSavedState();
      if (saved && typeof saved.idx === 'number' && saved.idx >= 0 && saved.idx < tracks.length) {
        return saved.idx;
      }
      if (tracks.length <= 1) return 0;
      var last = parseInt(localStorage.getItem('effn_music_last') || '-1', 10);
      var idx;
      do { idx = Math.floor(Math.random() * tracks.length); } while (idx === last);
      return idx;
    }

    function pickDifferent(from) {
      if (tracks.length <= 1) return from;
      var idx;
      do { idx = Math.floor(Math.random() * tracks.length); } while (idx === from);
      return idx;
    }

    function load(idx) {
      if (!tracks.length) {
        audio.removeAttribute('src');
        if (nameEl) nameEl.textContent = 'add music URL in theme settings';
        return;
      }
      currentIdx = idx;
      audio.src  = tracks[idx].src;
      if (nameEl) nameEl.textContent = tracks[idx].name;
      localStorage.setItem('effn_music_last', String(idx));
    }

    function setUi(playing) {
      if (playBtn)  playBtn.classList.toggle('is-pressed',  playing);
      if (pauseBtn) pauseBtn.classList.toggle('is-pressed', !playing && !audio.paused === false);
      // Visually press the active state's button
      if (playBtn)  playBtn.classList.toggle('is-pressed',  playing);
      if (pauseBtn) pauseBtn.classList.toggle('is-pressed', !playing);
    }

    function play() {
      if (!tracks.length) {
        if (nameEl) nameEl.textContent = 'add music URL in theme settings';
        return;
      }
      audio.play().then(function () {
        setUi(true);
        sessionStorage.removeItem('effn_music_paused');
      }).catch(function (err) {
        // Surface failure in the marquee so we can see why
        if (nameEl) nameEl.textContent = 'play err: ' + (err && err.name ? err.name : 'blocked') + ' — click ▶';
        
      });
    }

    // Diagnostic: surface load/network errors visibly in the marquee
    audio.addEventListener('error', function () {
      var e = audio.error;
      var msg = 'audio err';
      if (e) {
        msg = 'err code ' + e.code + ' (' + (e.message || '') + ') — ' + audio.currentSrc;
      }
      if (nameEl) nameEl.textContent = msg;
      
    });
    audio.addEventListener('stalled', function () {
      
    });

    function pause() {
      audio.pause();
      setUi(false);
      sessionStorage.setItem('effn_music_paused', '1');
    }

    function next()   { if (!tracks.length) { load(0); return; } load(pickDifferent(currentIdx)); play(); }
    function prev()   { if (!tracks.length) { load(0); return; } load((currentIdx - 1 + tracks.length) % tracks.length); play(); }

    function closeWidget() {
      audio.pause();
      sessionStorage.setItem('effn_music_paused', '1');
      sessionStorage.setItem('effn_music_closed', '1');
      if (widget) widget.classList.add('closed');
      setUi(false);
    }
    function openWidget() {
      sessionStorage.removeItem('effn_music_closed');
      if (widget) widget.classList.remove('closed', 'minimized');
      play();
    }
    function minToggle() {
      if (widget) widget.classList.toggle('minimized');
    }

    function openMusicLibrary() {
      if (musicLibraryWindow) {
        musicLibraryWindow.classList.remove('minimized');
        bringToFront(musicLibraryWindow);
        return;
      }
      var win = document.createElement('div');
      win.className = 'window draggable video-library music-library';
      var baseX = 140, baseY = 86, step = 28;
      effnPlaceWindow(win, { baseX: baseX, baseY: baseY, step: step });

      var listHtml = tracks.length ? tracks.map(function (track, idx) {
        return '<li class="video-item music-file' + (idx === currentIdx ? ' selected' : '') + '" data-track-index="' + idx + '">' +
                 '<span class="vi-glyph music-glyph"></span>' +
                 '<span class="vi-name">' + effnEscapeAttr(track.name || ('Track ' + (idx + 1))) + '</span>' +
                 '<span class="vi-size">MP3</span>' +
               '</li>';
      }).join('') : '<li class="video-item"><span class="vi-glyph music-glyph"></span><span class="vi-name">Add Music Track blocks in the theme editor</span></li>';

      win.innerHTML =
        '<div class="title-bar">' +
          '<div class="title-bar-text">Music</div>' +
          '<div class="title-bar-controls">' +
            '<button aria-label="Minimize" data-action="min"></button>' +
            '<button aria-label="Maximize"></button>' +
            '<button aria-label="Close" data-action="close"></button>' +
          '</div>' +
        '</div>' +
        '<div class="collection-toolbar">' +
          '<button>←</button>' +
          '<button>→</button>' +
          '<span class="breadcrumb">C:\\' + String(effnDriveName()).toUpperCase().replace(/\s+/g, '_') + '\\MUSIC</span>' +
        '</div>' +
        '<ul class="video-list">' + listHtml + '</ul>' +
        '<div class="collection-statusbar">' +
          '<span>' + tracks.length + ' object(s)</span>' +
          '<span>playlist</span>' +
        '</div>';

      document.getElementById('scene-desktop').appendChild(win);
      musicLibraryWindow = win;
      makeDraggable(win);
      bringToFront(win);
      wireWindowChrome(win, 'Music');

      win.querySelector('[data-action="close"]').addEventListener('click', function (e) {
        e.stopPropagation();
        win.remove();
        musicLibraryWindow = null;
      });
      win.querySelector('[data-action="min"]').addEventListener('click', function (e) {
        e.stopPropagation();
        win.classList.toggle('minimized');
      });
      win.querySelectorAll('[data-track-index]').forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.stopPropagation();
          win.querySelectorAll('.video-item.selected').forEach(function (s) { s.classList.remove('selected'); });
          item.classList.add('selected');
        });
        item.addEventListener('dblclick', function (e) {
          e.stopPropagation();
          load(Number(item.dataset.trackIndex));
          openWidget();
        });
      });
    }

    load(pickInitial());

    /* Resume from saved playhead. We try to seek + play immediately;
       if autoplay is blocked, the first-gesture handler below will
       still pick it up. */
    var savedState = readSavedState();
    if (savedState && typeof savedState.time === 'number') {
      var seekAndPlay = function () {
        try { audio.currentTime = savedState.time; } catch (_) {}
        if (!savedState.paused) {
          play();
          autoStarted = true;
        }
      };
      if (audio.readyState >= 1) {
        seekAndPlay();
      } else {
        audio.addEventListener('loadedmetadata', seekAndPlay, { once: true });
      }
    }

    // Autoplay tied to first user gesture (browsers block first-load audio)
    // unless user paused it earlier this session.
    if (!sessionStorage.getItem('effn_music_paused')) {
      var tryAutoplay = function () {
        if (autoStarted) return;
        autoStarted = true;
        play();
      };
      document.addEventListener('click',   tryAutoplay, { once: true });
      document.addEventListener('keydown', tryAutoplay, { once: true });
    }

    audio.addEventListener('ended', function () {
      if (!tracks.length) return;
      load(pickDifferent(currentIdx));
      play();
    });

    if (playBtn)  playBtn.addEventListener('click',  play);
    if (pauseBtn) pauseBtn.addEventListener('click', pause);
    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); closeWidget(); });
    if (minBtn)   minBtn.addEventListener('click',   function (e) { e.stopPropagation(); minToggle();   });

    // Hook the widget into the universal taskbar-tab + maximize system
    if (widget) wireWindowChrome(widget, effnCfg('radioTitle', 'EFFN.RADIO'));

    // Honor previously-closed state on reload
    if (sessionStorage.getItem('effn_music_closed') === '1' && widget) {
      widget.classList.add('closed');
    }

    // Allow MUSIC desktop icon to reopen the widget on dblclick
    var musicIcon = document.querySelector('.icon-cdmix');
    if (musicIcon) {
      musicIcon.addEventListener('dblclick', function (e) {
        e.stopPropagation();
        openMusicLibrary();
      });
    }
  })();

  // ============ START MENU ============
  // Expose toggle globally so the inline onclick on the button + console testing both work.
  window.toggleStartMenu = function (e) {
    if (e) e.stopPropagation();
    var btn  = document.getElementById('start-btn');
    var menu = document.getElementById('start-menu');
    if (!btn || !menu) {  return; }
    var wasOpen = menu.classList.contains('open');
    
    if (wasOpen) {
      menu.classList.remove('open');
      btn.classList.remove('open');
    } else {
      menu.classList.add('open');
      btn.classList.add('open');
    }
  };

  (function () {
    var btn  = document.getElementById('start-btn');
    var menu = document.getElementById('start-menu');
    
    if (!btn || !menu) return;

    function closeMenu() {
      menu.classList.remove('open');
      btn.classList.remove('open');
    }

    // Capture-phase delegated handler — most-robust click wiring
    document.addEventListener('click', function (e) {
      var hit = e.target.closest && e.target.closest('#start-btn');
      if (!hit) return;
      e.stopPropagation();
      window.toggleStartMenu();
    }, true);

    // Click anywhere else closes the menu
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target) && !btn.contains(e.target)) closeMenu();
    });
    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    function showStub(title, body) {
      var x = window.innerWidth / 2 - 170;
      var y = window.innerHeight / 2 - 90;
      var win = popupShell(title, 320);
      win.style.left = x + 'px';
      win.style.top  = y + 'px';
      win.innerHTML +=
        '<div class="window-body" style="padding:16px;font-size:12px;line-height:1.5;">' +
          body +
        '</div>' +
        '<div style="text-align:right;padding:0 14px 14px;">' +
          '<button data-action="close" style="min-width:72px;padding:5px 14px;font-size:11px;">OK</button>' +
        '</div>';
      document.getElementById('scene-desktop').appendChild(win);
      makeDraggable(win);
      bringToFront(win);
      wirePopupClose(win);
    }

    var routes = {
      'shop-all':    function () { openCollection('all');    },
      'tops':        function () { openCollection('tees');   },
      'bottoms':     function () { showStub('Bottoms',     'No drops in this category yet.<br>Check back soon.'); },
      'accessories': function () { showStub('Accessories', 'No drops in this category yet.<br>Check back soon.'); },
      'help':        function () { openSupportChat(); },
      'bg':          function () { openDisplayProperties(); }
    };

    menu.querySelectorAll('.start-menu-item').forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.stopPropagation();
        closeMenu();
        var key = item.dataset.menu;
        var fn = routes[key];
        
        if (fn) {
          try {
            fn();
          } catch (err) {
            
          }
        }
      });
    });
  })();


// ============ SHOPIFY PORT BRIDGE ============
(function () {
  if (window.EFFN_COLLECTIONS_SHOPIFY) {
    Object.keys(window.EFFN_COLLECTIONS_SHOPIFY).forEach(function (key) {
      var collection = window.EFFN_COLLECTIONS_SHOPIFY[key];
      if (collection && Array.isArray(collection.items)) {
        COLLECTIONS[key] = collection;
      }
    });
  }

  function catalogMatch(product) {
    var name = product && product.name;
    if (!name) return product;
    for (var key in COLLECTIONS) {
      var items = COLLECTIONS[key] && COLLECTIONS[key].items || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].name === name) return Object.assign({}, items[i], product);
      }
    }
    return product;
  }

  var previewAddToCart = addToCart;
  openSizeDialog = function (product) {
    product = catalogMatch(product);
    var variants = product.variants || [];
    var selectedVariant = variants.find(function (v) { return v.available; }) || variants[0] || null;
    if (isDefaultOnlyProduct(product)) {
      product.variantId = selectedVariant ? selectedVariant.id : product.variantId;
      product.price = selectedVariant && selectedVariant.price ? cleanMoney(selectedVariant.price) : cleanMoney(product.price || '');
      previewAddToCart(product, 'Default', 1);
      return;
    }
    var sizes = variants.length ? variants.map(function (v) { return v.title; }) : sizesForProduct(product.name);

    var overlay = document.createElement('div');
    overlay.className = 'size-dialog-overlay';
    overlay.innerHTML =
      '<div class="window size-dialog">' +
        '<div class="title-bar">' +
          '<div class="title-bar-text">Add to cart</div>' +
          '<div class="title-bar-controls">' +
            '<button aria-label="Close" data-cancel></button>' +
          '</div>' +
        '</div>' +
        '<div class="window-body">' +
          '<div class="size-dialog-product">' +
            '<div class="ph">' + renderProductVisual(product) + '</div>' +
            '<div class="size-dialog-product-info">' +
              '<p class="name">' + product.name + '</p>' +
              '<p class="price">' + product.price + '</p>' +
            '</div>' +
          '</div>' +
          '<p class="size-dialog-label">Select size</p>' +
          '<div class="size-dialog-options" data-sizes>' +
            sizes.map(function (s, idx) {
              var variant = variants[idx];
              if (String(s || '').toLowerCase() === 'default title') return '';
              var available = variant ? variant.available : true;
              var selected = variant ? selectedVariant && String(variant.id) === String(selectedVariant.id) : sizes.length === 1;
              return '<button data-size="' + s + '" data-variant-id="' + (variant ? variant.id : '') + '"' +
                (selected ? ' class="selected"' : '') +
                (available ? '' : ' disabled') + '>' + s + (available ? '' : ' — sold out') + '</button>';
            }).join('') +
          '</div>' +
          '<div class="size-dialog-actions">' +
            '<button data-cancel>Cancel</button>' +
            '<button data-confirm' + (selectedVariant || !variants.length ? '' : ' disabled') + '>Add to cart</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    var confirmBtn = overlay.querySelector('[data-confirm]');
    var selectedSize = selectedVariant ? selectedVariant.title : (sizes.length === 1 ? sizes[0] : null);
    var selectedVariantId = selectedVariant ? selectedVariant.id : product.variantId;

    overlay.querySelectorAll('[data-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        overlay.querySelectorAll('[data-size]').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        selectedSize = btn.dataset.size;
        selectedVariantId = btn.dataset.variantId || product.variantId;
        if (confirmBtn) confirmBtn.disabled = false;
      });
    });
    overlay.querySelectorAll('[data-cancel]').forEach(function (b) { b.addEventListener('click', function () { overlay.remove(); }); });
    confirmBtn.addEventListener('click', function () {
      if (!selectedSize) return;
      product.variantId = selectedVariantId;
      previewAddToCart(product, selectedSize);
      overlay.remove();
    });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });
  };

  var originalGoTo = goTo;
  goTo = function (name) {
    if (name === 'boot' || name === 'login' || name === 'desktop') localStorage.setItem('effn_mode', 'win98');
    originalGoTo(name);
  };
  window.goTo = goTo;

  var params = new URLSearchParams(window.location.search);
  if (params.get('mode') === 'win98') localStorage.setItem('effn_mode', 'win98');

  if (document.getElementById('scene-desktop') && document.getElementById('scene-boot') && document.getElementById('scene-login')) {
    if (localStorage.getItem('effn_mode') === 'win98' && sessionStorage.getItem('effn_seen_login') === '1') {
      goTo('desktop');
    } else {
      goTo(effnCfg('bootEnabled', true) === false ? 'login' : 'boot');
      sessionStorage.setItem('effn_seen_login', '1');
    }
  }
})();
